/* eslint-disable eqeqeq */
import {
  useState,
  useEffect,
  useCallback,
  useRef,
  useLayoutEffect,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Button, CircularProgress } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  CmpButton,
  CmpButtonKIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import {
  WmsSalesInvoiceRo,
  KernCAConfig,
  RoundingDigitRo,
  vRdxUserInfo,
} from "../../Redux/roStore";
import { confirmAlert } from "react-confirm-alert"; // Import
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  fAlertToast,
  fCalculate_Detail,
  fKeyTabInput,
  fcovertToNumber,
  GetGitterColumns,
  FShortCutKey,
  GetAccountPostingDetail,
  GetLinkDocument,
  fCheck_Doc_Rights_001,
  userBasedHideField,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import WmsSalesFooter from "./processComponent/WmsSalesFooter";

import {
  sTrnTyp,
  fRightClick,
  fLeftClick,
  Get_GCSearchBtn,
  getTransItemStockUOM,
} from "./WmsSalesInvoiceAction";
import {
  Wms_Invoice_HeadObject_Set,
  Wms_Invoice_HeadObject_New_Set,
  Wms_Invoice_HeadObject_A_VocNo_Set,
  Wms_Invoice_HeadObject_DrCrAccount_Set,
  Wms_Invoice_HeadObject_A_DocStatus_Set,
  Wms_Invoice_HeadObject_SalesGroup_SalesMan_Set,
  Wms_Invoice_HeadObject_A_Party_Set,
  WmsInvoice_HeadObject_Init,
  Wms_Invoice_HeadPosMode_Set,
  Wms_Invoice_HeadObject_A_Type_Set,
} from "./SliceWmsInvoice";
import "./WMSSalesInvoice.css";
import GCSearchBtn from "../../Component/Common/ReuseableComponent/GCSearchBtn";
import GCDiscountPercentage from "../../Component/Common/ReuseableComponent/GCDiscountPercentage";
import GCVanMaster from "../../Component/Common/ReuseableComponent/GCVanMaster";
import GCSimpleSearch from "../../Component/Common/ReuseableComponent/GCSimpleSearch";
import GCEmployee from "../../Component/Common/ReuseableComponent/GCEmployee";
import GCReverse from "../../Component/Common/ReuseableComponent/GCReverse";
import {
  GetSearchItem,
  sItemSearchData,
  sCustomerSearchData,
  GetSearchCustomer,
  fDefaultPayload,
  GetOSAmount,
  GetAttributes,
} from "./WmsSalesInvoiceAction";
import { fExecuteAPI } from "../../Server/Apis";
import {
  ApproveWMINV08,
  deleteDetailWMINV08,
  deleteHeadWMINV08,
  ReverseWMINV08,
  SaveWMINV08,
  SubKonten_Search_Full_V3Api,
  validationWMINV08,
} from "../../Server/ApiV2";
import GCAccountDetail from "../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";
import GCHead from "./processComponent/GCHead";
import GCContent from "./processComponent/GCContent";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";
import { DetailTblCard } from "./processComponent/DetailTblCard";

export default function WmsSalesInvoiceV1() {
  const { roundingDigit } = RoundingDigitRo();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const RefNoFocusOnLoad = useRef(null);
  const ClickNewFocsItem = useRef(null);
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  // eslint-disable-next-line no-unused-vars
  const sEnterKeyObj = {
    key: "Enter",
  };

  const vRdxWmsInvoiceHead = useSelector(
    (state) => state.SliceWmsInvoice.value.HeadObject
  );
  const vRdxWmsInvoicePosMode = useSelector(
    (state) => state.SliceWmsInvoice.value.HeadPosMode
  );
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const vRdxGRNtax1 = useSelector((state) => state.SliceGRN.value.tax.tax1);
  const vRdxGRNtax2 = useSelector((state) => state.SliceGRN.value.tax.tax2);
  const vRdxPricelevel = useSelector(
    (state) => state.SliceGRN.value.priceLevel
  );
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const vRdxDBBranchList = useSelector(
    (state) => state.SliceDB.value.DBBranchList
  );

  // const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  // const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const [sDocLoading, setDocLoading] = useState([]); // GrnType Select
  const [sDefaultPartyObj, setDefaultPartyObj] = useState({
    A_Party: "",
    A_PartyName: "",
  }); // DefaultParty Select
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });
  const [sCurrency, setCurrency] = useState([]); //Currency Select
  const [sSalesman, setSalesman] = useState([]); //sSalesman Select
  const [sSalesGroup, setSalesGroup] = useState([]); //sSalesGroup Select
  const [sGCSeachSalesGroupSearch, setGCSeachSalesGroupSearch] = useState([]); //GCSeachSalesGroupSearch Select
  const [sSupervisorSlabs, setSupervisorSlabs] = useState([]); //SupervisorSlabs Select
  const [sOtherSlabs, setOtherSlabs] = useState([]); //OtherSlabs Select
  const [sIncentiveGroups, SetIncentiveGroups] = useState([]); //IncentiveGroups Select
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);
  const [sLoading, setLoading] = useState(false);
  const [sToggleGrid, setToggleGrid] = useState(false);
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value
  // const [sOnGridClick, setOnGridClick] = useState(false);
  const [sRevNarr, setRevNarr] = useState(""); //for Reverse API
  const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];
  const [sInstTypeArr, setInstTypegArr] = useState([
    "Walk-In",
    "Distribution",
    "Instant Picking",
  ]);
  const [sNarrArr, setNarrArr] = useState([]);
  const sPayModeArr = ["CREDIT", "CASH", "CC"];
  const [sPaymodeEnable, setPaymodeEnable] = useState(true); //to set paymode enable or disable
  const [sOsAmount, setOsAmount] = useState({
    NetOsAmt: 0,
    PDCAmt: 0,
    BalanceOsAmt: 0,
  }); //to set paymode enable or disable

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });
  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const [sBufferObj, setBufferObj] = useState({
    B_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
    B_VocNo: vRdxWmsInvoiceHead.A_VocNo,
    B_Srno: 0,
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: (0).toFixed(roundingDigit),
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: "",
    B_BaseQty: (0).toFixed(roundingDigit),
    B_URateFc: (0).toFixed(roundingDigit),
    B_URateLc: (0).toFixed(roundingDigit),
    B_GrossAmt: (0).toFixed(roundingDigit),
    B_LDiscPerc: (0).toFixed(roundingDigit),
    B_LDiscAmt: (0).toFixed(roundingDigit),
    B_TDiscPerc: (0).toFixed(roundingDigit),
    B_TDiscAmt: (0).toFixed(roundingDigit),
    B_FocFlag: "N",
    B_AprmtFlag: "",
    B_FocAmt: (0).toFixed(roundingDigit),
    B_NetAmt: (0).toFixed(roundingDigit), //taxable Amt
    B_TaxDept: vRdxGRNtax1[0].UId,
    B_TaxPerc: vRdxGRNtax1[0].Perc,
    B_TaxAmt: (0).toFixed(roundingDigit),
    B_TaxDept2: vRdxGRNtax2[0].UId,
    B_TaxPerc2: vRdxGRNtax2[0].Perc,
    B_TaxAmt2: (0).toFixed(roundingDigit),
    B_LC: (0).toFixed(roundingDigit),
    B_Charges1: (0).toFixed(roundingDigit),
    B_Charges2: (0).toFixed(roundingDigit),
    B_Rounding: (0).toFixed(roundingDigit),
    B_LandVal: (0).toFixed(roundingDigit),
    B_RSP: (0).toFixed(roundingDigit),
    B_RefDocTyp: "",
    B_RefDocNo: "",
    B_RefNo1: "",
    B_RefNo2: "",
    B_RefNo3: "",
    B_RefNo4: (0).toFixed(roundingDigit),
    B_RefNo5: (0).toFixed(roundingDigit),
    B_RefNo6: (0).toFixed(roundingDigit),
    B_URate_Fixed: (0).toFixed(roundingDigit),
    B_CostPr: (0).toFixed(roundingDigit),
    B_ExciseTaxPerc: (0).toFixed(roundingDigit),
    B_ExciseTaxAmt: (0).toFixed(roundingDigit),
    B_ExciseTaxNetAmt: (0).toFixed(roundingDigit),
    B_IncGroup: "",
    B_SuprvPerc: (0).toFixed(roundingDigit),
    B_OthersPerc: (0).toFixed(roundingDigit),
    B_SLANSuprv: "",
    B_SlabAmtSuprv: (0).toFixed(roundingDigit),
    B_SLANOther: "",
    B_SlabAmtOther: (0).toFixed(roundingDigit),
    AddCess: (0).toFixed(roundingDigit),
    B_NetAddCess: (0).toFixed(roundingDigit),
    TaxableAmt: "",
    Narration: "",
    Itm_DefUnit: "",
    Itm_SalUnit: "",
  });

  const [sFooterObj, setFooterObj] = useState({
    A_GrossAmt: (0).toFixed(roundingDigit),
    A_TDiscAmt: (0).toFixed(roundingDigit),
    A_LDiscAmt: (0).toFixed(roundingDigit),
    A_FocAmt: (0).toFixed(roundingDigit),
    A_NetExcise: (0).toFixed(roundingDigit),
    A_Tax: (0).toFixed(roundingDigit),
    A_Tax2: (0).toFixed(roundingDigit),
    A_AddCess: (0).toFixed(roundingDigit),
    A_LandVal: (0).toFixed(roundingDigit),
  });

  const [sDiscPerModelObj, setDiscPerModelObj] = useState({
    A_TDiscAmt: sFooterObj.A_TDiscAmt,
    A_DiscPerc: vRdxWmsInvoiceHead.A_DiscPerc,
  });

  let vBufferObjInit = {
    B_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
    B_VocNo: vRdxWmsInvoiceHead.A_VocNo === "" ? 0 : vRdxWmsInvoiceHead.A_VocNo,
    B_Srno: 0,
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: 0,
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: "",
    B_BaseQty: (0).toFixed(roundingDigit),
    B_URateFc: (0).toFixed(4),
    B_URateLc: (0).toFixed(4),
    B_GrossAmt: (0).toFixed(roundingDigit),
    B_LDiscPerc: (0).toFixed(roundingDigit),
    B_LDiscAmt: (0).toFixed(roundingDigit),
    B_TDiscPerc: (0).toFixed(roundingDigit),
    B_TDiscAmt: (0).toFixed(roundingDigit),
    B_FocFlag: "N",
    B_AprmtFlag: "",
    B_FocAmt: (0).toFixed(roundingDigit),
    B_NetAmt: (0).toFixed(roundingDigit), //taxable Amt
    B_TaxDept: vRdxGRNtax1[0].UId,
    B_TaxPerc: vRdxGRNtax1[0].Perc,
    B_TaxAmt: (0).toFixed(roundingDigit),
    B_TaxDept2: vRdxGRNtax2[0].UId,
    B_TaxPerc2: vRdxGRNtax2[0].Perc,
    B_TaxAmt2: (0).toFixed(roundingDigit),
    B_LC: (0).toFixed(roundingDigit),
    B_Charges1: (0).toFixed(roundingDigit),
    B_Charges2: (0).toFixed(roundingDigit),
    B_Rounding: (0).toFixed(roundingDigit),
    B_LandVal: (0).toFixed(roundingDigit),
    B_RSP: (0).toFixed(roundingDigit),
    B_RefDocTyp: "",
    B_RefDocNo: "",
    B_RefNo1: "",
    B_RefNo2: "",
    B_RefNo3: "",
    B_RefNo4: (0).toFixed(roundingDigit),
    B_RefNo5: (0).toFixed(roundingDigit),
    B_RefNo6: (0).toFixed(roundingDigit),
    B_URate_Fixed: (0).toFixed(roundingDigit),
    B_CostPr: (0).toFixed(roundingDigit),
    B_ExciseTaxPerc: (0).toFixed(roundingDigit),
    B_ExciseTaxAmt: (0).toFixed(roundingDigit),
    B_ExciseTaxNetAmt: (0).toFixed(roundingDigit),
    B_IncGroup: "",
    B_SuprvPerc: (0).toFixed(roundingDigit),
    B_OthersPerc: (0).toFixed(roundingDigit),
    B_SLANSuprv: sSupervisorSlabs[0],
    B_SlabAmtSuprv: (0).toFixed(roundingDigit),
    B_SLANOther: sOtherSlabs[0],
    B_SlabAmtOther: (0).toFixed(roundingDigit),
    AddCess: (0).toFixed(roundingDigit),
    B_NetAddCess: (0).toFixed(roundingDigit),
    TaxableAmt: "",
    Narration: "", //FIELD8
    Itm_DefUnit: "",
    Itm_SalUnit: "",
  };
  const [sItemStock, setItemStock] = useState({
    rpStock: "",
    wmsStock: "",
    msp: "",
    costpr: "",
    OpenBinStock: "",
  });

  const [sErrorMsg, setErrorMsg] = useState({
    A_VocTyp: "",
    A_VocNo: "",
    A_PostDt: "",
    A_RefNo: "",
    A_RefDt: "",
    A_Loc: "",
    A_PayMode: "",
    A_Curr: "",
    A_ExRate: "",
    A_Party: "",
    A_PartyName: "",
    A_CUSTFIELD3: "",
    A_Type: "",
    A_Taxable: "",
    A_Buyer: "",
    A_Narr: "",
    A_Rounding: "",
    A_DiscPerc: "",
    A_CUSTFIELD2: "",
    A_CrAc: "",
    A_CrAcName: "",
    A_DrAc: "",
    A_DrAcName: "",
    A_INV_TYPE: "",
  });

  const [sErrorMsgDetail, setErrorMsgDetail] = useState({
    B_Srno: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: "",
    B_Unit: "",
    B_BaseQty: "",
    B_URateFc: "",
    B_URateLc: "",
    B_GrossAmt: "",
    B_LDiscPerc: "",
    B_LDiscAmt: "",
    B_TDiscPerc: "",
    B_TDiscAmt: "",
    B_FocFlag: "",
    B_FocAmt: "",
    B_ExciseTaxAmt: "",
    B_ExciseTaxNetAmt: "",
    B_NetAmt: "",
    B_TaxDept: "",
    B_TaxPerc: "",
    B_TaxAmt: "",
    B_TaxDept2: "",
    B_TaxPerc2: "",
    B_TaxAmt2: "",
    AddCess: "",
    B_NetAddCess: "",
    B_LandVal: "",
    Narration: "",
    B_IncGroup: "",
    B_SuprvPerc: "",
    B_OthersPerc: "",
    B_SLANSuprv: "",
    B_SlabAmtSuprv: "",
    B_SLANOther: "",
    B_SlabAmtOther: "",
  });
  const [sErrorMsgDiscountModal, setErrorMsgDiscountModal] = useState({
    A_TDiscAmt: "",
    A_DiscPerc: "",
  });

  let vErrorMessageInit = {
    A_VocTyp: "",
    A_VocNo: "",
    A_PostDt: "",
    A_RefNo: "",
    A_RefDt: "",
    A_Loc: "",
    A_PayMode: "",
    A_Curr: "",
    A_ExRate: "",
    A_Party: "",
    A_PartyName: "",
    A_CUSTFIELD3: "",
    A_Type: "",
    A_Taxable: "",
    A_Buyer: "",
    A_Narr: "",
    A_Rounding: "",
    A_DiscPerc: "",
    A_CUSTFIELD2: "",
    A_CrAc: "",
    A_CrAcName: "",
    A_DrAc: "",
    A_DrAcName: "",
    A_INV_TYPE: "",
  };
  let vErrorMessageDetailInit = {
    B_Srno: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: "",
    B_Unit: "",
    B_BaseQty: "",
    B_URateFc: "",
    B_URateLc: "",
    B_GrossAmt: "",
    B_LDiscPerc: "",
    B_LDiscAmt: "",
    B_TDiscPerc: "",
    B_TDiscAmt: "",
    B_FocFlag: "",
    B_FocAmt: "",
    B_ExciseTaxAmt: "",
    B_ExciseTaxNetAmt: "",
    B_NetAmt: "",
    B_TaxDept: "",
    B_TaxPerc: "",
    B_TaxAmt: "",
    B_TaxDept2: "",
    B_TaxPerc2: "",
    B_TaxAmt2: "",
    AddCess: "",
    B_NetAddCess: "",
    B_LandVal: "",
    Narration: "",
    B_IncGroup: "",
    B_SuprvPerc: "",
    B_OthersPerc: "",
    B_SLANSuprv: "",
    B_SlabAmtSuprv: "",
    B_SLANOther: "",
    B_SlabAmtOther: "",
  };
  let vErrorMsgDiscountModalInit = {
    A_TDiscAmt: "",
    A_DiscPerc: "",
  };
  const [sItemSearchModalObj, setItemSearchModalObj] = useState({
    vAnydata: sBufferObj.B_ItmName,
    vItemNameCode: "",
    vItemNameName: "",
    vItemNameBarcode: "",
    vItemNameGroupCode: "ALL",
    vItemNameRefNo: "",
    vItemNameNameFL: "",
    vItemNameCostPrice: "",
    vItemNameRSP: "",
  });

  const [sSearchLoactionArr, setSearchLoactionArr] = useState(vRdxuserLoc);
  const addAllInSearchLoactionArr = () => {
    const newObj = {
      UID: "All",
      Name1: "All",
      BranchCode: "All",
      BranchName: "All",
    };

    // Use the spread operator to create a new array with the new object added at the beginning
    setSearchLoactionArr([newObj, ...sSearchLoactionArr]);
  };
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: "",
    Loc: "All",
    RefNo: "",
    SalesGroup: "",
    Party: "All",
    PartyName: "All",
  });
  const [sItemUnit, setItemUnit] = useState([]);
  const [sInvoiceSalesModal, setInvoiceSalesModal] = useState(false);
  const [sSearchModal, setSearchModal] = useState(false);
  const [sOpenModalName, setOpenModalName] = useState("");
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sGridSalesHistoryRowData, setGridSalesHistoryRowData] = useState([]);
  const [sDetailGridData, setDetailGridData] = useState([]);
  const [sSearchGridData, setSearchGridData] = useState([]); //for item search
  const [sNarrationSearchGridFullData, setNarrationSearchGridFullData] =
    useState([]); //for Narration full data
  const [sNarrationSearchGridData, setNarrationSearchGridData] = useState([]); //for Narration search
  const [sCustSearchGridData, setCustSearchGridData] = useState([]); //for ARR FOR CUSTOMER SEARCH
  const [sTitle, setTitle] = useState("");
  const [sDiscountPercentageModal, setDiscountPercentageModal] =
    useState(false);
  const [sCustomerModelObj, setCustomerModelObj] = useState({
    AnyData: "",
    Name: "",
    Code: "",
  });
  const [sReverseTransactionModal, setReverseTransactionModal] =
    useState(false);
  const fOpenReverseTransactionModal = () => {
    setReverseTransactionModal(true);
  };
  const fCloseReverseTransactionModal = (e) => {
    setReverseTransactionModal(false);
  };
  const fonChangeInputCustomerModal = (event) => {
    setCustomerModelObj({
      ...sCustomerModelObj,
      [event.target.name]: event.target.value,
    });
  };
  const fOpenDiscountPercentageModal = (e) => {
    setDiscountPercentageModal(true);
    setDiscPerModelObj((obj) => ({
      ...obj,
      A_TDiscAmt: Number(sFooterObj.A_TDiscAmt).toFixed(roundingDigit),
      A_DiscPerc: Number(vRdxWmsInvoiceHead.A_DiscPerc).toFixed(roundingDigit),
    }));
  };

  const fClearSimpleSearch = () => {
    setCustomerModelObj({
      ...sCustomerModelObj,
      AnyData: "",
      Name: "",
      Code: "",
    });
    setHeaderSearchResultArr([]);
  };

  const fCloseDiscountPercentageModal = (e) => {
    setDiscountPercentageModal(false);
    setErrorMsgDiscountModal((obj) => ({
      ...obj,
      A_TDiscAmt: "",
      A_DiscPerc: "",
    }));
  };

  const [sAuditModal, setAuditModal] = useState(false);
  const fOpenAuditModal = (e) => {
    setAuditModal(true);
  };

  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      let vrdl = vRdxDBBranchList.find((obj) => {
        return obj.LocName[0] == vRdxWmsInvoiceHead.A_Loc;
      });
      let webReport = vRdxDBKernObj?.WEB_REPORT_BASE_URL;
      if (vrdl?.InvoiceFile != "") {
        let urlPrint =
          webReport?.Val +
          "sales?trntyp=" +
          sTrnTyp +
          "&voctyp=" +
          vRdxWmsInvoiceHead.A_VocTyp +
          "&vocno=" +
          vRdxWmsInvoiceHead.A_VocNo +
          "&prnTyp=" +
          xPrnTyp +
          "&amountInWord=''" +
          "&rdl=" +
          vrdl?.InvoiceFile;
        setWebReportUrlModal(urlPrint);
        fWebReport();
      } else {
        let urlPrint =
          webReport?.Val +
          "sales?trntyp=" +
          sTrnTyp +
          "&voctyp=" +
          vRdxWmsInvoiceHead.A_VocTyp +
          "&vocno=" +
          vRdxWmsInvoiceHead.A_VocNo +
          "&prnTyp=" +
          xPrnTyp +
          "&amountInWord=''";
        setWebReportUrlModal(urlPrint);
        fWebReport();
      }
    },
    [
      vRdxWmsInvoiceHead.A_Loc,
      vRdxWmsInvoiceHead.A_VocNo,
      vRdxWmsInvoiceHead.A_VocTyp,
      vRdxDBKernObj,
      vRdxDBBranchList,
    ]
  );

  //Sales Group Modal
  const [sSaleGroupTypeArr, setSaleGroupTypegArr] = useState([
    { UId: "Supervisor", Name: "Supervisor" },
    { UId: "Driver", Name: "Driver" },
    { UId: "Salesman", Name: "Salesman" },
    { UId: "Helper", Name: "Helper" },
  ]);
  const [sSalesGroupModal, setSalesGroupModal] = useState(false);
  const [sSalesGroupModalObj, setSalesGroupModalObj] = useState({
    Group: "",
    SrNo: "0",
    Type: sSaleGroupTypeArr[0].UId,
    EmployeeID: "",
    EmployeeName: "",
    // Branch: "1",
    Active: "Y",
    // ImageUrl: "",
  });
  var vErrorMsgVanMasterInit = {
    SrNo: "",
    Type: "",
    EmployeeID: "",
    EmployeeName: "",
    Active: "",
  };
  const [sErrorMsgVanMaster, setErrorMsgVanMaster] = useState({
    SrNo: "",
    Type: "",
    EmployeeID: "",
    EmployeeName: "",
    Active: "",
  });

  const [sSalesGroupModalArr, setSalesGroupModalArr] = useState([]);
  const fGetVanMasterSearchEnter = (e) => {
    if (e.key == "Backspace") {
      setSalesGroupModalObj((obj) => ({
        ...obj,
        EmployeeID: "",
      }));
    }
    if (
      e._reactName === "onClick" ||
      (e.key == "Enter" && e.target.name == "EmployeeName")
    ) {
      fOpenSalesGroupEmployeeModal();
      setSalesGroupEmployeeModelObj((obj) => ({
        ...obj,
        AnyData: sSalesGroupModalObj.EmployeeName,
      }));
      if (sSalesGroupModalObj.EmployeeName !== "") {
        GetEmployeeSearchVanGroup(sSalesGroupModalObj.EmployeeName);
      }
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (Number(selectedLength) === 0) {
          let tabel = document.getElementById("table-main-grid-5");
          // vIsDownKeyPressedSimpleSearch = true;
          // tabel?.getElementsByClassName('MuiDataGrid-row')[0].firstChild.click();
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 100);
    }
  };

  //GCSimpleSearch Sales Group Modal
  const fVanMasterRowClick = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      SrNo: e?.row?.Srno,
      Type: e?.row?.Typ,
      EmployeeID: e?.row?.EMPID,
      EmployeeName: e?.row?.EMPNAME,
      Active: e?.row?.Active,
    }));
  };

  // Sales Group Modal
  const fVanMasterRowCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      setSalesGroupModalObj((obj) => ({
        ...obj,
        SrNo: newSelectionModel?.row?.Srno,
        Type: newSelectionModel?.row?.Typ,
        EmployeeID: newSelectionModel?.row?.EMPID,
        EmployeeName: newSelectionModel?.row?.EMPNAME,
        Active: newSelectionModel?.row?.Active,
      }));
    }
  };
  const fOnVanMasterSrNoModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnVanMasterTypModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnVanMasterActiveModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.checked ? "Y" : "N",
    }));
  };
  const fOnVanMasterEmployeeModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length <
        sSalesGroupModalObj.EmployeeName.toString().length &&
      vMediaQuery &&
      e.target.name === "EmployeeName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      fGetVanMasterSearchEnter(vBackspaceObj);
    }
  };

  const fOpenSalesGroupModal = async () => {
    // setSalesGroupModal(true);
    if (
      vRdxWmsInvoiceHead.A_VocNo !== 0 &&
      vRdxWmsInvoiceHead.A_CUSTFIELD2 !== ""
    ) {
      if (vRdxWmsInvoiceHead.A_DocStat == "ENTER") {
        let vFillVanMaster = await GetFillVanMaster();
        if (vFillVanMaster.toUpperCase() === "SUCCESS") {
          setSalesGroupModal(true);
          GetVANMastItemList();
          setSalesGroupModalObj((obj) => ({
            ...obj,
            Group: vRdxWmsInvoiceHead.A_CUSTFIELD2,
          }));
          setTimeout(() => {
            document.getElementsByName("EmployeeName")[0]?.focus();
          }, 100);
        } else {
          fAlertToast("FAILED", "FillVanMaster not Saved ");
        }
      } else if (vRdxWmsInvoiceHead.A_DocStat == "POST") {
        setSalesGroupModal(true);
        GetVANMastItemList();
        setSalesGroupModalObj((obj) => ({
          ...obj,
          Group: vRdxWmsInvoiceHead.A_CUSTFIELD2,
        }));
        setTimeout(() => {
          document.getElementsByName("EmployeeName")[0]?.focus();
        }, 100);
      }
    } else {
      fAlertToast("FAILED", "VocNo and Sales Group shouldn't be Empty ");
    }
  };

  const fCloseSalesGroupModal = (e) => {
    setSalesGroupModal(false);
    fClearSalesGroupSearch();
  };

  const fClearSalesGroupSearch = () => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      Group: vRdxWmsInvoiceHead.A_CUSTFIELD2,
      SrNo: "0",
      Type: sSaleGroupTypeArr[0].UId,
      EmployeeID: "",
      EmployeeName: "",
      // Branch: "1",
      Active: "Y",
      // ImageUrl: "",
    }));
    setSalesGroupModalArr([]);
    setErrorMsgVanMaster(vErrorMsgVanMasterInit);
  };
  const fNewSaleGroupModal = () => {
    fClearSalesGroupSearch();
    GetVANMastItemList();
  };
  const fValidationVanMasterSalesGroup = () => {
    let iRes = true;
    if (sSalesGroupModalObj.SrNo === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        SrNo: "SrNo should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.Type === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        Type: "Type should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.EmployeeID === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        EmployeeID: "EmployeeID should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.EmployeeName === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        EmployeeID: "EmployeeName should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.Active === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        Active: "Active should not be empty",
      }));
      iRes = false;
    }
    return iRes;
  };
  const fSaveSaleGroupModal = async () => {
    setErrorMsgVanMaster(vErrorMsgVanMasterInit);
    if (fValidationVanMasterSalesGroup()) {
      GetVANMastItemSave();
    }
  };
  const fDeleteSaleGroupModal = async () => {
    if (sSalesGroupModalObj.SrNo > 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              GetVANMastItemDelete();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }

    // GetVANMastItemDelete();
  };

  // Employee Modal
  const [sSalesGroupEmployeeModal, setSalesGroupEmployeeModal] =
    useState(false);
  const [sEmployeeSearchResultArr, setEmployeeSearchResultArr] = useState([]);
  const [sSalesGroupEmployeeModelObj, setSalesGroupEmployeeModelObj] = useState(
    {
      AnyData: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
    }
  );
  const fOpenSalesGroupEmployeeModal = () => {
    fClearEmployeeSearch();
    setTimeout(() => {
      document.getElementsByName("AnyData")[0]?.focus();
    }, 100);
    setSalesGroupEmployeeModal(true);
  };
  const fCloseSalesGroupEmployeeModal = (e) => {
    setSalesGroupEmployeeModal(false);
    setTimeout(() => {
      document.getElementsByName("EmployeeName")[0]?.focus();
    }, 100);
  };

  //GCEmployeeSearch
  const fEmployeeSearchEnter = (e) => {
    if (e.key == "Enter") {
      GetEmployeeSearchVanGroup(sSalesGroupEmployeeModelObj.AnyData);
    }

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (Number(selectedLength) === 0) {
          let tabel = document.getElementById("table-main-grid-6");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild.focus();
        }
      }, 200);
    }
  };
  const fonChangeInputEmployeeModal = (event) => {
    setSalesGroupEmployeeModelObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };
  //GCEmployeeSearch
  const fEmployeeRowClick = (e, x) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      EmployeeID: e?.row?.EMPID,
      EmployeeName: e?.row?.SName,
      Active: e?.row?.InActive,
    }));
    fCloseSalesGroupEmployeeModal();
  };

  //GCEmployeeSearch
  const fEmployeeRowCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      setSalesGroupModalObj((obj) => ({
        ...obj,
        EmployeeID: newSelectionModel?.row?.EMPID,
        EmployeeName: newSelectionModel?.row?.SName,
        Active: newSelectionModel?.row?.InActive,
      }));
      fCloseSalesGroupEmployeeModal();
    }
  };

  const fClearEmployeeSearch = () => {
    setSalesGroupEmployeeModelObj((obj) => ({
      ...obj,
      AnyData: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
    }));
    setEmployeeSearchResultArr([]);
  };

  //GCSimpleSearch CUSTOMER SEARCH MODAL
  const [sCustomerSearchModal, setCustomerSearchModal] = useState(false);
  const fOpenCustomerSearchModal = () => {
    setCustomerSearchModal(true);
  };
  const fCloseCustomerSearchModal = (e) => {
    setCustomerSearchModal(false);
    fClearSimpleSearch();

    setHeaderSearchResultArr([]);
    setCustomerModelObj({
      AnyData: "",
      Name: "",
      Code: "",
    });
  };
  const fCloseInvoiceSalesModal = () => {
    setInvoiceSalesModal(false);
    fClearItem();
  };

  const fOpenInvoiceSalesModal = (OpenModelName) => {
    setOpenModalName(OpenModelName);
    setInvoiceSalesModal(true);

    if (sOpenModalName === "itemSearch") {
      setItemSearchModalObj((obj) => ({
        ...obj,
        vAnydata: sBufferObj.B_ItmName != "" ? sBufferObj.B_ItmName : "",
      }));
      if (sBufferObj.B_ItmName != "") {
        GetItemSearchValue("", "openCustomer", sBufferObj.B_ItmName);
      }
    }
  };
  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: "All",
      RefNo: "",
      SalesGroup: sGCSeachSalesGroupSearch[0]?.UId,
      Party: "All",
      PartyName: "All",
    });
    setGridSearchHeadRowData([]);
  };

  const fSearch = async () => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModal(true);
    document.getElementById("BtnSearch")?.blur();
    // SALESGROUPSSEARCH_GETROW
    let iSalesGroupArr = await GetSalesGroupSearch(vRdxWmsInvoiceHead.A_Loc);
    if (iSalesGroupArr.length > 0) {
      setGCSeachSalesGroupSearch(iSalesGroupArr);
      addAllInSearchLoactionArr();
      setSearchModalObj({
        ...sSearchModalObj,
        SalesGroup: iSalesGroupArr[0]?.UId,
      });
      GetSearchValue("", "APICallSalesGroupModal", iSalesGroupArr[0]?.UId);
    }
  };

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALL", vSelectedValue);
  };

  const fonChangePartyModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.AcCd == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Party: vSelectedValue.AcCd,
      PartyName: vSelectedValue.AcCd,
    }));
    GetSearchValue("", "APICallPartyModal", vSelectedValue.AcCd);
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UID == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UID,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UID);
  };

  const fonChangeSalesGroupModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      SalesGroup: vSelectedValue.UId,
    }));
    GetSearchValue("", "APICallSalesGroupModal", vSelectedValue.UId);
  };

  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };
  const fonChangeRefNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      RefNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
  };

  const fItemCodeDependency = async (
    vItemSearchFull,
    taxType = vRdxWmsInvoiceHead.A_CUSTFIELD3
  ) => {
    let iTax =
      taxType == "OTTRN002" || taxType == "OTTRN003"
        ? vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val
        : vItemSearchFull.ResultSet[0].TaxDept;

    let iCess =
      taxType == "OTTRN002" || taxType == "OTTRN003"
        ? vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
        : vItemSearchFull.ResultSet[0].TaxDept2;

    let vRdxGRNtax1arr = vRdxGRNtax1.find((obj) => {
      return obj.UId === iTax;
    });
    let vRdxGRNtax2arr = vRdxGRNtax2.find((obj) => {
      return obj.UId === iCess;
    });

    let iQty =
      vRdxWmsInvoicePosMode?.PosMode && Number(sBufferObj.B_Qty) === 0
        ? 1
        : sBufferObj.B_Qty;

    setBufferObj((object) => ({
      ...object,
      B_Itmcd: vItemSearchFull.ResultSet[0].ItmCd,
      B_ItmName: vItemSearchFull.ResultSet[0].Name2,
      B_TaxDept: vRdxGRNtax1arr.UId,
      B_TaxDept2: vRdxGRNtax2arr.UId,
      B_TaxPerc: vRdxGRNtax1arr.Perc,
      B_TaxPerc2: vRdxGRNtax2arr.Perc,
      Itm_DefUnit: vItemSearchFull.ResultSet[0].DefUnit,
      Itm_SalUnit: vItemSearchFull.ResultSet[0].SalUOM,
      B_Qty: iQty,
    }));
    const currentUnitArr = await fUnitArrApi(
      vItemSearchFull.ResultSet[0].ItmCd,
      setItemUnit
    );

    if (currentUnitArr.length > 0) {
      let iUnit = vItemSearchFull.ResultSet[0].DefUnit || "";

      if (!iUnit) {
        iUnit = vItemSearchFull.ResultSet[0].SalUOM || "";
      }

      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });

      if (!vItemUnitSet) {
        iUnit = currentUnitArr[0]?.Unit || "";

        vItemUnitSet = currentUnitArr.find((obj) => {
          return obj.Unit === iUnit;
        });
      }

      await Unit_Onchange_001(
        iUnit,
        vItemUnitSet,
        vItemSearchFull.ResultSet[0].ItmCd,
        vRdxGRNtax1arr.Perc,
        vRdxGRNtax2arr.Perc,
        iQty
      );
      if (vRdxDBKernObj?.SONAS_INVOICE?.Val === "Y") {
        const vIncentiveGroups = await GetIncentiveGroup(
          vItemSearchFull.ResultSet[0].ItmCd,
          vRdxWmsInvoiceHead.A_Loc,
          SetIncentiveGroups
        );
        if (vIncentiveGroups.length > 0) {
          setBufferObj((object) => ({
            ...object,
            B_IncGroup: vIncentiveGroups[0].UId,
            B_SuprvPerc: vIncentiveGroups[0].SuprvPerc,
            B_OthersPerc: vIncentiveGroups[0].OthersPerc,
          }));
        } else {
          setBufferObj((object) => ({
            ...object,
            B_IncGroup: "",
            B_SuprvPerc: 0,
            B_OthersPerc: 0,
          }));
        }
      }

      await ItemsAliasListSearch(
        vRdxWmsInvoiceHead.A_Loc,
        vItemSearchFull.ResultSet[0].ItmCd
      );

      GetItemNarration(
        vItemSearchFull.ResultSet[0].ItmCd,
        vRdxWmsInvoiceHead.A_Loc
      );

      setTimeout(() => {
        if (vRdxWmsInvoicePosMode?.PosMode) {
          document?.getElementsByName("B_URateFc")[0]?.focus();
        } else {
          document?.getElementsByName("B_Qty")[0]?.focus();
        }
      }, 100);
    }
  };

  const fOpenContentItemSearchModalKey = async (e, ModalName) => {
    setLoading(true);

    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sBufferObj.B_Itmcd == "") {
        const vItemSearchFull = await fExactSearchApi(sBufferObj.B_ItmName);
        if (vItemSearchFull?.ResultSet?.length > 0) {
          fItemCodeDependency(vItemSearchFull);
        } else {
          fOnClickDropdownItemSearchModalKey(e);
        }
      } else {
        setTimeout(() => {
          document.getElementsByName("B_Qty")[0]?.focus();
        }, 200);
      }
    } else if (e.key === "Backspace") {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      } = fCalculate_Detail(
        0, //sBufferObj.B_Qty,
        0, //sBufferObj.B_PackQty,
        vRdxWmsInvoiceHead.A_ExRate, //exchangeRate
        0, //sBufferObj.B_URateFc,
        0, //sBufferObj.B_LDiscPerc,
        0, //sBufferObj.B_TDiscPerc,
        "N", //sBufferObj.B_FocFlag,
        0, //sBufferObj.B_ExciseTaxAmt,
        vRdxGRNtax1[0].Perc, //tax1%
        vRdxGRNtax2[0].Perc, //tax%2
        0, //sBufferObj.B_Ad_PCRate,
        0 //Rounding
      );

      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_TaxDept: vRdxGRNtax1[0].UId,
        B_TaxDept2: vRdxGRNtax2[0].UId,
        B_TaxPerc: vRdxGRNtax1[0].Perc,
        B_TaxPerc2: vRdxGRNtax2[0].Perc,
        Itm_DefUnit: "",
        Itm_SalUnit: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
        B_URateFc: 0,
        B_LDiscPerc: 0,
        AddCess: 0,
        B_IncGroup: "",
        B_SuprvPerc: 0,
        B_SLANOther: 0,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      }));
      setItemStock((obj) => ({
        ...obj,
        rpStock: "",
        wmsStock: "",
        msp: "",
        costpr: "",
        OpenBinStock: "",
      }));
      setItemUnit([]);
      SetIncentiveGroups([]);
    }
  };

  //ItemSearch Dropdowm
  const [ToggleDropdown, setToggleDropdown] = useState(false);

  const handleClick = useCallback(() => {
    if (ToggleDropdown) {
      setToggleDropdown(false);
      setSearchGridData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setToggleDropdown(true);
    }
  }, [ToggleDropdown]);

  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxWmsInvoiceHead.A_Loc,
        setSearchGridData
      );
    }
    //   id="table-main-grid-dropdown"
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (Number(selectedLength) === 0) {
          // let tabel = document.getElementById("table-main-grid-dropdown");
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fOnClickDropdownItemSearchModalKey = async (e) => {
    setLoading(true);
    if (e.key === "Enter" || e._reactName === "onClick") {
      setItemSearchDropdownObj((obj) => ({
        ...obj,
        Data: sBufferObj.B_ItmName,
      }));
      if (sBufferObj.B_ItmName != "") {
        GetSearchItem(
          sBufferObj.B_ItmName,
          "Any",
          vRdxWmsInvoiceHead.A_Loc,
          setSearchGridData
        );
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      handleClick();
    }
  };

  const fOnChangeSelectTaxDept = (event, selectArr) => {
    // var vSelectedObj = selectArr?.find((item, index) => {
    //   const keys = Object.keys(item);
    //   return item[keys[0]] == event.target.value;
    // });
    let vSelectedObj = vRdxGRNtax1.find((obj) => {
      return obj.UId == event.target.value;
    });

    // setSelectedOption(event.target.value);
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vSelectedObj?.Perc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept: vSelectedObj?.UId,
      B_TaxPerc: vSelectedObj?.Perc,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fOnChangeSelectTaxDept2 = (event, selectArr) => {
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == event.target.value;
    });

    // setSelectedOption(event.target.value);
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0
    );
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept2: vCessGroupValue?.UId,
      B_TaxPerc2: vCessGroupValue?.Perc,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fOnChangeSelectIncGroup = (event, selectArr) => {
    var vSelectedObj = selectArr?.find((option, index) => {
      const keys = Object.keys(option);
      return option[keys[0]] == event.target.value;
    });

    const selectObj = Object.keys(vSelectedObj);
    setBufferObj((obj) => ({
      ...obj,
      B_IncGroup: vSelectedObj[selectObj[0]],
      B_SuprvPerc: vSelectedObj[selectObj[2]],
      B_OthersPerc: vSelectedObj[selectObj[3]],
    }));
  };

  const fOnChangeSelectSupervisorSlab = (event, selectArr) => {
    setBufferObj((obj) => ({
      ...obj,
      B_SLANSuprv: event.target.value,
    }));
  };

  const fOnChangeSelectOtherSlab = (event, selectArr) => {
    setBufferObj((obj) => ({
      ...obj,
      B_SLANOther: event.target.value,
    }));
  };

  const fonChangeInputUnit = async (event, selectArr) => {
    var vSelectedObj = selectArr?.find((option, index) => {
      return option.Unit == event.target.value;
    });

    await Unit_Onchange_001(vSelectedObj?.Unit, vSelectedObj);
  };
  const Unit_Onchange_001 = async (
    xUnit = "",
    xUnitObj = {},
    xItemCode = sBufferObj.B_Itmcd,
    iTax1Perc = sBufferObj.B_TaxPerc,
    iTax2Perc = sBufferObj.B_TaxPerc2,
    iQty = sBufferObj.B_Qty
  ) => {
    //by sir
    if (!!xUnitObj) {
      setBufferObj((obj) => ({
        ...obj,
        B_Unit: xUnitObj?.Unit,
        B_UnitName: xUnitObj?.Name1,
        B_PackQty: xUnitObj?.PackQty,
      }));
    }
    let vItemUnitRate = await GetUnitRateApi(xItemCode, xUnit);
    let unitRate = {
      UnitRateFC: 0,
      DiscPerc: 0,
      AddiCess: 0,
    };

    if (vItemUnitRate.length > 0) {
      unitRate.UnitRateFC = vItemUnitRate[0]?.UnitRateFC;
      unitRate.DiscPerc = vItemUnitRate[0]?.DiscPerc;
      unitRate.AddiCess = vItemUnitRate[0]?.AddiCess;
    }

    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: unitRate?.UnitRateFC,
      B_LDiscPerc: unitRate?.DiscPerc,
      AddCess: unitRate?.AddiCess,
    }));

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      iQty,
      xUnitObj.PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      unitRate?.UnitRateFC,
      unitRate?.DiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      iTax1Perc,
      iTax2Perc,
      unitRate?.AddiCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));

    GetItemStock(
      xItemCode,
      sBufferObj.B_Srno,
      vRdxWmsInvoiceHead.A_Loc,
      vRdxWmsInvoiceHead.A_INV_TYPE,
      xUnit
    );
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(roundingDigit),
      }));
      setToggleGrid(false);
    }
  };
  const fFocusShowSalesHistoryGrid = async () => {
    let vSalesHistoryArr = await GetSalesHistory(
      sBufferObj.B_Itmcd,
      sBufferObj.B_Unit,
      vRdxWmsInvoiceHead.A_Party,
      vRdxWmsInvoiceHead.A_Loc
    );
    if (vSalesHistoryArr.length > 0) {
      setToggleGrid(true);
    } else {
      setToggleGrid(false);
    }
  };

  const fonChangeInputQty = (event) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      event.target.value,
      sBufferObj.B_PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_Qty: event.target.value,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const [sNarrationToggleDropdown, setNarrationToggleDropdown] =
    useState(false);

  const fonChangeInputNarration = (event) => {
    setBufferObj((obj) => ({ ...obj, Narration: event }));
    ffilterNarrationDropDownSearch(event, sNarrationSearchGridFullData);
  };

  const fNarrationKeyEnter = (e) => {
    if (e.key == "Enter" || e._reactName === "onClick") {
      setNarrationToggleDropdown(!sNarrationToggleDropdown);
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (Number(selectedLength) === 0) {
          let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const ffilterNarrationDropDownSearch = useCallback((xValue, xArray) => {
    let vNewFilterSearchArr = xArray?.filter((obj) => {
      return (
        obj.Code.toString()
          .toLowerCase()
          .includes(xValue.toString().toLowerCase()) ||
        obj.Name.toString()
          .toLowerCase()
          .includes(xValue.toString().toLowerCase())
      );
    });
    if (xValue !== "") {
      setNarrationSearchGridData(vNewFilterSearchArr);
    } else {
      setNarrationSearchGridData(xArray);
    }
  }, []);

  const fonChangeInputSupervisorAmtSc = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };

  const fonChangeInputOtherAmtSc = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };

  const fonChangeInputItemName = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
    // ffilterDropDownSearch(event.target.value, sSearchGridDataFullData);
  };

  const fonChangeInputUnitRateFC = (event) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      event.target.value,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };
  const fGrossAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_GrossAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      // B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_URateFc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      0,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      //B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_URateFc,
    }));
  };
  const fUnitRateFCSave_onKeyUp = (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        e.key === "Enter" &&
        // !isSaved &&
        vRdxWmsInvoiceHead.A_DocStat == "ENTER"
      ) {
        document.getElementsByName("B_URateFc")[0]?.blur();
        // setIsSaved(true);
        fSave();
      }
    }, 1000);
  };
  //discAmt footer
  const fonChangeInputDiscount = (event) => {
    let vTDiscAmt =
      (fcovertToNumber(event.target.value) / 100) *
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        A_DiscPerc: fcovertToNumber(event.target.value),
      })
    );
    setDiscPerModelObj({
      ...sDiscPerModelObj,
      A_DiscPerc: fcovertToNumber(event.target.value),
      A_TDiscAmt: vTDiscAmt,
    });
  };

  //Discount% modal
  const fonChangeInputDiscountModal = (event) => {
    let vTDiscAmt =
      (fcovertToNumber(event.target.value) / 100) *
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj({
      ...sDiscPerModelObj,
      A_DiscPerc: Number(event.target.value),
      A_TDiscAmt: vTDiscAmt,
    });
  };

  //DiscountAmt modal
  const fOnChangeTDiscAmtModal = (e) => {
    let vCheckValue =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt);
    let vTDiscPer =
      (fcovertToNumber(e.target.value) * 100) /
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj({
      ...sDiscPerModelObj,
      A_DiscPerc: Number(vCheckValue) === 0 ? 0 : fcovertToNumber(vTDiscPer),
      A_TDiscAmt: Number(e.target.value),
    });
  };

  const fLandValueCalc = (event) => {
    let iLandVal =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_TDiscAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt) -
      fcovertToNumber(sFooterObj.A_FocAmt) +
      fcovertToNumber(sFooterObj.A_NetExcise) +
      fcovertToNumber(sFooterObj.A_Tax) +
      fcovertToNumber(sFooterObj.A_Tax2) +
      fcovertToNumber(sFooterObj.A_AddCess) +
      fcovertToNumber(Number(event.target.value));

    setFooterObj((obj) => ({
      ...obj,
      A_LandVal: iLandVal.toFixed(roundingDigit),
    }));
  };

  const fFooter_Rounding_OnChange = (event) => {
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        A_Rounding: event.target.value,
      })
    );
    fLandValueCalc(event);
  };

  const fFooter_Rounding_Focus = (event) => {
    if (event.target.value == 0) {
      dispatch(
        Wms_Invoice_HeadObject_Set({ ...vRdxWmsInvoiceHead, A_Rounding: "" })
      );
    }
  };

  const fFooter_Rounding_Blur = (event) => {
    const iRounding = fcovertToNumber(event.target.value);
    if (iRounding == 0) {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          A_Rounding: (0).toFixed(roundingDigit),
        })
      );

      fLandValueCalc(event);
    }
  };

  const fonChangeInputLDisc = (event) => {
    if (event.target.value <= 100) {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      } = fCalculate_Detail(
        sBufferObj.B_Qty,
        sBufferObj.B_PackQty,
        vRdxWmsInvoiceHead.A_ExRate,
        sBufferObj.B_URateFc,
        event.target.value,
        sBufferObj.B_TDiscPerc,
        sBufferObj.B_FocFlag,
        sBufferObj.B_ExciseTaxAmt,
        sBufferObj.B_TaxPerc,
        sBufferObj.B_TaxPerc2,
        sBufferObj.AddCess,
        0
      );

      setBufferObj((obj) => ({
        ...obj,
        [event.target.name]: event.target.value,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      }));
    }
  };

  const fonChangeInputLDiscAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_LDiscAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      // B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_LDiscPerc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      0,
      sBufferObj.B_GrossAmt,
      false,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_LDiscPerc,
    }));
  };

  const fonChangeInputExcise = (event) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      event.target.value,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fonChangeCheckBoxFoc = (event) => {
    let isChecked = event.target.checked ? "Y" : "N";
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      isChecked,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_FocFlag: isChecked,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const [xAuditId, setAuditId] = useState("All");

  const fClearItem = (event) => {
    setItemSearchModalObj({
      vAnydata: "",
      vItemNameCode: "",
      vItemNameName: "",
      vItemNameBarcode: "",
      vItemNameGroupCode: "ALL",
      vItemNameRefNo: "",
      vItemNameNameFL: "",
      vItemNameCostPrice: "",
      vItemNameRSP: "",
    });
    setGridSelectRowData([]);
  };

  //GCItemSearch
  const fOnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fOnRowClick(newSelectionModel);
      // document.getElementsByName("B_Qty")[0]?.focus();
    }
  };

  //GCItemSearch
  const fOnRowClick = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: e?.row?.ItmCd,
      B_ItmName: e?.row?.Name2,
    }));
    ItemsAliasListSearch(vRdxWmsInvoiceHead.A_Loc, e?.row?.ItmCd);
    if (vRdxWmsInvoiceHead.A_DocStat == "ENTER") {
      GetItemStock(
        e?.row?.ItmCd,
        sBufferObj.B_Srno,
        vRdxWmsInvoiceHead.A_Loc,
        vRdxWmsInvoiceHead.A_INV_TYPE,
        sBufferObj.B_Unit
      );
    }

    GetExactSearch(e?.row?.ItmCd);
    GetItemNarration(e?.row?.ItmCd, vRdxWmsInvoiceHead.A_Loc);
    if (!vIsDownKeyPressed) {
      setToggleDropdown(false);
      fCloseInvoiceSalesModal();
      document.getElementsByName("B_Qty")[0]?.focus();
    }
    vIsDownKeyPressed = false;
  };

  //GCSimpleSearch for customer
  const fRowClick = async (e) => {
    // let iDefaultTaxType = await GetTransTaxType(
    //   vRdxWmsInvoiceHead.A_Loc,
    //   e?.row?.AcCd
    // );
    let vDefaultTaxType = "OTTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsInvoiceHead.A_Loc,
      e?.row?.AcCd
    );
    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
    }
    //if inter.comp then tax group should be 0
    if (vDefaultTaxType == "OTTRN002" || vDefaultTaxType == "OTTRN003") {
      InterCompanyDependency(
        vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
        vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
      );
    }
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        A_Party: e?.row?.AcCd,
        A_PartyName: e?.row?.Name1,
        A_CUSTFIELD3: vDefaultTaxType,
      })
    );
    CustDependency(e?.row?.AcCd);
    if (!vIsDownKeyPressedSimpleSearch) {
      GetDefaultDrCrAccount(
        vRdxWmsInvoiceHead.A_VocTyp,
        vRdxWmsInvoiceHead.A_PayMode,
        e?.row?.AcCd
      );
      GetDefcustomersetting(e?.row?.AcCd, vRdxWmsInvoiceHead.A_Loc);
      // setHeaderSearchResultArr([]);
      setTimeout(() => {
        document.getElementsByName("B_ItmName")[0]?.focus();
      }, 500);
      fCloseCustomerSearchModal();
      setCustomerToggleDropdown(false);
    }
    vIsDownKeyPressedSimpleSearch = false;
  };

  //GCSimpleSearch for customer
  const fRowCellClick = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      // let iDefaultTaxType = await GetTransTaxType(
      //   vRdxWmsInvoiceHead.A_Loc,
      //   newSelectionModel?.row?.AcCd
      // );
      fRowClick(newSelectionModel);
    }
  };

  //GCSearchBtn
  const fTrans_Search_Grid_KeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo);
      fCloseSearchModal();
      fClearSearchModal();
    }
  };
  //GCSearchBtn
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo);
    fCloseSearchModal();
    fClearSearchModal();
  };
  //GCSearchBtn Start
  const xfGCSearchBtn_Name = (e) => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModalObj((obj) => ({
      ...obj,
      Party: "",
      PartyName: e.target.value,
    }));
  };

  const [
    sGCSearchBtn_SearchDropdownObj_SearchDropdownObj,
    setGCSearchBtn_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sGCSearchBtn_GridData, setGCSearchBtn_GridData] = useState([]);
  const [sGCSearchBtn_Toggle_ToggleDropDowm, setGCSearchBtn_ToggleDropDowm] =
    useState(false);

  const xfGCSearchBtn_Toggle = useCallback(() => {
    if (sGCSearchBtn_Toggle_ToggleDropDowm) {
      setGCSearchBtn_ToggleDropDowm(false);
      setGCSearchBtn_GridData([]);
      setGCSearchBtn_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGCSearchBtn_ToggleDropDowm(true);
    }
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  //2nd call
  const fGCSearchBtn_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGCSearchBtn_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sSearchModalObj.PartyName,
      }));
      if (sSearchModalObj.PartyName != "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "N"
        );
        setGCSearchBtn_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGCSearchBtn_Toggle();
    }
  };

  //1stcall
  const fGCSearchBtn_onKeyUp_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sSearchModalObj.Party == "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "Y"
        );
        if (vLandedCostExactSearch.length > 0) {
          setSearchModalObj((obj) => ({
            ...obj,
            Party: vLandedCostExactSearch[0].AcCd,
            PartyName: vLandedCostExactSearch[0].Name2,
          }));
          GetSearchValue(
            "",
            "APICallPartyModal",
            vLandedCostExactSearch[0].AcCd
          );
        } else {
          fGCSearchBtn_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setSearchModalObj((obj) => ({
        ...obj,
        Party: "",
      }));
    }
  };

  const xGCSearchBtn_Dropdown_onChange = (e) => {
    setGCSearchBtn_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGCSearchBtn__Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_GCSearchBtn(
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Data,
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Type
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setGCSearchBtn_GridData(vLandedCostDropdownSearch);
      } else {
        setGCSearchBtn_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document?.getElementsByClassName("Mui-selected")?.length;
        if (selectedLength === 0) {
          let tabel = document?.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGCSearchBtn_OnRowClick = (e) => {
    setSearchModalObj((obj) => ({
      ...obj,
      Party: e?.row?.AcCd,
      PartyName: e?.row?.Name2,
    }));
    GetSearchValue("", "APICallPartyModal", e?.row?.AcCd);
    xfGCSearchBtn_Toggle();
  };
  const fGCSearchBtn_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCSearchBtn_OnRowClick(newSelectionModel);
    }
  };
  //GCSearchBtn End

  //Narration input search
  const OnCellKeyNarrationDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      setBufferObj((obj) => ({
        ...obj,
        Narration: newSelectionModel?.row?.Name,
      }));
      setNarrationToggleDropdown(false);
      // document.getElementsByName("B_Qty")[0]?.focus();
    }
  };

  //Narration input search
  const OnRowNarrationClick = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Narration: e?.row?.Name,
    }));
    setNarrationToggleDropdown(false);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(vErrorMessageInit);
    setErrorMsgDetail(vErrorMessageDetailInit);
    setGridSalesHistoryRowData([]);
    setRevNarr("");
    setToggleGrid(false);
  };

  const fNew = async (VocNo = "") => {
    fClearErrorMsg();

    if (sBufferObj.B_ItmName == "") {
      let idefaultTaxTypeValue = "OTTRN001";
      let iDefaultTaxType = await GetTransTaxType(
        vRdxuserLoc[0].UID, //locaation
        ""
      );

      if (Object.keys(iDefaultTaxType[0]).length != 0) {
        idefaultTaxTypeValue = iDefaultTaxType[0]?.TaxType;
      }

      fNewHead(VocNo);
      fNewDetail(VocNo, 0, sDocLoading[0].VocTyp, idefaultTaxTypeValue);
      // if (vRdxWmsInvoiceHead.A_INV_TYPE == "Distribution") {
      //   document.getElementsByName("A_PostDt")[0]?.focus();
      // } else if (sDefaultPartyObj.A_Party == "") {
      //   document.getElementsByName("A_PartyName")[0]?.focus();
      // } else {
      //   document.getElementsByName("B_ItmName")[0]?.focus();
      // }
      if (sBufferObj.B_Itmcd == "") {
        document.getElementsByName("A_PartyName")[0]?.focus();
      } else {
        document.getElementsByName("B_ItmName")[0]?.focus();
      }
    } else {
      fNewDetail(
        vRdxWmsInvoiceHead.A_VocNo,
        vRdxWmsInvoiceHead.A_Rounding,
        vRdxWmsInvoiceHead.A_VocTyp,
        vRdxWmsInvoiceHead.A_CUSTFIELD3
      );
    }
  };

  const fNewHead = async (VocNo = "") => {
    fClearErrorMsg();
    dispatch(WmsInvoice_HeadObject_Init()); // Head Clearing
    // Setting Initial List Box 0th Object
    // let iDefaultTaxType = await GetTransTaxType(vRdxuserLoc[0].UID, "");
    let idefaultTaxTypeValue = "OTTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxuserLoc[0].UID, //locaation
      ""
    );

    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      idefaultTaxTypeValue = iDefaultTaxType[0]?.TaxType;
    }

    let iDefaultParty = await fDefParty(vRdxWmsInvoiceHead.A_INV_TYPE);
    dispatch(
      Wms_Invoice_HeadObject_New_Set({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_Loc: vRdxuserLoc[0]?.UID,
        A_Curr: sCurrency[0]?.Uid,
        A_Currname: sCurrency[0]?.Name1,
        A_ExRate: sCurrency[0]?.Rate,
        A_Type: vRdxPricelevel[0],
        A_Buyer: sSalesman[0]?.UId,
        A_CUSTFIELD2: sSalesGroup[0]?.UId,
        A_CUSTFIELD3: idefaultTaxTypeValue,
        A_Party: iDefaultParty?.A_Party,
        A_PartyName: iDefaultParty?.A_PartyName,
        A_INV_TYPE: vRdxWmsInvoiceHead?.A_INV_TYPE,
      })
    );
    // let currentPayMode = fDefaultPayload(
    //   sDocLoading[0]?.Paymode,
    //   dispatch,
    //   setPaymodeEnable
    // );
    let currentPayMode = fDefaultPayload(
      vRdxWmsInvoiceHead?.A_INV_TYPE == "Walk-In" ? "CASH" : "CREDIT",
      dispatch,
      setPaymodeEnable
    );
    GetDefaultDrCrAccount(
      sDocLoading[0].VocTyp,
      currentPayMode,
      iDefaultParty.A_Party
    );
    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    setBufferObj(vBufferObjInit);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: (0).toFixed(roundingDigit),
      A_TDiscAmt: (0).toFixed(roundingDigit),
      A_LDiscAmt: (0).toFixed(roundingDigit),
      A_FocAmt: (0).toFixed(roundingDigit),
      A_NetExcise: (0).toFixed(roundingDigit),
      A_Tax: (0).toFixed(roundingDigit),
      A_Tax2: (0).toFixed(roundingDigit),
      A_AddCess: (0).toFixed(roundingDigit),
      A_LandVal: (0).toFixed(roundingDigit),
    }));
    // RefNoFocusOnLoad.current.focus();
  };

  const fDefParty = async (xInvType) => {
    let iDefaultParty = {
      A_Party: "",
      A_PartyName: "",
    };

    //this is for focus party if party == ""
    setDefaultPartyObj((obj) => ({
      ...obj,
      A_Party: "",
      A_PartyName: "",
    }));
    if (xInvType == "Walk-In") {
      let DefaultPartyApi = await GetDefaultValue(sTrnTyp);
      if (DefaultPartyApi.length > 0) {
        let vDefaultParty = DefaultPartyApi.find((object) => {
          return object.Field === "PARTY";
        });
        if (!!vDefaultParty) {
          iDefaultParty.A_Party = vDefaultParty?.Val;
          iDefaultParty.A_PartyName = vDefaultParty?.ValName;
          setDefaultPartyObj((obj) => ({
            ...obj,
            A_Party: vDefaultParty?.Val,
            A_PartyName: vDefaultParty?.ValName,
          }));
        }
        return iDefaultParty;
      } else {
        return iDefaultParty;
      }
    } else {
      return iDefaultParty;
    }
  };
  const fNewDetail = (xVocNo, xRounding, xVocTyp, vTaxType) => {
    fClearErrorMsg();
    const { HeadObject } = WmsSalesInvoiceRo();
    setBufferObj(vBufferObjInit);
    setBufferObj((obj) => ({
      ...obj,
      B_TDiscPerc: HeadObject?.A_DiscPerc,
    }));
    let iTaxPerc = 0;
    let iCessPerc = 0;
    if (vTaxType == "OTTRN002" || vTaxType == "OTTRN003") {
      let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
        return obj.UId == vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val;
      });
      let vCessGroupValue = vRdxGRNtax2.find((obj) => {
        return obj.UId == vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val;
      });
      if (vtaxGroupValue && vCessGroupValue) {
        setBufferObj((obj) => ({
          ...obj,
          B_TaxDept: vtaxGroupValue?.UId,
          B_TaxPerc: vtaxGroupValue?.Perc,
          B_TaxDept2: vCessGroupValue?.UId,
          B_TaxPerc2: vCessGroupValue?.Perc,
        }));
      }
      iTaxPerc = vtaxGroupValue?.Perc;
      iCessPerc = vCessGroupValue?.Perc;
    }

    SetIncentiveGroups([]);
    setItemUnit([]);
    setItemStock((obj) => ({
      ...obj,
      rpStock: "",
      wmsStock: "",
      msp: "",
      costpr: "",
      OpenBinStock: "",
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      0, //sBufferObj.B_Qty,
      0, //sBufferObj.B_PackQty,
      sCurrency[0]?.Rate, //exchangeRate
      0, //sBufferObj.B_URateFc,
      0, //sBufferObj.B_LDiscPerc,
      HeadObject?.A_DiscPerc, //sBufferObj.B_TDiscPerc,
      "N", //sBufferObj.B_FocFlag,
      0, //sBufferObj.B_ExciseTaxAmt,
      vTaxType == "INTRN002" || vTaxType == "INTRN003"
        ? iTaxPerc
        : vRdxGRNtax1[0].Perc, //tax1%
      vTaxType == "INTRN002" || vTaxType == "INTRN003"
        ? iCessPerc
        : vRdxGRNtax2[0].Perc, //tax%2
      0, //sBufferObj.AddCess,
      0 //Rounding
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));

    fLoad_Grid(xVocNo, 0, xRounding, xVocTyp);

    document?.getElementsByName("B_ItmName")[0]?.focus();
  };

  const fReverse = (e) => {
    fCloseReverseTransactionModal();
    confirmAlert({
      title: "Reverse",
      message: "Are you sure to Reverse.",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => fSave(),
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => setRevNarr(""),
        },
      ],
    });
  };
  const finalSave = async (
    xSave = true,
    xDocStatus = vRdxWmsInvoiceHead.A_DocStat
  ) => {
    fSaveHead(xSave, xDocStatus);
  };

  const handleSaveOrApprove = async (
    xsave = true,
    docstatus = vRdxWmsInvoiceHead.A_DocStat
  ) => {
    if (vRdxWmsInvoiceHead.A_VocNo == "0" || !xsave) {
      setTimeout(() => {
        confirmAlert({
          title: `${xsave ? "Save" : "Approve"}`,
          message: `Are you want to ${xsave ? "Save" : "Approve"}?`,
          buttons: [
            {
              className: "alertBtn",
              name: "SaveYes",
              label: "Yes",
              onClick: async () => {
                await finalSave(xsave, docstatus);
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      }, 100);
      setTimeout(() => {
        document.getElementsByName("SaveYes")[0]?.focus();
      }, 150);
    } else if (xsave) {
      await finalSave(xsave, docstatus);
    }
  };

  const processResponse = (
    response,
    xsave = true,
    docstatus = vRdxWmsInvoiceHead.A_DocStat
  ) => {
    console.log("response", response);
    // Step 1: Check if there's any STOP type message
    const stopItem = response.find((item) => item.Type === "STOP");

    if (stopItem) {
      fAlertToast("FAILED", stopItem.Message);
      return false;
    }

    // Step 2: If no STOP, process CONFIRMATION dialogs
    let confirmationIndex = 0;
    console.log("confirmationIndex", confirmationIndex);

    const askConfirmation = async () => {
      if (confirmationIndex >= response.length) {
        // All confirmations processed successfully
        // fAlertToast("SUCCESS", "Saved Successfully");
        await handleSaveOrApprove(xsave, docstatus);
        // return true;
      }

      const currentItem = response[confirmationIndex];
      if (currentItem?.Type === "CONFIRMATION") {
        setTimeout(() => {
          confirmAlert({
            title: "Confirmation",
            message: currentItem.Message,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  confirmationIndex = confirmationIndex + 1;
                  askConfirmation(); // Proceed to next confirmation
                },
              },
              {
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", currentItem.Message);
                  return false;
                },
              },
            ],
          });
        }, 200);
      }
    };

    askConfirmation();
  };

  let timeout = null;
  const serverValidation = async () => {
    const { HeadObject } = WmsSalesInvoiceRo();
    const vRdxUserInfoObj = vRdxUserInfo();

    let obj = {
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_A_Loc: HeadObject.A_Loc,
      v_A_Party: HeadObject.A_Party,
      v_UserId: vRdxUserInfoObj.UserID,
      v_BilltoBill: "Y",
      PurchaseBlock: "N",
      v_RefDocTyp: "",
      v_RefDocNo: "", //it is empty in pre code,if needed take from A_RefNo
      // Detail section
      v_ItmCd: sBufferObj.B_Itmcd,
      v_TaxType: HeadObject.A_CUSTFIELD3, //A_CUSTFIELD3
      v_Unit: sBufferObj.B_Unit,
      A_RefNo: vRdxWmsInvoiceHead.A_RefNo,
      v_TaxDept: sBufferObj.B_TaxDept,
      v_TaxPerc: sBufferObj.B_TaxPerc,
      v_TaxPerc2: sBufferObj.B_TaxPerc2,
      v_TaxDept2: sBufferObj.B_TaxDept2,
      v_B_BaseQty: sBufferObj.B_BaseQty,
      v_SrNo: sBufferObj.B_Srno,
      v_IncentiveGrp: sBufferObj.B_IncGroup,
      A_INV_TYPE: vRdxWmsInvoiceHead.A_INV_TYPE,
      // Confirmation section
      v_B_Qty: sBufferObj.B_Qty,
      v_B_GrossAmt: sBufferObj.B_GrossAmt,
      v_B_LDiscAmt: sBufferObj.B_LDiscAmt,
      v_B_URateLc: sBufferObj.B_URateLc,
      isValidateDetail: true,
      DocStat: HeadObject.A_DocStat,
    };
    let resp = await validationWMINV08(fcheck_null_undefine_replace_empty(obj));
    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet?.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet);
      } else {
        return true;
      }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg || "error in validationWMINV03 "
        );
        const errorField = resp?.response?.data?.message?.field;
        const errorMsg = resp?.response?.data?.message?.msg;
        if (sErrorMsg.hasOwnProperty(errorField)) {
          setErrorMsg((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));
        } else if (sErrorMsgDetail.hasOwnProperty(errorField)) {
          setErrorMsgDetail((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));
        }
      }
      return false;
    }
  };

  const fSave = async (e) => {
    fCloseReverseTransactionModal();
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        vRdxWmsInvoiceHead.A_DocStat == "POST" &&
        vRdxWmsInvoiceHead.A_INV_TYPE == "Walk-In"
      ) {
        fAlertToast(
          "FAILED",
          "Not allowed to Reverse if document status is post and Inv.Type is Walk-In "
        );
      } else if (
        (vRdxWmsInvoiceHead.A_DocStat == "POST" &&
          vRdxWmsInvoiceHead.A_INV_TYPE != "Walk-In") ||
        (vRdxWmsInvoiceHead.A_DocStat == "DRAFT" &&
          vRdxWmsInvoiceHead.A_INV_TYPE != "Walk-In")
      ) {
        if (sRevNarr == "") {
          fOpenReverseTransactionModal();
          return;
        } else {
          let resp = await GetRevereTransaction();
          if (resp?.status === 200) {
            fClearErrorMsg();
            setRevNarr("");
            dispatch(
              Wms_Invoice_HeadObject_A_DocStatus_Set({
                A_DocStat: "ENTER",
              })
            );
            fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
            return;
          }
        }
      } else if (vRdxWmsInvoiceHead.A_DocStat !== "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " +
            vRdxWmsInvoiceHead.A_DocStat.toLowerCase() +
            " mode"
        );
        return;
      } else if (vRdxWmsInvoiceHead.A_DocStat == "ENTER") {
        let validation = fValidationHead();
        if (!validation) return;

        let validationDetil = fValidationDetail();
        if (!validationDetil) return;
        let server_Validation = await serverValidation();

        if (!server_Validation) return;

        if (server_Validation) {
          await handleSaveOrApprove(true);
        }
      }
    }, 200);
  };
  const ValidationApprove = async (xbool, docstatus) => {
    const { HeadObject } = WmsSalesInvoiceRo();
    const vRdxUserInfoObj = vRdxUserInfo();

    let obj = {
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_UserId: vRdxUserInfoObj.UserID,
      v_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_Party: HeadObject.A_Party,
      v_Loc: HeadObject.A_Loc,
      SalesGrp: HeadObject.A_CUSTFIELD2,
      v_Offer: false,
      v_A_Buyer: "", //sruthiji
      A_PayMode: HeadObject.A_PayMode,
      A_DrAc: HeadObject?.A_DrAc,
      partyOsTag: sOsAmount.NetOsAmt,
      crLimitTag: sOsAmount.BalanceOsAmt,
      partyPDCTag: sOsAmount.PDCAmt,
      ItmCd: sBufferObj.B_Itmcd,
      DocStat: HeadObject.A_DocStat,
    };
    let resp = await ApproveWMINV08(fcheck_null_undefine_replace_empty(obj));

    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet, xbool, docstatus);
      } else {
        return true;
      }
    } else {
      if (resp.response.status == 500) {
        if (resp?.response?.data?.message?.field == "UNKNOWN") {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg ||
              "error in ValidateInvTransHeadUpdate "
          );
        } else {
          const errorField = resp?.response?.data?.message?.field;
          const errorMsg = resp?.response?.data?.message?.msg;
          if (sErrorMsg.hasOwnProperty(errorField)) {
            setErrorMsg((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else if (sErrorMsgDetail.hasOwnProperty(errorField)) {
            setErrorMsgDetail((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else {
            fAlertToast(
              "FAILED",
              resp.response.data.message.msg ||
                "error in ValidateInvTransHeadUpdate "
            );
          }

          document
            ?.getElementsByName([resp?.response?.data?.message?.field])[0]
            ?.focus();
        }
      }
      return false;
    }
  };

  const fApprove = async (xDocStatus) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      let validation = fValidationHead();
      if (!validation) return;

      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetailGridData.length === 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }

      let Searver_ValidationApprove = await ValidationApprove(
        false,
        xDocStatus
      );
      if (!Searver_ValidationApprove) return;
      if (!!Searver_ValidationApprove) {
        setTimeout(() => {
          confirmAlert({
            title: "Approve",
            message: "Are you want to Approve..",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: async () => {
                  await finalSave(false, xDocStatus);
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => {
                  return;
                },
              },
            ],
          });
        }, 200);
      }
    }, 800);
  };

  const fDelete = (Srno = sBufferObj.B_Srno) => {
    if (vRdxWmsInvoiceHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (Number(Srno) === 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteHead(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document?.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAuditId(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };
  const fMove_First = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    setItemStock((obj) => ({
      ...obj,
      rpStock: "",
      wmsStock: "",
      msp: "",
      costpr: "",
      OpenBinStock: "",
    }));
    fDisplay(sUser_Doc_Arr[0].A_VocTyp, sUser_Doc_Arr[0].A_VocNo);
    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();
    setItemStock((obj) => ({
      ...obj,
      rpStock: "",
      wmsStock: "",
      msp: "",
      costpr: "",
      OpenBinStock: "",
    }));
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocNo
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();
    setItemStock((obj) => ({
      ...obj,
      rpStock: "",
      wmsStock: "",
      msp: "",
      costpr: "",
      OpenBinStock: "",
    }));
    setBufferObj(vBufferObjInit);
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(sUser_Doc_Arr[row - 1].A_VocTyp, sUser_Doc_Arr[row - 1].A_VocNo);
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();
    setItemStock((obj) => ({
      ...obj,
      rpStock: "",
      wmsStock: "",
      msp: "",
      costpr: "",
      OpenBinStock: "",
    }));
    setBufferObj(vBufferObjInit);
    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(sUser_Doc_Arr[row - 1].A_VocTyp, sUser_Doc_Arr[row - 1].A_VocNo);
      setNavDocValue(row);
    }
  };

  const fValidationHead = () => {
    let iRes = true;

    if (
      vRdxWmsInvoiceHead.A_VocTyp === "" ||
      vRdxWmsInvoiceHead.A_VocTyp === null ||
      vRdxWmsInvoiceHead.A_VocTyp === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_VocTyp: "VocTyp should not be empty",
      }));
      fAlertToast("FAILED", "VocTyp should not be empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_VocNo === "" ||
      vRdxWmsInvoiceHead.A_VocNo === null ||
      vRdxWmsInvoiceHead.A_VocNo === undefined
    ) {
      setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
      fAlertToast("FAILED", "VocNo should not be empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_PostDt === "" ||
      vRdxWmsInvoiceHead.A_PostDt === null ||
      vRdxWmsInvoiceHead.A_PostDt === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_PostDt: "PostDt should not be empty",
      }));
      fAlertToast("FAILED", "PostDt should not be empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_RefNo.toUpperCase() === "POS" ||
      vRdxWmsInvoiceHead.A_RefNo === null ||
      vRdxWmsInvoiceHead.A_RefNo === undefined
    ) {
      setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be POS" }));
      fAlertToast("FAILED", "Text should not be POS");
      iRes = false;
    } else if (vRdxWmsInvoiceHead.A_RefNo.toUpperCase() === "CREDIT") {
      setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be CREDIT" }));
      fAlertToast("FAILED", "Text should not be CREDIT");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_Party === "" ||
      vRdxWmsInvoiceHead.A_Party === null ||
      vRdxWmsInvoiceHead.A_Party === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_PartyName: "Party should not be empty",
      }));
      fAlertToast("FAILED", "Party should not be empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_PartyName === "" ||
      vRdxWmsInvoiceHead.A_PartyName === null ||
      vRdxWmsInvoiceHead.A_PartyName === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_PartyName: "PartyName should not be empty",
      }));
      fAlertToast("FAILED", "PartyName should not be empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_Curr === "" ||
      vRdxWmsInvoiceHead.A_Curr === null ||
      vRdxWmsInvoiceHead.A_Curr === undefined
    ) {
      setErrorMsg((obj) => ({ ...obj, A_Curr: "Curr should not be empty" }));
      fAlertToast("FAILED", "Curr should not be empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_ExRate === "" ||
      vRdxWmsInvoiceHead.A_ExRate === null ||
      vRdxWmsInvoiceHead.A_ExRate === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_ExRate: "ExRate should not be empty",
      }));
      fAlertToast("FAILED", "ExRate should not be empty");
      iRes = false;
    } else if (Number(vRdxWmsInvoiceHead.A_ExRate) === 0) {
      setErrorMsg((obj) => ({ ...obj, A_ExRate: "ExRate should not be zero" }));
      fAlertToast("FAILED", "ExRate should not be zero");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_PayMode === "" ||
      vRdxWmsInvoiceHead.A_PayMode === null ||
      vRdxWmsInvoiceHead.A_PayMode === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_PayMode: "PayMode should not be Empty",
      }));
      fAlertToast("FAILED", "PayMode should not be Empty");
      iRes = false;
    }
    if (
      (vRdxWmsInvoiceHead.A_CUSTFIELD2 === "" ||
        vRdxWmsInvoiceHead.A_CUSTFIELD2 === null ||
        vRdxWmsInvoiceHead.A_CUSTFIELD2 === undefined) &&
      vRdxDBKernObj.SONAS_INVOICE.Val === "Y"
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      fAlertToast("FAILED", "Sales Group should not be Empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_CUSTFIELD2: "Sales Group should not be Empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_Type === "" ||
      vRdxWmsInvoiceHead.A_Type === null ||
      vRdxWmsInvoiceHead.A_Type === undefined
    ) {
      setErrorMsg((obj) => ({ ...obj, A_Type: "Type should not be Empty" }));
      fAlertToast("FAILED", "Type should not be Empty");
      iRes = false;
    }
    if (
      vRdxWmsInvoiceHead.A_CUSTFIELD3 === "" ||
      vRdxWmsInvoiceHead.A_CUSTFIELD3 === null ||
      vRdxWmsInvoiceHead.A_CUSTFIELD3 === undefined
    ) {
      fAlertToast("FAILED", "Tax Type should not be Empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_CUSTFIELD3: "Tax Type should not be Empty",
      }));
      iRes = false;
    }
    if (
      vRdxWmsInvoiceHead.A_Loc === "" ||
      vRdxWmsInvoiceHead.A_Loc === null ||
      vRdxWmsInvoiceHead.A_Loc === undefined
    ) {
      setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be Empty" }));
      fAlertToast("FAILED", "Location should not be Empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_RefDt === "" ||
      vRdxWmsInvoiceHead.A_RefDt === null ||
      vRdxWmsInvoiceHead.A_RefDt === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_RefDt: "Reference Date should not be Empty",
      }));
      fAlertToast("FAILED", "Reference Date should not be Empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_Buyer === "" ||
      vRdxWmsInvoiceHead.A_Buyer === null ||
      vRdxWmsInvoiceHead.A_Buyer === undefined
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      setErrorMsg((obj) => ({ ...obj, A_Buyer: "Buyer should not be Empty" }));
      fAlertToast("FAILED", "Buyer should not be Empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_INV_TYPE === "" ||
      vRdxWmsInvoiceHead.A_INV_TYPE === null ||
      vRdxWmsInvoiceHead.A_INV_TYPE === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_INV_TYPE: "INV Type should not be Empty",
      }));
      fAlertToast("FAILED", "INV Type should not be Empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_Taxable === "" ||
      vRdxWmsInvoiceHead.A_Taxable === null ||
      vRdxWmsInvoiceHead.A_Taxable === undefined
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_Taxable: "Taxable should not be Empty",
      }));
      fAlertToast("FAILED", "Taxable should not be Empty");
      iRes = false;
    }
    if (
      vRdxWmsInvoiceHead.A_CrAc === "" ||
      vRdxWmsInvoiceHead.A_CrAc === null ||
      vRdxWmsInvoiceHead.A_CrAc === undefined
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      setErrorMsg((obj) => ({ ...obj, A_CrAc: "CrAc is Empty" }));
      fAlertToast("FAILED", "CrAc is Empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_CrAcName === "" ||
      vRdxWmsInvoiceHead.A_CrAcName === null ||
      vRdxWmsInvoiceHead.A_CrAcName === undefined
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      setErrorMsg((obj) => ({ ...obj, A_CrAcName: "CrAcName is Empty" }));
      fAlertToast("FAILED", "CrAcName is Empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_DrAc === "" ||
      vRdxWmsInvoiceHead.A_DrAc === null ||
      vRdxWmsInvoiceHead.A_DrAc === undefined
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      setErrorMsg((obj) => ({ ...obj, A_DrAc: "DrAc is Empty" }));
      fAlertToast("FAILED", "DrAc is Empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_DrAcName === "" ||
      vRdxWmsInvoiceHead.A_DrAcName === null ||
      vRdxWmsInvoiceHead.A_DrAcName === undefined
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      setErrorMsg((obj) => ({ ...obj, A_DrAcName: "DrAcName is Empty" }));
      fAlertToast("FAILED", "DrAcName is Empty");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_Rounding === "" ||
      vRdxWmsInvoiceHead.A_Rounding === null ||
      vRdxWmsInvoiceHead.A_Rounding === undefined
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      setErrorMsg((obj) => ({
        ...obj,
        A_Rounding: "Rounding should not be Empty",
      }));
      fAlertToast("FAILED", "Rounding should not be Empty");
      iRes = false;
    }

    if (sFooterObj.A_LandVal < 0) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }

      setErrorMsg((obj) => ({
        ...obj,
        A_Rounding: "Transaction amount should be greater than zero",
      }));
      fAlertToast("FAILED", "Transaction amount should be greater than zero");
      iRes = false;
    }

    if (
      vRdxWmsInvoiceHead.A_DiscPerc === "" ||
      vRdxWmsInvoiceHead.A_DiscPerc === null ||
      vRdxWmsInvoiceHead.A_DiscPerc === undefined
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      fAlertToast("FAILED", "Discount percentage should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_DiscPerc: "Discount percentage should not be empty",
      }));
      iRes = false;
    } else if (
      Number(vRdxWmsInvoiceHead.A_DiscPerc) !== 0 &&
      Number(sFooterObj.A_TDiscAmt) === 0
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      fAlertToast("FAILED", "Check discount percentage2");
      setErrorMsg((obj) => ({
        ...obj,
        A_TDiscAmt: "Check discount percentage2",
      }));
      iRes = false;
    } else if (
      vRdxWmsInvoiceHead.A_DiscPerc == 0 &&
      sFooterObj.A_TDiscAmt != 0
    ) {
      if (vMediaQuery) {
        fOpenInvoiceSalesModal("summary");
      }
      fAlertToast("FAILED", "Check discount percentage1");
      setErrorMsg((obj) => ({
        ...obj,
        A_DiscPerc: "Check discount percentage1",
      }));
      iRes = false;
    } else if (
      Number(vRdxWmsInvoiceHead.A_DiscPerc) > 100 ||
      Number(vRdxWmsInvoiceHead.A_DiscPerc) < 0
    ) {
      setErrorMsg((obj) => ({
        ...obj,
        A_DiscPerc:
          "Discount Percentage must be greater than 0 and less than or equal to 100",
      }));
      fAlertToast("FAILED", "Discount Percentage must be between 0 and 100");
      iRes = false;
    }

    return iRes;
  };

  const UnitRateFlag = () => {
    const { DBKernObj } = KernCAConfig();
    if (DBKernObj.WMINV03_UNITRATE_VLDT?.Val === "N") {
      return false;
    } else {
      return true;
    }
  };

  const fValidationDetail = () => {
    let iRes = true;

    if (vRdxWmsInvoiceHead.A_DocStat !== "ENTER") {
      fAlertToast("FAILED", "Check Doc Status");
      iRes = false;
    }

    if (sBufferObj.B_Srno === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_Srno: "Serial number should not be empty",
      }));
      fAlertToast("FAILED", "Serial number should not be empty");
      iRes = false;
    }

    if (sBufferObj.B_Itmcd === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ItmName: "Item code should not be empty",
      }));
      fAlertToast("FAILED", "Item code should not be empty");
      iRes = false;
    }

    if (
      sBufferObj.B_ItmName === "" ||
      sBufferObj.B_ItmName === null ||
      sBufferObj.B_ItmName === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ItmName: "Item name should not be empty",
      }));
      fAlertToast("FAILED", "Item name should not be empty");
      iRes = false;
    }

    if (
      sBufferObj.B_Qty === "" ||
      sBufferObj.B_Qty === null ||
      sBufferObj.B_Qty === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_Qty: "Enter quantity" }));
      fAlertToast("FAILED", "Enter quantity");
      iRes = false;
    } else if (Number(sBufferObj.B_Qty) <= 0) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_Qty: "Quantity should not be zero",
      }));
      fAlertToast("FAILED", "Quantity should not be zero");
      iRes = false;
    }

    if (
      sBufferObj.B_Unit === "" ||
      sBufferObj.B_Unit === null ||
      sBufferObj.B_Unit === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
      fAlertToast("FAILED", "Select unit");
      iRes = false;
    } else if (
      sBufferObj.B_PackQty === "" ||
      sBufferObj.B_PackQty === null ||
      sBufferObj.B_PackQty === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_Unit: "Pack quantity should not be Empty",
      }));
      fAlertToast("FAILED", "Pack quantity should not be Empty");
      iRes = false;
    } else if (Number(sBufferObj.B_PackQty) === 0) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_Unit: "Pack quantity should not be zero",
      }));
      fAlertToast("FAILED", "Pack quantity should not be zero");
      iRes = false;
    }

    if (UnitRateFlag()) {
      if (
        sBufferObj.B_BaseQty === "" ||
        sBufferObj.B_BaseQty === null ||
        sBufferObj.B_BaseQty === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_BaseQty: "Base quantity should not be Empty",
        }));
        fAlertToast("FAILED", "Base quantity should not be Empty");
        iRes = false;
      }

      if (
        sBufferObj.B_URateFc === "" ||
        sBufferObj.B_URateFc === null ||
        sBufferObj.B_URateFc === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_URateFc: "Enter unit rate [F.C]",
        }));
        fAlertToast("FAILED", "Enter unit rate [F.C]");
        iRes = false;
      } else if (Number(sBufferObj.B_URateFc) === 0) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_URateFc: "Unit rate [F.C] should not be zero",
        }));
        fAlertToast("FAILED", "Unit rate [F.C] should not be zero");
        iRes = false;
      }

      if (
        sBufferObj.B_URateLc === "" ||
        sBufferObj.B_URateLc === null ||
        sBufferObj.B_URateLc === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_URateLc: "Enter unit rate [L.C]",
        }));
        fAlertToast("FAILED", "Enter unit rate [L.C]");
        iRes = false;
      } else if (Number(sBufferObj.B_URateLc) <= 0) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_URateLc: "Unit rate [L.C] should not be zero",
        }));
        fAlertToast("FAILED", "Unit rate [L.C] should not be zero");
        iRes = false;
      }

      if (
        sBufferObj.B_GrossAmt === "" ||
        sBufferObj.B_GrossAmt === null ||
        sBufferObj.B_GrossAmt === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_GrossAmt: "GrossAmt should not be Empty",
        }));
        fAlertToast("FAILED", "GrossAmt should not be Empty");
        iRes = false;
      }
    }
    if (
      sBufferObj.B_LDiscPerc === "" ||
      sBufferObj.B_LDiscPerc === null ||
      sBufferObj.B_LDiscPerc === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscPerc should not be Empty",
      }));
      fAlertToast("FAILED", "LDiscPerc should not be Empty");
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) == 0 &&
      Number(sBufferObj.B_LDiscAmt) != 0
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscAmt should be Zero",
      }));
      fAlertToast("FAILED", "LDiscAmt should be Zero");
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) != 0 &&
      Number(sBufferObj.B_LDiscAmt) <= 0
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscAmt should not be Zero",
      }));
      fAlertToast("FAILED", "LDiscAmt should not be Zero");
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) > 100 ||
      Number(sBufferObj.B_LDiscPerc) < 0
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc:
          "LDisc Percentage must be greater than 0 and less than or equal to 100",
      }));
      fAlertToast("FAILED", "LDisc Percentage must be between 0 and 100");
      iRes = false;
    }
    if (
      sBufferObj.B_LDiscAmt === "" ||
      sBufferObj.B_LDiscAmt === null ||
      sBufferObj.B_LDiscAmt === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscAmt: "LDiscAmt should not be Empty",
      }));
      fAlertToast("FAILED", "LDiscAmt should not be Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_TDiscPerc === "" ||
      sBufferObj.B_TDiscPerc === null ||
      sBufferObj.B_TDiscPerc === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TDiscPerc: "TDiscPerc should not be Empty",
      }));
      fAlertToast("FAILED", "TDiscPerc should not be Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_TDiscAmt === "" ||
      sBufferObj.B_TDiscAmt === null ||
      sBufferObj.B_TDiscAmt === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TDiscAmt: "TDiscAmt should not be Empty",
      }));
      fAlertToast("FAILED", "TDiscAmt should not be Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_FocFlag === "" ||
      sBufferObj.B_FocFlag === null ||
      sBufferObj.B_FocFlag === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocFlag: "FocFlag should not be Empty",
      }));
      fAlertToast("FAILED", "FocFlag should not be Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_FocAmt === "" ||
      sBufferObj.B_FocAmt === null ||
      sBufferObj.B_FocAmt === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocAmt: "FocAmt should not be Empty",
      }));
      fAlertToast("FAILED", "FocAmt should not be Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_ExciseTaxAmt === "" ||
      sBufferObj.B_ExciseTaxAmt === null ||
      sBufferObj.B_ExciseTaxAmt === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxAmt: "ExciseTaxAmt should not be Empty",
      }));
      fAlertToast("FAILED", "ExciseTaxAmt should not be Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_ExciseTaxNetAmt === "" ||
      sBufferObj.B_ExciseTaxNetAmt === null ||
      sBufferObj.B_ExciseTaxNetAmt === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxNetAmt: "ExciseTaxNetAmt should not be Empty",
      }));
      fAlertToast("FAILED", "ExciseTaxNetAmt should not be Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_NetAmt === "" ||
      sBufferObj.B_NetAmt === null ||
      sBufferObj.B_NetAmt === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_NetAmt: "NetAmt is Empty" }));
      fAlertToast("FAILED", "NetAmt is Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_TaxDept === "" ||
      sBufferObj.B_TaxDept === null ||
      sBufferObj.B_TaxDept === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept: "TaxDept is Empty" }));
      fAlertToast("FAILED", "TaxDept is Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_TaxPerc === "" ||
      sBufferObj.B_TaxPerc === null ||
      sBufferObj.B_TaxPerc === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc: "TaxPerc is Empty" }));
      fAlertToast("FAILED", "TaxPerc is Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_TaxAmt === "" ||
      sBufferObj.B_TaxAmt === null ||
      sBufferObj.B_TaxAmt === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt: "TaxAmt is Empty" }));
      fAlertToast("FAILED", "TaxAmt is Empty");
      iRes = false;
    }
    if (
      sBufferObj.B_TaxDept2 === "" ||
      sBufferObj.B_TaxDept2 === null ||
      sBufferObj.B_TaxDept2 === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept2: "TaxDept2 is Empty" }));
      fAlertToast("FAILED", "TaxDept2 is Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_TaxPerc2 === "" ||
      sBufferObj.B_TaxPerc2 === null ||
      sBufferObj.B_TaxPerc2 === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc2: "TaxPerc2 is Empty" }));
      fAlertToast("FAILED", "TaxPerc2 is Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_TaxAmt2 === "" ||
      sBufferObj.B_TaxAmt2 === null ||
      sBufferObj.B_TaxAmt2 === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt2: "TaxAmt2 is Empty" }));
      fAlertToast("FAILED", "TaxAmt2 is Empty");
      iRes = false;
    }

    if (
      sBufferObj?.AddCess === "" ||
      sBufferObj?.AddCess === null ||
      sBufferObj?.AddCess === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, AddCess: "AddCess is Empty" }));
      fAlertToast("FAILED", "AddCess is Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_NetAddCess === "" ||
      sBufferObj.B_NetAddCess === null ||
      sBufferObj.B_NetAddCess === undefined
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAddCess: "NetAddCess is Empty",
      }));
      fAlertToast("FAILED", "NetAddCess is Empty");
      iRes = false;
    }

    if (
      sBufferObj.B_LandVal === "" ||
      sBufferObj.B_LandVal === null ||
      sBufferObj.B_LandVal === undefined
    ) {
      setErrorMsgDetail((obj) => ({ ...obj, B_LandVal: "LandVal is Empty" }));
      fAlertToast("FAILED", "LandVal is Empty");
      iRes = false;
    }
    if (vRdxDBKernObj.SONAS_INVOICE.Val === "Y") {
      if (sBufferObj.B_IncGroup === "" && sIncentiveGroups.length > 0) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_IncGroup: "B_IncGroup is Empty",
        }));
        fAlertToast("FAILED", "B_IncGroup is Empty");
        iRes = false;
      }
      if (
        sBufferObj.B_SuprvPerc === "" ||
        sBufferObj.B_SuprvPerc === null ||
        sBufferObj.B_SuprvPerc === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SuprvPerc: "SuprvPerc is Empty",
        }));
        fAlertToast("FAILED", "SuprvPerc is Empty");
        iRes = false;
      }
      if (
        sBufferObj.B_OthersPerc === "" ||
        sBufferObj.B_OthersPerc === null ||
        sBufferObj.B_OthersPerc === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_OthersPerc: "OthersPerc is Empty",
        }));
        fAlertToast("FAILED", "OthersPerc is Empty");
        iRes = false;
      }
      if (
        sBufferObj.B_SLANSuprv === "" ||
        sBufferObj.B_SLANSuprv === null ||
        sBufferObj.B_SLANSuprv === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SLANSuprv: "SLANSuprv is Empty",
        }));
        fAlertToast("FAILED", "SLANSuprv is Empty");
        iRes = false;
      }
      if (
        sBufferObj.B_SlabAmtSuprv === "" ||
        sBufferObj.B_SlabAmtSuprv === null ||
        sBufferObj.B_SlabAmtSuprv === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SlabAmtSuprv: "SlabAmtSuprv is Empty",
        }));
        fAlertToast("FAILED", "SlabAmtSuprv is Empty");
        iRes = false;
      }
      if (
        sBufferObj.B_SLANOther === "" ||
        sBufferObj.B_SLANOther === null ||
        sBufferObj.B_SLANOther === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SLANOther: "SLANOther is Empty",
        }));
        fAlertToast("FAILED", "SLANOther is Empty");
        iRes = false;
      }
      if (
        sBufferObj.B_SlabAmtOther === "" ||
        sBufferObj.B_SlabAmtOther === null ||
        sBufferObj.B_SlabAmtOther === undefined
      ) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SlabAmtOther: "SlabAmtOther is Empty",
        }));
        fAlertToast("FAILED", "SlabAmtOther is Empty");
        iRes = false;
      }
    }

    return iRes;
  };

  //onchange we will not get value so 2 parameter added
  //GCItemSearch
  let vIsDownKeyPressed = false;
  const GetItemSearchValue = async (e, xOnchangeAPI, xValue) => {
    //openCustomer to call api on open modal if value in any data

    if (
      e.key === "Enter" ||
      xOnchangeAPI == "GROUP" ||
      xOnchangeAPI == "openCustomer"
    ) {
      if (sTitle === "Item/Vendor") {
        let vSeatchVendor = {
          anyData:
            xOnchangeAPI == "openCustomer"
              ? xValue
              : sItemSearchModalObj.vAnydata,
          itemCd: sItemSearchModalObj.vItemNameCode,
          itemName: sItemSearchModalObj.vItemNameName,
          barcode: sItemSearchModalObj.vItemNameBarcode,
          model:
            xOnchangeAPI == "GROUP"
              ? xValue
              : sItemSearchModalObj.vItemNameGroupCode,
          refNo1: sItemSearchModalObj.vItemNameRefNo,
          nameFL: sItemSearchModalObj.vItemNameNameFL,
          loc: vRdxWmsInvoiceHead.A_Loc,
          vendor: vRdxWmsInvoiceHead.A_Party,
        };

        const vItemSearch = await fExecuteAPI(
          "SEARCHVENDORITEM_GETROW",
          vSeatchVendor
        );
        if (vItemSearch.ResultSet) {
          let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
            ...obj,
            id: i + 1,
          }));
          setGridSelectRowData(vItemSearchArr);
        }
      } else if (sTitle === "Item") {
        let vSeatchVendor = {
          anyData:
            xOnchangeAPI == "openCustomer"
              ? xValue
              : sItemSearchModalObj.vAnydata,
          itemCd: sItemSearchModalObj.vItemNameCode,
          itemName: sItemSearchModalObj.vItemNameName,
          barcode: sItemSearchModalObj.vItemNameBarcode,
          model:
            xOnchangeAPI == "GROUP"
              ? xValue
              : sItemSearchModalObj.vItemNameGroupCode,
          refNo1: sItemSearchModalObj.vItemNameRefNo,
          nameFL: sItemSearchModalObj.vItemNameNameFL,
          loc: vRdxWmsInvoiceHead.A_Loc,
        };
        const vItemSearch = await fExecuteAPI(
          "SEARCHITEM_GETROW",
          vSeatchVendor
        );
        if (vItemSearch.ResultSet) {
          let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
            ...obj,
            id: i + 1,
          }));
          setGridSelectRowData(vItemSearchArr);
        }
      }
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (Number(selectedLength) === 0) {
          let tabel = document.getElementById("table-main-grid-3");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    setLoading(true);
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALL" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallPartyModal" ||
      xAPICALL === "APICallLocModal" ||
      xAPICALL === "APICallSalesGroupModal"
    ) {
      let vSearchObj = {
        VocNo: sSearchModalObj.VocNo,
        PostDt:
          xAPICALL === "APICALLDATE"
            ? moment(xSTATUS).format("MM/DD/YYYY")
            : !!sSearchModalObj.PostDt
            ? moment(sSearchModalObj.PostDt).format("MM/DD/YYYY")
            : "01/01/1900",
        // PostDt: "01/01/1900",
        RefNo: sSearchModalObj.RefNo,
        Party:
          xAPICALL === "APICallPartyModal"
            ? !!xSTATUS
              ? xSTATUS
              : "All"
            : !!sSearchModalObj.Party
            ? sSearchModalObj.Party
            : "All",
        Type: "",
        Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        Status: xAPICALL === "APICALL" ? xSTATUS : sSearchModalObj.Status,
        UserCd: vRdxuserInfo.UserID,
        SalesGroup:
          xAPICALL === "APICallSalesGroupModal"
            ? xSTATUS
            : sSearchModalObj.SalesGroup,
      };
      const vSearch = await fExecuteAPI("SEARCHSIHEAD_GETROW", vSearchObj);
      if (vSearch?.Type?.toUpperCase() === "SUCCESS") {
        let vSearchArr = vSearch?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
        setLoading(false);
      } else {
        fAlertToast("FAILED", vSearch.Message);
      }
    }
    setLoading(false);
  };

  const CustDependency = async (xAcCd) => {
    const vSupplier = await fExecuteAPI("SUPPLIER_GETROW", "D");

    if (vSupplier?.ResultSet?.length > 0) {
      let pricelvl = vSupplier?.ResultSet.find((obj) => {
        return obj.AcCd?.toUpperCase() === xAcCd?.toUpperCase();
      });
      console.log("pricelvl", pricelvl);
      let { PriceLevel } = vSupplier?.ResultSet.find((obj) => {
        return obj.AcCd?.toUpperCase() === xAcCd?.toUpperCase();
      });
      if (!!PriceLevel) {
        dispatch(
          Wms_Invoice_HeadObject_A_Type_Set({
            A_Type: PriceLevel,
          })
        );
      }
    }
  };

  const fOpenHeadCustomerSearchModalKey = async (e, ModalName) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vSupplierSearchDataObj = {
        Typ: "D",
        Data: vRdxWmsInvoiceHead?.A_PartyName ?? "",
      };

      const vSupplierSearch = await SubKonten_Search_Full_V3Api(
        vSupplierSearchDataObj
      );
      if (vSupplierSearch?.status === 200) {
        const rows = vSupplierSearch?.data?.ResultSet ?? [];
        if (rows.length > 0) {
          const vSupplierData = rows[0];

          let vDefaultTaxType = "OTTRN001";
          let iDefaultTaxType = await GetTransTaxType(
            vRdxWmsInvoiceHead.A_Loc,
            vSupplierData?.AcCd
          );
          if (Object.keys(iDefaultTaxType[0]).length != 0) {
            vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
          }
          //if inter.comp then tax group should be 0
          if (vDefaultTaxType == "OTTRN002" || vDefaultTaxType == "OTTRN003") {
            InterCompanyDependency(
              vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
              vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
            );
          }
          if (!!vSupplierData) {
            if (iDefaultTaxType.length > 0) {
              dispatch(
                Wms_Invoice_HeadObject_Set({
                  ...vRdxWmsInvoiceHead,
                  A_Party: vSupplierData?.AcCd,
                  A_PartyName: vSupplierData?.Name1,
                  A_CUSTFIELD3: vDefaultTaxType,
                })
              );

              GetDefcustomersetting(
                vSupplierData?.AcCd,
                vRdxWmsInvoiceHead.A_Loc
              );
            } else {
              dispatch(
                Wms_Invoice_HeadObject_Set({
                  ...vRdxWmsInvoiceHead,
                  A_Party: vSupplierData?.AcCd,
                  A_PartyName: vSupplierData?.Name1,
                })
              );
            }
            CustDependency(vSupplierData?.AcCd);
            GetDefaultDrCrAccount(
              vRdxWmsInvoiceHead.A_VocTyp,
              vRdxWmsInvoiceHead.A_PayMode,
              vSupplierData?.AcCd
            );
            setTimeout(() => {
              fKeyTabInput(e, "B_ItmName");
            }, 500);
          } else {
            fOnClickDropdownCustomerSearchModalKey(e);
          }
          if (vRdxWmsInvoiceHead.A_Party != "") {
            setTimeout(() => {
              fKeyTabInput(e, "B_ItmName");
            }, 500);
          }
        } else {
          fOnClickDropdownCustomerSearchModalKey(e);
        }
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          A_Party: "",
          A_PartyName: e.target.value,
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );

          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  //Customer Dropdowm
  const [sCustomerToggleDropdown, setCustomerToggleDropdown] = useState(false);
  const [sCustomerSearchDropdownObj, setCustomerSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const fOnChangeCustomer = (e) => {
    setCustomerSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fCustomerClick = useCallback(() => {
    if (sCustomerToggleDropdown) {
      setCustomerToggleDropdown(false);
      setCustSearchGridData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setCustomerToggleDropdown(true);
    }
  }, [sCustomerToggleDropdown]);

  const fOnKeyUpCustomer = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchCustomer(
        sCustomerSearchDropdownObj.Data,
        sCustomerSearchDropdownObj.Type,
        vRdxWmsInvoiceHead.A_Loc,
        setCustSearchGridData
      );
    }
    //   id="table-main-grid-dropdown"
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          // let tabel = document.getElementById("table-main-grid-dropdown");
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );

          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fOnClickDropdownCustomerSearchModalKey = async (e) => {
    setLoading(true);
    if (e.key === "Enter" || e._reactName === "onClick") {
      setCustomerSearchDropdownObj((obj) => ({
        ...obj,
        Data: vRdxWmsInvoiceHead.A_PartyName,
      }));
      if (vRdxWmsInvoiceHead.A_PartyName != "") {
        GetSearchCustomer(
          vRdxWmsInvoiceHead.A_PartyName,
          "Any",
          vRdxWmsInvoiceHead.A_Loc,
          setCustSearchGridData
        );
      }
      setTimeout(() => {
        document?.getElementsByName("Data")[0]?.focus();
      }, 100);
      fCustomerClick();
    }
  };

  //HEAD Component

  const fOnChangeSelectDocType = (event) => {
    var vSelectedObj = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        A_VocTyp: vSelectedObj.VocTyp,
        A_VocTypName: vSelectedObj.VocName,
      })
    );
    fDefaultPayload(vSelectedObj.Paymode, dispatch, setPaymodeEnable);
    GetDefaultDrCrAccount(
      event.target.value,
      vRdxWmsInvoiceHead.A_PayMode,
      vRdxWmsInvoiceHead.A_Party
    );
  };

  const fOnChangeSelectCurr = (event) => {
    var vCurrency = sCurrency?.find((option, index) => {
      return option.Uid === event.target.value;
    });

    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        A_Curr: vCurrency.Uid,
        A_Currname: vCurrency.Name1,
        A_ExRate: vCurrency?.Rate,
      })
    );

    fonChangeGetValueExRate(vCurrency?.Rate);
  };

  const fOnChangeInputDate = useCallback(
    (event) => {
      if (
        event?.$d == "Invalid Date" ||
        event?.$d == null ||
        event?.$d === undefined ||
        event?.$d === ""
      ) {
        dispatch(
          Wms_Invoice_HeadObject_Set({
            ...vRdxWmsInvoiceHead,
            A_PostDt: "",
          })
        );
      } else {
        dispatch(
          Wms_Invoice_HeadObject_Set({
            ...vRdxWmsInvoiceHead,
            A_PostDt: event?.$d,
          })
        );
      }
    },
    [vRdxWmsInvoiceHead, dispatch]
  );

  const fOnChangeInputDateRefDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          A_RefDt: "",
        })
      );
    } else {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          A_RefDt: event?.$d,
        })
      );
    }
  };

  const fonChangeInput = useCallback(
    (event) => {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          [event.target.name]: event.target.value,
        })
      );
    },
    [vRdxWmsInvoiceHead, dispatch]
  );
  const fonChangeInputTaxType = async (event) => {
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        [event.target.name]: event.target.value,
      })
    );
    //if inter.comp then tax group should be 0
    if (event.target.value == "OTTRN002" || event.target.value == "OTTRN003") {
      InterCompanyDependency(
        vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
        vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
      );
    } else {
      if (sBufferObj.B_Itmcd === "") {
        InterCompanyDependency(vRdxGRNtax1[0].UId, vRdxGRNtax2[0].UId);
      } else {
        if (sBufferObj.B_Itmcd != "") {
          const vItemSearchFull = await fExactSearchApi(sBufferObj.B_Itmcd);
          if (vItemSearchFull.ResultSet.length > 0) {
            fItemCodeDependency(vItemSearchFull, event.target.value);
          }
        }
      }
    }
  };
  const fonChangeInputInvType = async (event) => {
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        [event.target.name]: event.target.value,
        A_PayMode: event.target.value == "Walk-In" ? "CASH" : "CREDIT",
      })
    );
    let iDefaultParty = await fDefParty(event.target.value);
    dispatch(
      Wms_Invoice_HeadObject_A_Party_Set({
        A_Party: iDefaultParty.A_Party,
        A_PartyName: iDefaultParty.A_PartyName,
      })
    );

    GetItemStock(
      sBufferObj.B_Itmcd,
      sBufferObj.B_Srno,
      vRdxWmsInvoiceHead.A_Loc,
      event.target.value,
      sBufferObj.B_Unit
    );
    GetDefaultDrCrAccount(
      vRdxWmsInvoiceHead.A_VocTyp,
      event.target.value == "Walk-In" ? "CASH" : "CREDIT",
      iDefaultParty.A_Party
    );
  };
  const fonChangeInputCustomer = (event) => {
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      event.target.value.length <
        vRdxWmsInvoiceHead.A_PartyName.toString().length &&
      vMediaQuery &&
      event.target.name === "A_PartyName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      fOpenHeadCustomerSearchModalKey(vBackspaceObj);
    }
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        [event.target.name]: event.target.value,
      })
    );
    setCustomerModelObj((obj) => ({ ...obj, AnyData: event.target.value }));
  };
  const fonChangeInputPayMode = useCallback(
    (event) => {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          [event.target.name]: event.target.value,
        })
      );
      GetDefaultDrCrAccount(
        vRdxWmsInvoiceHead.A_VocTyp,
        event.target.value,
        vRdxWmsInvoiceHead.A_Party
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [vRdxWmsInvoiceHead]
  );
  const fonChangeInputTaxable = useCallback(
    (event) => {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          [event.target.name]: event.target.checked ? "Y" : "N",
        })
      );
    },
    [vRdxWmsInvoiceHead, dispatch]
  );
  const fonChangeInputPosMode = (event) => {
    dispatch(
      Wms_Invoice_HeadPosMode_Set({
        PosMode: event.target.checked,
      })
    );
  };
  const fonChangeInputLocation = async (event) => {
    let iDefaultTaxType = await GetTransTaxType(
      event.target.value,
      vRdxWmsInvoiceHead.A_Party
    );
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        [event.target.name]: event.target.value,
        A_CUSTFIELD3: iDefaultTaxType[0]?.TaxType,
      })
    );
    ItemsAliasListSearch(event.target.value, sBufferObj.B_Itmcd);
    fonChangeGetValueLocation(event.target.value);
    GetItemStock(
      sBufferObj.B_Itmcd,
      sBufferObj.B_Srno,
      event.target.value,
      vRdxWmsInvoiceHead.A_INV_TYPE,
      sBufferObj.B_Unit
    );
    GetItemNarration(sBufferObj.B_Itmcd, event.target.value);
    GetDefcustomersetting(vRdxWmsInvoiceHead.A_Party, event.target.value);
  };

  //getting value (ExRate) from head
  const fonChangeGetValueExRate = useCallback(
    (ExRate) => {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      } = fCalculate_Detail(
        sBufferObj.B_Qty,
        sBufferObj.B_PackQty,
        ExRate,
        sBufferObj.B_URateFc,
        sBufferObj.B_LDiscPerc,
        sBufferObj.B_TDiscPerc,
        sBufferObj.B_FocFlag,
        sBufferObj.B_ExciseTaxAmt,
        sBufferObj.B_TaxPerc,
        sBufferObj.B_TaxPerc2,
        sBufferObj.AddCess,
        0
      );

      setBufferObj((obj) => ({
        ...obj,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      }));
    },
    [sBufferObj]
  );

  //getting value (Location) from head
  const fonChangeGetValueLocation = async (xA_Loc) => {
    const vIncentiveGroups = await GetIncentiveGroup(
      sBufferObj.B_Itmcd,
      xA_Loc,
      SetIncentiveGroups
    );
    if (vIncentiveGroups.length > 0) {
      setBufferObj((obj) => ({
        ...obj,
        B_IncGroup: vIncentiveGroups[0].UId,
        B_SuprvPerc: vIncentiveGroups[0].SuprvPerc,
        B_OthersPerc: vIncentiveGroups[0].OthersPerc,
      }));
    }
    // WmsSI/getSalesGroups?loc=64
    const vSalesGroup = await GetSalesGroups(xA_Loc);
    if (vSalesGroup?.Type?.toUpperCase() === "SUCCESS") {
      setSalesGroup(vSalesGroup.ResultSet);
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          A_Loc: xA_Loc,
          A_CUSTFIELD2: vSalesGroup.ResultSet[0].UId,
        })
      );
    } else {
      fAlertToast("FAILED", vSalesGroup.Message);
    }
    GetItemStock(
      sBufferObj.B_Itmcd,
      sBufferObj.B_Srno,
      xA_Loc,
      vRdxWmsInvoiceHead.A_INV_TYPE,
      sBufferObj.B_Unit
    );
  };

  const GetExactSearch = async (xItemValue) => {
    const vItemSearchFull = await fExactSearchApi(xItemValue);
    if (vItemSearchFull.ResultSet.length > 0) {
      fItemCodeDependency(vItemSearchFull);
    }
  };

  // if any data value is not empty filter array
  //GCSimpleSearch
  let vIsDownKeyPressedSimpleSearch = false;
  const fHeaderSearchEnter = (e, xAnyData = false, xAnyDataValue = "") => {
    if (xAnyData == true) {
      fformHeaderSearch(
        xAnyDataValue,
        sCustomerModelObj.Code,
        sCustomerModelObj.Name
      );
    } else if (e.key === "Enter") {
      fformHeaderSearch(
        sCustomerModelObj.AnyData,
        sCustomerModelObj.Code,
        sCustomerModelObj.Name
      );
    }

    if (e.key === "Backspace") {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          A_Party: "",
          A_PartyName: e.target.value,
        })
      );
      setHeaderSearchResultArr([]);
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (selectedLength === 0) {
          let tabel = document?.getElementById("table-main-grid-5");
          // vIsDownKeyPressedSimpleSearch = true;
          // tabel?.getElementsByClassName('MuiDataGrid-row')[0].firstChild.click();
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 100);
    }
  };

  const [sHeaderSearchResultArr, setHeaderSearchResultArr] = useState([]);

  async function fformHeaderSearch(pAnydata, pCode, pName) {
  const vSupplierSearchDataObj = {
    Typ: "D",
    Data: pAnydata ?? "",
  };

  const vSupplierSearch = await SubKonten_Search_Full_V3Api(
    vSupplierSearchDataObj
  );

  if (vSupplierSearch?.status === 200) {
    const vNewFilterSearchArr =
      vSupplierSearch?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      })) ?? [];

    if (vNewFilterSearchArr.length > 0) {
      setHeaderSearchResultArr(vNewFilterSearchArr);
    } else {
      await GetSearchCustomer(
        pAnydata,
        "Any",
        vRdxWmsInvoiceHead.A_Loc,
        setCustSearchGridData
      );
      setHeaderSearchResultArr(sCustSearchGridData);
    }
  }
}


  console.log(sCustSearchGridData, "sCustSearchGridData");

  const fSalesGroup = async (xA_Loc) => {
    // WmsSI/getSalesGroups?loc=64
    const vSalesGroup = await GetSalesGroups(xA_Loc);
    if (vSalesGroup?.Type?.toUpperCase() === "SUCCESS") {
      setSalesGroup(vSalesGroup.ResultSet);
      if (vSalesGroup.ResultSet.length > 0) {
        let vSalesGroupObj = {
          A_Loc: xA_Loc,
          A_CUSTFIELD2: vSalesGroup.ResultSet[0].UId,
        };
        return vSalesGroupObj;
      } else {
        let vSalesGroupObjEmpty = {
          A_Loc: xA_Loc,
          A_CUSTFIELD2: "",
        };
        return vSalesGroupObjEmpty;
      }
    } else {
      fAlertToast("FAILED", vSalesGroup.Message);
    }
  };
  //Footer Component
  const fonChangeSelectSalesMan = (event, selectArr) => {
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        A_Buyer: event.target.value,
      })
    );
  };
  const fonChangeSelectSalesGroup = (event, selectArr) => {
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        A_CUSTFIELD2: event.target.value,
      })
    );
  };

  const fonClickInputBlurDiscount = (event) => {
    if (event.target.value == "") {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          A_DiscAmt: (0).toFixed(roundingDigit),
        })
      );
    }
  };
  const fonClickInputFocusDiscount = (event) => {
    if (event.target.value <= 0 || event.target.value == "") {
      dispatch(
        Wms_Invoice_HeadObject_Set({ ...vRdxWmsInvoiceHead, A_DiscAmt: "" })
      );
    }
  };
  const fonChangeInputFooter = (event) => {
    dispatch(
      Wms_Invoice_HeadObject_Set({
        ...vRdxWmsInvoiceHead,
        [event.target.name]: event.target.value,
      })
    );
  };
  //if inter.comp then tax group should be 0
  const InterCompanyDependency = (xTaxID, xCessID) => {
    let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
      return obj.UId == xTaxID;
    });
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == xCessID;
    });
    if (vtaxGroupValue) {
      setBufferObj((obj) => ({
        ...obj,
        B_TaxDept: vtaxGroupValue?.UId,
        B_TaxPerc: vtaxGroupValue?.Perc,
        B_TaxDept2: vCessGroupValue?.UId,
        B_TaxPerc2: vCessGroupValue?.Perc,
      }));
    }

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsInvoiceHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vtaxGroupValue?.Perc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fUnitArrApi = async (ItemCode, setUnt) => {
    let vItemunitObj = {
      itemCd: ItemCode,
    };

    const vItemUnitArr = await fExecuteAPI("GETITEMUNITS_GETROW", vItemunitObj);
    if (vItemUnitArr.Type === "SUCCESS") {
      setUnt(vItemUnitArr.ResultSet);
      return vItemUnitArr.ResultSet;
    } else {
      fAlertToast("FAILED", vItemUnitArr.Message);
      return [];
    }
  };

  const fExactSearchApi = async (itemCd = sBufferObj.B_ItmName) => {
    let vItemFullSearchDataObj = {
      anyData: itemCd,
      transType: "F",
      report: "Y",
      loc: vRdxWmsInvoiceHead.A_Loc,
    };
    const vItemSearchFull = await fExecuteAPI(
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );

    return vItemSearchFull;
  };

  const GetIncentiveGroup = async (xB_Itmcd, xA_Loc, SetIncentiveGroups) => {
    let vIncentiveGroupsObj = {
      itemCd: xB_Itmcd,
      loc: xA_Loc,
    };
    const vIncentiveGroups = await fExecuteAPI(
      "INCENTIVEGROUP_GETROW",
      vIncentiveGroupsObj
    );
    if (vIncentiveGroups?.Type?.toUpperCase() === "SUCCESS") {
      if (vIncentiveGroups?.ResultSet?.length > 0) {
        SetIncentiveGroups(vIncentiveGroups.ResultSet);
        return vIncentiveGroups.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vIncentiveGroups?.Type?.response?.data?.message
          ? vIncentiveGroups?.Type?.response?.data?.message
          : "Error in vIncentiveGroups"
      );
      return [];
    }
  };

  const GetUnitRateApi = async (xB_Itmcd, xUnit) => {
    let vItemunitRateObject = {
      itemCd: xB_Itmcd,
      unit: xUnit,
      loc: vRdxWmsInvoiceHead.A_Loc,
      type: vRdxWmsInvoiceHead.A_Type,
      party: vRdxWmsInvoiceHead.A_Party,
      date: moment(vRdxWmsInvoiceHead.A_PostDt).format("MM/DD/YYYY"),
      curr: vRdxWmsInvoiceHead.A_Curr,
    };
    const vItemUnitRate = await fExecuteAPI(
      "UNITRATE_GETROW",
      vItemunitRateObject
    );
    if (vItemUnitRate.Type === "SUCCESS") {
      return vItemUnitRate.ResultSet;
    } else {
      fAlertToast("FAILED", vItemUnitRate.Message);
      return [];
    }
  };

  //API SALESGROUP
  const GetSalesGroups = async (xA_Loc) => {
    const vSalesGroups = await fExecuteAPI("SALESGROUPS_GETROW", xA_Loc);
    return vSalesGroups;
  };
  //API SALESGROUP
  const GetSalesGroupSearch = async (xA_Loc) => {
    const vSalesGroupSearchs = await fExecuteAPI(
      "SALESGROUPSSEARCH_GETROW",
      xA_Loc
    );
    if (vSalesGroupSearchs.Type == "SUCCESS") {
      return vSalesGroupSearchs.ResultSet;
    } else {
      fAlertToast("FAILED", vSalesGroupSearchs.Message);
    }
  };

  //API SaveSIHead
  const fSaveHead = async (xSave, xDocStatus = "POST") => {
    const iStatus = xSave ? vRdxWmsInvoiceHead.A_DocStat : xDocStatus; //xSave False means Post
    const { HeadObject } = WmsSalesInvoiceRo();

    let vSaveSIHeadObj = {
      // Header
      A_VocTyp: HeadObject.A_VocTyp,
      A_VocNo: HeadObject.A_VocNo,
      A_VocDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      A_RefDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
      A_RefNo: HeadObject.A_RefNo,
      A_Party: HeadObject.A_Party,
      A_Curr: HeadObject.A_Curr,
      A_ExRate: HeadObject.A_ExRate,
      A_PayMode: HeadObject.A_PayMode,
      A_Type: HeadObject.A_Type,
      A_Loc: HeadObject.A_Loc,
      A_Buyer: HeadObject.A_Buyer,
      A_Narr: HeadObject.A_Narr,
      A_CrAc: HeadObject.A_CrAc,
      A_DrAc: HeadObject.A_DrAc,
      A_DiscPerc: HeadObject.A_DiscPerc,
      A_Rounding: HeadObject.A_Rounding,
      A_DocStat: iStatus,
      IP: vRdxuserInfo.IP,
      UserId: vRdxuserInfo.UserID,
      A_Taxable: HeadObject.A_Taxable,
      A_CUSTFIELD2: HeadObject.A_CUSTFIELD2,
      A_CUSTFIELD3: HeadObject.A_CUSTFIELD3,
      A_CUSTFIELD9: HeadObject.A_CUSTFIELD9,
      A_LCust: "",
      A_INV_TYPE: HeadObject.A_INV_TYPE,

      // Detail
      B_Srno: sBufferObj.B_Srno,
      B_Itmcd: sBufferObj.B_Itmcd,
      B_Qty: sBufferObj.B_Qty,
      B_Unit: sBufferObj.B_Unit,
      B_URateFc: sBufferObj.B_URateFc,
      B_URateLc: sBufferObj.B_URateLc,
      B_GrossAmt: sBufferObj.B_GrossAmt,
      B_LDiscPerc: sBufferObj.B_LDiscPerc,
      B_LDiscAmt: sBufferObj.B_LDiscAmt,
      B_FocFlag: sBufferObj.B_FocFlag,
      B_RefDocTyp: sBufferObj.B_RefDocTyp,
      B_RefDocNo: sBufferObj.B_RefDocNo,
      B_ExciseTaxAmt: sBufferObj.B_ExciseTaxAmt,
      B_ExciseTaxNetAmt: sBufferObj.B_ExciseTaxNetAmt,
      B_TaxPerc: sBufferObj.B_TaxPerc,
      B_TaxAmt: sBufferObj.B_TaxAmt,
      Field8: sBufferObj.Narration,
      B_TaxPerc2: sBufferObj.B_TaxPerc2,
      B_TaxAmt2: sBufferObj.B_TaxAmt2,
      B_IncGroup: sBufferObj.B_IncGroup,
      B_SuprvPerc: sBufferObj.B_SuprvPerc,
      B_OthersPerc: sBufferObj.B_OthersPerc,
      B_SLANSuprv: sBufferObj.B_SLANSuprv,
      B_SlabAmtSuprv: sBufferObj.B_SlabAmtSuprv,
      B_SLANOther: sBufferObj.B_SLANOther,
      B_SlabAmtOther: sBufferObj.B_SlabAmtOther,
      B_TaxDept: sBufferObj.B_TaxDept,
      B_TaxDept2: sBufferObj.B_TaxDept2,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
    const vSaveSIHead = await SaveWMINV08(FinalObj);
    if (vSaveSIHead.status == 200) {
      let iVocNo = xSave
        ? vSaveSIHead?.data?.ResultSet?.DocNo
        : vRdxWmsInvoiceHead.A_VocNo;
      if (vRdxWmsInvoiceHead.A_VocNo == "0") {
        setUser_Doc_Arr([
          ...sUser_Doc_Arr,
          {
            A_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
            A_VocNo: iVocNo,
            SrNo: sUser_Doc_Arr.length + 1,
          },
        ]);
      }

      dispatch(
        Wms_Invoice_HeadObject_A_VocNo_Set({
          A_VocNo: iVocNo,
          A_DocStat: iStatus,
        })
      );
      //approve bool type false
      if (!xSave) {
        fDisplay(vRdxWmsInvoiceHead.A_VocTyp, iVocNo);
        fAlertToast("SUCCESS", "Successfully posted");
      } else {
        fNewDetail(
          iVocNo,
          vRdxWmsInvoiceHead.A_Rounding,
          vRdxWmsInvoiceHead.A_VocTyp,
          vRdxWmsInvoiceHead.A_CUSTFIELD3
        );
        fAlertToast("SUCCESS", "Successfully Saved");
      }
    }
  };

  //API GETSIHEAD_GETROW to gethead
  const fDisplay = async (xA_VocTyp, A_VocNo) => {
    let vSIHeadObj = {
      A_VocTyp: xA_VocTyp,
      A_VocNo: A_VocNo,
    };
    const vSIHead = await fExecuteAPI("GETSIHEAD_GETROW", vSIHeadObj);
    if (vSIHead.Type === "SUCCESS") {
      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          A_VocTyp: vSIHead.ResultSet[0].A_VocTyp,
          A_VocTypName: vSIHead.ResultSet[0].VocName,
          A_VocNo: vSIHead.ResultSet[0].A_VocNo,
          A_PostDt: vSIHead.ResultSet[0].A_PostDt,
          A_RefDt: vSIHead.ResultSet[0].A_RefDt,
          A_RefNo: vSIHead.ResultSet[0].A_RefNo,
          A_Party: vSIHead.ResultSet[0].A_Party,
          A_PartyName: vSIHead.ResultSet[0].PartyName,
          A_Curr: vSIHead.ResultSet[0].A_Curr,
          A_Currname: vSIHead.ResultSet[0].CurrName,
          A_ExRate: vSIHead.ResultSet[0].A_ExRate,
          A_PayMode: vSIHead.ResultSet[0].A_PayMode,
          A_Type: vSIHead.ResultSet[0].A_Type,
          A_Loc: vSIHead.ResultSet[0].A_Loc,
          A_Buyer: vSIHead.ResultSet[0].A_Buyer, ////SalesMan
          A_Narr: vSIHead.ResultSet[0].A_Narr,
          A_CrAc: vSIHead.ResultSet[0].A_CrAc,
          A_CrAcName: vSIHead.ResultSet[0].CrAcName,
          A_DrAc: vSIHead.ResultSet[0].A_DrAc,
          A_DrAcName: !!vSIHead.ResultSet[0].DrAcName
            ? vSIHead.ResultSet[0].DrAcName
            : "",
          A_DiscPerc: vSIHead.ResultSet[0].A_DiscPerc
            ? vSIHead.ResultSet[0].A_DiscPerc
            : 0,
          // A_DiscAmt: vSIHead.ResultSet[0].A_DiscAmt,
          A_Rounding: vSIHead.ResultSet[0].A_Rounding
            ? vSIHead.ResultSet[0].A_Rounding
            : 0,

          A_DocStat: vSIHead.ResultSet[0].A_DocStat,
          A_CUSTFIELD2: vSIHead.ResultSet[0].A_CUSTFIELD2, //SalesGroup
          A_CUSTFIELD3: vSIHead.ResultSet[0].A_CUSTFIELD3,
          A_CUSTFIELD9: vSIHead.ResultSet[0].A_CUSTFIELD9,
          A_CUSTFIELD10: vSIHead.ResultSet[0].A_CUSTFIELD10,
          PKD: vSIHead.ResultSet[0].PKD,
          A_TaxGross: vSIHead.ResultSet[0].A_TaxGross,
          A_Taxable: vSIHead.ResultSet[0].A_Taxable,

          A_INV_TYPE: vSIHead.ResultSet[0].A_INV_TYPE,
        })
      );
      ItemsAliasListSearch(vSIHead.ResultSet[0].A_Loc, sBufferObj.B_Itmcd);

      GetItemStock(
        "",
        0,
        vSIHead.ResultSet[0].A_Loc,
        vSIHead.ResultSet[0].A_INV_TYPE,
        ""
      );
      fNewDetail(
        vSIHead.ResultSet[0].A_VocNo,
        vSIHead.ResultSet[0].A_Rounding,
        vSIHead.ResultSet[0].A_VocTyp,
        vSIHead.ResultSet[0].A_CUSTFIELD3
      );
    } else {
      fAlertToast("FAILED", vSIHead.Message);
    }
  };

  //API GETSIDETAILS_GETROW
  const fLoad_Grid = async (
    xB_VocNo,
    xB_Srno,
    xRoundingValue = "",
    xVocTyp
  ) => {
    let iSIDetailObj = {
      VocTyp: !!xVocTyp ? xVocTyp : "",
      VocNo: !!xB_VocNo ? xB_VocNo : "",
      SrNo: xB_Srno,
    };

    const iSIDetail = await fExecuteAPI("GETSIDETAILS_GETROW", iSIDetailObj);

    if (iSIDetail.Type === "SUCCESS") {
      setDetailGridData(iSIDetail?.ResultSet);
      var iGrossAmt = 0,
        iTDiscAmt = 0,
        iLDiscAmt = 0,
        iFocAmt = 0,
        iExciseTaxNetAmt = 0,
        iTaxAmt = 0,
        iTaxAmt2 = 0,
        iAddCess = 0;

      for (let i = 0; i < iSIDetail?.ResultSet?.length; i++) {
        iGrossAmt += iSIDetail.ResultSet[i].B_GrossAmt;
        iTDiscAmt += iSIDetail.ResultSet[i].B_TDiscAmt;
        iLDiscAmt += iSIDetail.ResultSet[i].B_LDiscAmt;
        iFocAmt += iSIDetail.ResultSet[i].B_FocAmt;
        iExciseTaxNetAmt += iSIDetail.ResultSet[i].B_ExciseTaxNetAmt;
        iTaxAmt += iSIDetail.ResultSet[i].B_TaxAmt;
        iTaxAmt2 += iSIDetail.ResultSet[i].B_TaxAmt2;
        iAddCess += iSIDetail.ResultSet[i].B_AddCess;
      }

      let iLandVal =
        iGrossAmt -
        iTDiscAmt -
        iLDiscAmt -
        iFocAmt +
        iExciseTaxNetAmt +
        iTaxAmt +
        iTaxAmt2 +
        iAddCess +
        fcovertToNumber(xRoundingValue);

      setFooterObj((obj) => ({
        ...obj,
        A_GrossAmt: iGrossAmt.toFixed(roundingDigit),
        A_TDiscAmt: iTDiscAmt.toFixed(roundingDigit),
        A_LDiscAmt: iLDiscAmt.toFixed(roundingDigit),
        A_FocAmt: iFocAmt.toFixed(roundingDigit),
        A_NetExcise: iExciseTaxNetAmt.toFixed(roundingDigit),
        A_Tax: iTaxAmt.toFixed(roundingDigit),
        A_Tax2: iTaxAmt2.toFixed(roundingDigit),
        A_AddCess: iAddCess.toFixed(roundingDigit),
        A_LandVal: iLandVal.toFixed(roundingDigit),
      }));
    } else {
      fAlertToast("FAILED", iSIDetail.Message);
    }
  };

  //DELETESIHEAD_GETROW
  const fDeleteHead = async () => {
    let vDeleteSIHeadObj = {
      A_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      A_VocNo: vRdxWmsInvoiceHead.A_VocNo,
      IP: vRdxuserInfo.IP,
      UserId: vRdxuserInfo.UserID,
    };
    const vDeleteSIHead = await deleteHeadWMINV08(vDeleteSIHeadObj);

    if (vDeleteSIHead?.status === 200) {
      if (sBufferObj.B_Srno == 0) {
        // vocno,srno
        dispatch(
          Wms_Invoice_HeadObject_A_DocStatus_Set({
            A_DocStat: "DELETE",
          })
        );
        fDisplay(vRdxWmsInvoiceHead.A_VocTyp, vRdxWmsInvoiceHead.A_VocNo);
        fNewDetail(
          vRdxWmsInvoiceHead.A_VocNo,
          vRdxWmsInvoiceHead.A_Rounding,
          vRdxWmsInvoiceHead.A_VocTyp,
          vRdxWmsInvoiceHead.A_CUSTFIELD3
        );
        fAlertToast("SUCCESS", "Successfully Deleted");
      }
    } else {
      fAlertToast("FAILED", vDeleteSIHead.Message);
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIDetailObj = {
      B_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      B_VocNo: vRdxWmsInvoiceHead.A_VocNo,
      B_Srno: Srno,
    };
    const vDeleteSIDetail = await deleteDetailWMINV08(vDeleteSIDetailObj);

    if (vDeleteSIDetail?.status == 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail(
        vRdxWmsInvoiceHead.A_VocNo,
        "",
        vRdxWmsInvoiceHead.A_VocTyp,
        vRdxWmsInvoiceHead.A_CUSTFIELD3
      );
    }
  };

  const fonRowClickGridObj = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      B_VocNo: vRdxWmsInvoiceHead.A_VocNo,
      B_Srno: item.row.B_Srno,
      B_Itmcd: item.row.B_Itmcd,
      B_ItmName: item.row.ItmName,
      B_Qty: item.row.B_Qty,
      B_Unit: item.row.B_Unit,
      B_UnitName: item.row.UnitName,
      B_PackQty: item.row.B_PackQty,
      B_BaseQty: item.row.B_BaseQty,
      B_URateFc: item.row.B_URateFc,
      B_URateLc: item.row.B_URateLc,
      B_GrossAmt: item.row.B_GrossAmt,
      B_LDiscPerc: item.row.B_LDiscPerc,
      B_LDiscAmt: item.row.B_LDiscAmt,
      B_TDiscPerc: item.row.B_TDiscPerc,
      B_TDiscAmt: item.row.B_TDiscAmt,
      B_FocFlag: item.row.B_FocFlag,
      B_FocAmt: item.row.B_FocAmt,
      B_TaxDept: item.row.B_TaxDept,
      B_TaxPerc: item.row.B_TaxPerc,
      B_TaxAmt: item.row.B_TaxAmt,
      B_TaxDept2: item.row.B_TaxDept2,
      B_TaxPerc2: item.row.B_TaxPerc2,
      B_TaxAmt2: item.row.B_TaxAmt2,
      B_Rounding: item.row.B_Rounding ? item.row.B_Rounding : 0,
      B_LandVal: item.row.B_LandVal || "",
      B_RSP: item.row.B_RSP,
      B_RefDocTyp: item.row.B_RefDocTyp,
      B_RefDocNo: item.row.B_RefDocNo,
      B_URate_Fixed: item.row.B_URate_Fixed,
      B_ExciseTaxPerc: item.row.B_ExciseTaxPerc,
      B_ExciseTaxAmt: item.row.B_ExciseTaxAmt,
      B_ExciseTaxNetAmt: item.row.B_ExciseTaxNetAmt,
      B_IncGroup: item.row.B_IncGroup,
      B_SuprvPerc: item.row.B_SuprvPerc,
      B_OthersPerc: item.row.B_OthersPerc,
      B_SLANSuprv: item.row.B_SLANSuprv,
      B_SlabAmtSuprv: item.row.B_SlabAmtSuprv,
      B_SLANOther: item.row.B_SLANOther,
      B_SlabAmtOther: item.row.B_SlabAmtOther,
      AddCess: item.row.B_AddCess,
      B_NetAddCess: item.row.B_NetAddCess,
      B_NetAmt: item.row.B_NetAmt,
      Narration: item.row.Field8,
      Itm_DefUnit: "",
      Itm_SalUnit: "",
    }));

    await fUnitArrApi(item.row.B_Itmcd, setItemUnit);

    ItemsAliasListSearch(vRdxWmsInvoiceHead.A_Loc, item.row.B_Itmcd);
    await GetIncentiveGroup(
      item.row.B_Itmcd,
      vRdxWmsInvoiceHead.A_Loc,
      SetIncentiveGroups
    );

    let vCurrentSalesHistory = await GetSalesHistory(
      item.row.B_Itmcd,
      item.row.B_Unit,
      vRdxWmsInvoiceHead.A_Party,
      vRdxWmsInvoiceHead.A_Loc
    );

    GetItemStock(
      item.row.B_Itmcd,
      item.row.B_Srno,
      vRdxWmsInvoiceHead.A_Loc,
      vRdxWmsInvoiceHead.A_INV_TYPE,
      item.row.B_Unit
    );
    if (vCurrentSalesHistory.length > 0) {
      setToggleGrid(true);
    } else {
      setToggleGrid(false);
    }
    GetItemNarration(item.row.B_Itmcd, vRdxWmsInvoiceHead.A_Loc);
  };

  const fvalidateDiscount = () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    let iResp = true;
    if (
      Number(sDiscPerModelObj.A_DiscPerc) != 0 &&
      Number(sDiscPerModelObj.A_TDiscAmt <= 0)
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_TDiscAmt: "Check discount percentage.",
      }));
      iResp = false;
    } else if (
      Number(sDiscPerModelObj.A_DiscPerc <= 0) &&
      Number(sDiscPerModelObj.A_TDiscAmt) != 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc: "Check discount percentage",
      }));
      iResp = false;
    } else if (
      Number(sDiscPerModelObj.A_DiscPerc > 100) ||
      Number(sDiscPerModelObj.A_DiscPerc) < 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc:
          "DiscPerc must be greater than 0 and less than or equal to 100",
      }));
      iResp = false;
    }
    return iResp;
  };

  //API SALESHISTORY_GETROW
  const GetSalesHistory = async (xItmcd, xUnit, xParty, xLoc) => {
    let vSalesHistoryObj = {
      itmCd: xItmcd,
      party: xParty,
      unit: xUnit,
      loc: xLoc,
    };
    const vSalesHistory = await fExecuteAPI(
      "SALESHISTORY_GETROW",
      vSalesHistoryObj
    );
    if (vSalesHistory.Type === "SUCCESS") {
      let vSalesHistoryResp = vSalesHistory.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
        // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
      }));
      setGridSalesHistoryRowData(vSalesHistoryResp);
      return vSalesHistoryResp;
    } else {
      fAlertToast("FAILED", vSalesHistory.Message);
      return [];
    }
  };
  //API APPLYTDISCOUNT_GETROW
  const GetApplyTDiscount = async () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    if (fvalidateDiscount()) {
      let vApplyTDiscountObj = {
        B_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
        B_VocNo: vRdxWmsInvoiceHead.A_VocNo,
        TDiscPerc: sDiscPerModelObj.A_DiscPerc,
      };
      const vApplyTDiscount = await fExecuteAPI(
        "APPLYTDISCOUNT_GETROW",
        vApplyTDiscountObj
      );
      if (vApplyTDiscount.Type === "SUCCESS") {
        dispatch(
          Wms_Invoice_HeadObject_Set({
            ...vRdxWmsInvoiceHead,
            A_DiscPerc: sDiscPerModelObj.A_DiscPerc,
          })
        );
        fCloseDiscountPercentageModal();
        fNewDetail(
          vRdxWmsInvoiceHead.A_VocNo,
          vRdxWmsInvoiceHead.A_Rounding,
          vRdxWmsInvoiceHead.A_VocTyp,
          vRdxWmsInvoiceHead.A_CUSTFIELD3
        );
        setTimeout(() => {
          document?.getElementsByName("B_ItmName")[0]?.focus();
        }, 100);
      } else {
        fAlertToast("FAILED", vApplyTDiscount.Message);
      }
    }
  };

  //API VALIDATIONHEADINFO_GETROW
  const fGetValidationHeadInfo = async (xIsApprove) => {
    let vResp = true;
    let vValidationHeadInfoObj = {
      trnTyp: sTrnTyp,
      A_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      A_VocNo: vRdxWmsInvoiceHead.A_VocNo,
      A_PostDt: moment(vRdxWmsInvoiceHead.A_PostDt).format("MM/DD/YYYY"),
      A_Loc: vRdxWmsInvoiceHead.A_Loc,
      A_Party: vRdxWmsInvoiceHead.A_Party,
      userCd: vRdxuserInfo.UserID,
      chkBillToBill: true,
      approve: xIsApprove,
      salesGrp: vRdxWmsInvoiceHead.A_CUSTFIELD2,
      A_PayMode: vRdxWmsInvoiceHead.A_PayMode,
      GridRowCount: sDetailGridData.length,
      isValidate_Purcahse_Block: false,
      RefDocTyp: "",
      RefDocNo: "",
      RefDocName: "",
      RefVer: "0",
      inbound_Type: "",
      xOfferTrans: false,
      xUserCd: vRdxuserInfo?.UserID, // Added 15-02-2023
      xUserGrp: vRdxuserInfo?.UserGroupCode, // Added 15-02-2023
      xRebate: false, // Added 15-02-2023
      A_Buyer: "", //sruthiji
    };

    const vValidationHeadInfo = await fExecuteAPI(
      "VALIDATIONHEADINFO_GETROW",
      vValidationHeadInfoObj
    );
    if (!!vValidationHeadInfo.Type && vValidationHeadInfo?.Type == "SUCCESS") {
      vResp = true;
    } else if (vValidationHeadInfo.response.status == 400) {
      let isKeyAvailable =
        vValidationHeadInfo.response.data.ResultSet.field in sErrorMsg;
      if (isKeyAvailable) {
        setErrorMsg((obj) => ({
          ...obj,
          [vValidationHeadInfo.response.data.ResultSet.field]:
            vValidationHeadInfo.response.data.Status,
        }));
      } else {
        fAlertToast("FAILED", vValidationHeadInfo?.response?.data?.Status);
      }
      return (vResp = false);
    } else if (vValidationHeadInfo.response.status == 500) {
      fAlertToast("FAILED", vValidationHeadInfo.response.data.Status);
      return (vResp = false);
    }
    return vResp;
  };

  const fDemandItmQty = async (xDocStatus = vRdxWmsInvoiceHead.A_DocStat) => {
    let vValidationHeadInfoObj = {
      UserId: vRdxuserInfo.UserID,
      Loc: vRdxWmsInvoiceHead.A_Loc,
      Party: vRdxWmsInvoiceHead.A_Party,
      ItmCd: sBufferObj.B_Itmcd,
      DocStat: xDocStatus,
      VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      VocNo: vRdxWmsInvoiceHead.A_VocNo,
      SrNo: sBufferObj.B_Srno,
      Unit: sBufferObj.B_Unit,
      Qty: sBufferObj.B_Qty,
    };

    let vDemandItemqtyValidation = await fExecuteAPI(
      "GetDemandItemQty_GETROW",
      vValidationHeadInfoObj
    );
    if (
      !!vDemandItemqtyValidation.Type &&
      vDemandItemqtyValidation?.Type.toUpperCase() == "SUCCESS"
    ) {
      return vDemandItemqtyValidation;
    } else {
      fAlertToast(
        "FAILED",
        vDemandItemqtyValidation?.response?.data?.Status ||
          vDemandItemqtyValidation?.response?.data?.message ||
          vDemandItemqtyValidation?.message
      );
      return vDemandItemqtyValidation;
    }
  };

  //API VALIDATIONDETAILINFO_GETROW
  const fGetValidationDetailInfo = async () => {
    let vResp = true;
    let vValidationDetailInfoObj = {
      trnTyp: sTrnTyp,
      vocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      vocNo: vRdxWmsInvoiceHead.A_VocNo,
      B_Srno: sBufferObj?.B_Srno,
      userCd: vRdxuserInfo.UserID,
      B_Itmcd: sBufferObj.B_Itmcd,
      unit: sBufferObj.B_Unit,
      A_Loc: vRdxWmsInvoiceHead.A_Loc,
      landAmt: sBufferObj.B_LandVal,
      B_Qty: sBufferObj.B_Qty,
      refDoctyp: "",
      refDocName: "",
      refDocNo: vRdxWmsInvoiceHead.A_RefNo,
      party: vRdxWmsInvoiceHead.A_Party,
      B_IncGroup: sBufferObj.B_IncGroup,
      B_BaseQty: sBufferObj.B_BaseQty,
      A_INV_TYPE: vRdxWmsInvoiceHead.A_INV_TYPE,
    };
    const vValidationDetailInfo = await fExecuteAPI(
      "VALIDATIONDETAILINFO_GETROW",
      vValidationDetailInfoObj
    );
    if (vValidationDetailInfo.Type == "SUCCESS") {
      vResp = true;
    } else if (vValidationDetailInfo.response.status == 400) {
      let isKeyAvailable =
        vValidationDetailInfo.response.data.ResultSet.field in sErrorMsg;
      if (isKeyAvailable) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          [vValidationDetailInfo.response.data.ResultSet.field]:
            vValidationDetailInfo.response.data.Status,
        }));
      } else {
        fAlertToast("FAILED", vValidationDetailInfo.response.data.Status);
      }
      return (vResp = false);
    } else if (vValidationDetailInfo.response.status == 500) {
      fAlertToast("FAILED", vValidationDetailInfo.response.data.Status);
      return (vResp = false);
    }
    return vResp;
  };

  //API ITEMNARRATION_GETROW
  const GetItemNarration = async (xitmCd, xloc) => {
    let vItemNarrationObj = {
      itmCd: xitmCd,
      loc: xloc,
    };
    const vItemNarration = await fExecuteAPI(
      "ITEMNARRATION_GETROW",
      vItemNarrationObj
    );
    if (vItemNarration.Type === "SUCCESS") {
      let itemList = vItemNarration.ResultSet.map((obj) => {
        return obj.Name;
      });
      //bcoz itemlist returning "" in arr [0]
      if (itemList[0] != "") {
        setNarrArr(itemList);
      }
    } else if (
      vItemNarration.response.status == 400 ||
      vItemNarration.response.status == 500
    ) {
      fAlertToast("FAILED", vItemNarration.response.data.Status);
    }
  };

  //API WMSSI_ITEMSTOCK_GETROW // for viewing ERP & WMS
  const GetItemStock = async (xItemCode, xSrno, xLoc, xInvType, xUnit) => {
    let vItemStockObj = {
      itmCd: xItemCode.trim(),
      loc: xLoc,
      invoiceTyp: xInvType,
      vocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      vocNo: vRdxWmsInvoiceHead.A_VocNo,
      srNo: xSrno,
      unit: xUnit,
    };
    const vItemStock = await fExecuteAPI(
      "WMSSI_ITEMSTOCK_GETROW",
      vItemStockObj
    );
    if (vItemStock.Type === "SUCCESS") {
      setItemStock((obj) => ({
        ...obj,
        rpStock: vItemStock.ResultSet[0].rpStock,
        wmsStock: vItemStock.ResultSet[0].wmsStock,
        msp: vItemStock.ResultSet[0].msp,
        costpr: vItemStock.ResultSet[0].costpr,
        OpenBinStock: vItemStock.ResultSet[0].OpenBinStock,
      }));
    } else if (
      vItemStock.response.status == 400 ||
      vItemStock.response.status == 500
    ) {
      fAlertToast("FAILED", vItemStock.response.data.Status);
    }
  };
  //API TransTaxType_GETROW
  const GetTransTaxType = async (xLoc, xParty) => {
    let vTransTaxTypeObj = {
      loc: xLoc,
      party: xParty,
      taxtype: "OUT",
    };
    const vItemStock = await fExecuteAPI(
      "TransTaxType_GETROW",
      vTransTaxTypeObj
    );
    if (vItemStock.Type === "SUCCESS") {
      return vItemStock.ResultSet;
    } else {
      fAlertToast("FAILED", vItemStock.response.data.Status);
      return [];
    }
  };

  //API DefaultValue_GETROW
  const GetDefaultValue = async (xTransType) => {
    let vDefaultValueObj = {
      TrnTyp: xTransType,
    };
    const vDefaultValue = await fExecuteAPI(
      "DefaultValue_GETROW",
      vDefaultValueObj
    );
    if (vDefaultValue.Type === "SUCCESS") {
      return vDefaultValue.ResultSet;
    } else {
      fAlertToast("FAILED", vDefaultValue.response.data.Status);
      return [];
    }
  };

  //API DEFAULTDRCRACCOUNT_GETROW
  const GetDefaultDrCrAccount = async (xVocTyp, xPayMode, xParty) => {
    let vDefaultDrCrAccountObj = {
      process: sTrnTyp,
      voucher: xVocTyp,
      paymode: xPayMode,
      party: xParty,
    };
    const vDefaultDrCrAccount = await fExecuteAPI(
      "DEFAULTDRCRACCOUNT_GETROW",
      vDefaultDrCrAccountObj
    );
    if (vDefaultDrCrAccount.Type === "SUCCESS") {
      let iDefDrCr = vDefaultDrCrAccount.ResultSet[0];
      dispatch(
        Wms_Invoice_HeadObject_DrCrAccount_Set({
          A_CrAc: !!iDefDrCr.CrAc ? iDefDrCr.CrAc : "",
          A_CrAcName: !!iDefDrCr.CrAcName ? iDefDrCr.CrAcName : "",
          A_DrAc: !!iDefDrCr.DrAc ? iDefDrCr.DrAc : "",
          A_DrAcName: !!iDefDrCr.DrAcName ? iDefDrCr.DrAcName : "",
        })
      );
    } else {
      fAlertToast("FAILED", vDefaultDrCrAccount.response.data.Status);
    }
  };
  //API CHECKCUSTOMEROVERDUE_GETROW
  const GetCheckCustomerOverDue = async () => {
    let vCheckCustomerOverDueObj = {
      A_Party: vRdxWmsInvoiceHead.A_Party,
      userGrp: vRdxuserInfo.UserGroupCode,
    };
    const vCheckCustomerOverDue = await fExecuteAPI(
      "CHECKCUSTOMEROVERDUE_GETROW",
      vCheckCustomerOverDueObj
    );
    if (vCheckCustomerOverDue.Type === "SUCCESS") {
      return vCheckCustomerOverDue.ResultSet;
    } else {
      fAlertToast(
        "FAILED",
        vCheckCustomerOverDue.Message ||
          vCheckCustomerOverDue.response.data.Status ||
          vCheckCustomerOverDue?.response?.data?.message ||
          vCheckCustomerOverDue?.message
      );
    }
  };
  //API CHECKCRLIMIT_GETROW
  const GetCheckCRLimit = async () => {
    let vCheckCRLimitObj = {
      A_Party: vRdxWmsInvoiceHead.A_Party,
      userGrp: vRdxuserInfo.UserGroupCode,
      landAmt: sFooterObj.A_LandVal,
      loc: vRdxWmsInvoiceHead.A_Loc,
    };
    const vCheckCRLimit = await fExecuteAPI(
      "CHECKCRLIMIT_GETROW",
      vCheckCRLimitObj
    );
    if (vCheckCRLimit.Type === "SUCCESS") {
      return vCheckCRLimit.ResultSet;
    } else if (vCheckCRLimit.Type === "FAILED") {
      fAlertToast("FAILED", vCheckCRLimit?.Status);
    } else {
      fAlertToast("FAILED", vCheckCRLimit?.Message);
    }
  };

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField.Type === "SUCCESS") {
      // setAuditSelectArr(vAuditField.ResultSet);
      return vAuditField.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField.Message);
      return vAuditField.ResultSet;
    }
  };

  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      vocNo: vRdxWmsInvoiceHead.A_VocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", vTransAuditObj);
    if (vTransAudit.Type === "SUCCESS") {
      // let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
      //   ...obj,
      //   id: i + 1,
      // }));
      // setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };

  //API GETITEMATTRIBUTES_GETROW
  const fValidateItemsAttributes = async () => {
    let vItemAttributesObj = {
      itmCd: sBufferObj?.B_Itmcd,
      loc: vRdxWmsInvoiceHead?.A_Loc,
      taxType: vRdxWmsInvoiceHead?.A_CUSTFIELD3,
      unit: sBufferObj?.B_Unit,
    };

    const vItemAttributes = await fExecuteAPI(
      "GETITEMATTRIBUTES_GETROW",
      vItemAttributesObj
    );

    if (
      vItemAttributes.Type === "SUCCESS" &&
      vItemAttributes.ResultSet.length > 0
    ) {
      let vGetItemAttributes = vItemAttributes.ResultSet[0];
      let iRes = true;

      if (vGetItemAttributes.Linking != "") {
        setErrorMsgDetail((...obj) => ({
          ...obj,
          B_Itmcd: vGetItemAttributes.Linking,
        }));
        iRes = false;
      }

      if (vGetItemAttributes.ItmActive == "N") {
        setErrorMsgDetail((...obj) => ({
          ...obj,
          B_ItmName: "Item is in-actived",
        }));
        iRes = false;
      }

      if (vGetItemAttributes.TaxDept1 != sBufferObj.B_TaxDept) {
        setErrorMsgDetail((...obj) => ({
          ...obj,
          B_TaxDept: "Tax code is not matching",
        }));
        iRes = false;
      }

      if (vGetItemAttributes.TaxPerc1 != sBufferObj.B_TaxPerc) {
        setErrorMsgDetail((...obj) => ({
          ...obj,
          B_TaxPerc: "Tax % is not matching",
        }));
        iRes = false;
      }

      if (vGetItemAttributes.TaxDept2 != sBufferObj.B_TaxDept2) {
        setErrorMsgDetail((...obj) => ({
          ...obj,
          B_TaxDept2: "Cess code is not matching",
        }));
        iRes = false;
      }
      if (vGetItemAttributes.TaxPerc2 != sBufferObj.B_TaxPerc2) {
        setErrorMsgDetail((...obj) => ({
          ...obj,
          B_TaxPerc2: "Cess % is not matching",
        }));
        iRes = false;
      }

      return { iRes, vGetItemAttributes };
    } else {
      fAlertToast("FAILED", vItemAttributes.Message);
    }
  };

  //defcustomersetting_GETROW
  const GetDefcustomersetting = async (xAcCd, xLoc) => {
    if (vRdxDBKernObj?.SONAS_INVOICE?.Val === "Y") {
      let vdefcustomersettingObj = {
        accd: xAcCd,
        loc: xLoc,
      };
      const vdefcustomersetting = await fExecuteAPI(
        "defcustomersetting_GETROW",
        vdefcustomersettingObj
      );
      if (vdefcustomersetting.Type == "SUCCESS") {
        if (vdefcustomersetting.ResultSet.length > 0) {
          dispatch(
            Wms_Invoice_HeadObject_SalesGroup_SalesMan_Set({
              A_Buyer: !!vdefcustomersetting?.ResultSet[0]?.SalesMan
                ? vdefcustomersetting?.ResultSet[0]?.SalesMan || ""
                : sSalesman[0]?.UId || "",
              A_CUSTFIELD2: !!vdefcustomersetting?.ResultSet[0]?.SalesGroup
                ? vdefcustomersetting?.ResultSet[0]?.SalesGroup || ""
                : sSalesGroup[0]?.UId || "",
            })
          );
        }
      } else {
        fAlertToast(
          "FAILED",
          !!vdefcustomersetting.Message
            ? vdefcustomersetting.Message
            : "Error in default setting customer"
        );
      }
    }
  };

  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      A_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      A_VocNo: vRdxWmsInvoiceHead.A_VocNo,
      A_PostDt: moment(vRdxWmsInvoiceHead.A_PostDt).format("MM/DD/YYYY"),
      userCd: vRdxuserInfo.UserID,
      IP: vRdxuserInfo.IP,
      v_DocStat: vRdxWmsInvoiceHead.A_DocStat,

      // revNarr: sRevNarr,
    };
    const vRevereTransaction = await ReverseWMINV08(vRevereTransactionObj);
    return vRevereTransaction;
  };

  //API FillVanMaster_GETROW
  const GetFillVanMaster = async () => {
    let vFillVanMasterObj = {
      VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      VocNo: vRdxWmsInvoiceHead.A_VocNo,
      SalesGroup: vRdxWmsInvoiceHead.A_CUSTFIELD2,
      Flag: "N",
    };
    const vFillVanMaster = await fExecuteAPI(
      "FillVanMaster_GETROW",
      vFillVanMasterObj
    );
    if (vFillVanMaster.Type == "SUCCESS") {
      return vFillVanMaster.Type;
    } else if (vFillVanMaster.Type == "FAILED") {
      fAlertToast("FAILED", vFillVanMaster.Message);
      return vFillVanMaster.Type;
    } else if (
      vFillVanMaster.response.status == 500 ||
      vFillVanMaster.response.status == 400
    ) {
      fAlertToast("FAILED", vFillVanMaster.response.data.Status);
      return vFillVanMaster.Type;
    } else {
      fAlertToast("FAILED", "Error in loading FillVanMaster");
      return vFillVanMaster.Type;
    }
  };

  //API EmployeeSearchVanGroup_GETROW
  const GetEmployeeSearchVanGroup = async (xAnyData) => {
    let vEmployeeSearchVanGroupObj = {
      v_AnyData: xAnyData,
      v_FName: sSalesGroupEmployeeModelObj.FirstName,
      v_LName: sSalesGroupEmployeeModelObj.LastName,
      v_MName: sSalesGroupEmployeeModelObj.MiddleName,
      v_UserCd: vRdxuserInfo.UserID,
    };
    const vEmployeeSearchVanGroup = await fExecuteAPI(
      "EmployeeSearchVanGroup_GETROW",
      vEmployeeSearchVanGroupObj
    );
    if (vEmployeeSearchVanGroup.Type == "SUCCESS") {
      let GridID = vEmployeeSearchVanGroup.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setEmployeeSearchResultArr(GridID);
    } else if (vEmployeeSearchVanGroup.Type == "FAILED") {
      fAlertToast("FAILED", vEmployeeSearchVanGroup.Message);
    } else if (
      vEmployeeSearchVanGroup.response.status == 500 ||
      vEmployeeSearchVanGroup.response.status == 400
    ) {
      fAlertToast("FAILED", vEmployeeSearchVanGroup.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading EmployeeSearchVanGroup");
    }
  };
  //API WMINV08VANMastItemSave_GETROW
  const GetVANMastItemSave = async () => {
    let vSaveSaleGroupModalObj = {
      v_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      v_VocNo: vRdxWmsInvoiceHead.A_VocNo,
      v_UId: vRdxWmsInvoiceHead.A_CUSTFIELD2,
      v_SrNo: sSalesGroupModalObj.SrNo,
      v_Typ: sSalesGroupModalObj.Type,
      v_EMPID: sSalesGroupModalObj.EmployeeID,
      v_UserCd: vRdxuserInfo.UserID,
      v_Ip: vRdxuserInfo.IP,
      v_Active: sSalesGroupModalObj.Active,
    };
    const vSaveSaleGroupModal = await fExecuteAPI(
      "WMINV08VANMastItemSave_GETROW",
      vSaveSaleGroupModalObj
    );
    if (vSaveSaleGroupModal?.Type?.toUpperCase() == "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Saved");
      fNewSaleGroupModal();
    } else if (vSaveSaleGroupModal?.Type?.toUpperCase() == "FAILED") {
      fAlertToast("FAILED", vSaveSaleGroupModal.Message);
    } else if (
      vSaveSaleGroupModal.response.status == 500 ||
      vSaveSaleGroupModal.response.status == 400
    ) {
      fAlertToast("FAILED", vSaveSaleGroupModal.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading SaveSaleGroupModal");
    }
  };

  //API WMINV08VANMastItemDelete_GETROW
  const GetVANMastItemDelete = async () => {
    let vDeleteSaleGroupModalObj = {
      v_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      v_VocNo: vRdxWmsInvoiceHead.A_VocNo,
      v_UId: vRdxWmsInvoiceHead.A_CUSTFIELD2,
      v_SrNo: sSalesGroupModalObj.SrNo,
    };
    const vDeleteSaleGroupModal = await fExecuteAPI(
      "WMINV08VANMastItemDelete_GETROW",
      vDeleteSaleGroupModalObj
    );
    if (vDeleteSaleGroupModal?.Type?.toUpperCase() == "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Deleted");
      fNewSaleGroupModal();
    } else if (vDeleteSaleGroupModal?.Type?.toUpperCase() == "FAILED") {
      fAlertToast("FAILED", vDeleteSaleGroupModal.Message);
    } else if (
      vDeleteSaleGroupModal.response.status == 500 ||
      vDeleteSaleGroupModal.response.status == 400
    ) {
      fAlertToast("FAILED", vDeleteSaleGroupModal.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading DeleteSaleGroupModal");
    }
  };

  //API WMINV08VANMastItemList_GETROW
  const GetVANMastItemList = async () => {
    let vVANMastItemListObj = {
      v_VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      v_VocNo: vRdxWmsInvoiceHead.A_VocNo,
      v_UID: vRdxWmsInvoiceHead.A_CUSTFIELD2,
    };
    const vVANMastItemList = await fExecuteAPI(
      "WMINV08VANMastItemList_GETROW",
      vVANMastItemListObj
    );
    if (vVANMastItemList.Type == "SUCCESS") {
      let GridID = vVANMastItemList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSalesGroupModalArr(GridID);
    } else if (vVANMastItemList.Type == "FAILED") {
      fAlertToast("FAILED", vVANMastItemList.Message);
    } else if (
      vVANMastItemList.response.status == 500 ||
      vVANMastItemList.response.status == 400
    ) {
      fAlertToast("FAILED", vVANMastItemList.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading VANMastItemList");
    }
  };

  const [sERPStockModal, setERPStockModal] = useState(false);
  const [sERPStockGridRow, setERPStockGridRow] = useState([]);
  const [sERPStockGridColumn, setERPStockGridColumn] = useState([
    {
      field: "SrNo",
      headerName: "Sr.No",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "DocNo",
      headerName: "Doc.No",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "Trans",
      headerName: "Trans",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "Qty",
      headerName: "Qty",
      width: 50,
      headerClassName: "grid-header-row",
    },
  ]);
  const fOpenERPStockModal = () => {
    GetERpStock();
    setERPStockModal(true);
  };
  const fCloseERPStockModal = (e) => {
    setERPStockModal(false);
    setERPStockGridRow([]);
  };
  //API DISPATCH_VARIANCE_ITEMS_GETROW
  const GetERpStock = async () => {
    let vERpStockObj = {
      ItmCd: sBufferObj.B_Itmcd,
      Loc: vRdxWmsInvoiceHead.A_Loc,
      InvType: vRdxWmsInvoiceHead.A_INV_TYPE,
      VocTyp: vRdxWmsInvoiceHead.A_VocTyp,
      VocNo: vRdxWmsInvoiceHead.A_VocNo,
      SrNo: sBufferObj.B_Srno,
      Unit: sBufferObj.B_Unit,
    };
    const vERpStock = await fExecuteAPI(
      "WMINV08_wmsErpStockDetail_GETROW",
      vERpStockObj
    );
    if (vERpStock?.Type?.toUpperCase() == "SUCCESS") {
      let GridID = vERpStock.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setERPStockGridRow(GridID);
    } else {
      fAlertToast("FAILED", vERpStock.response.data.message);
    }
  };

  //API ItemsAliasList_GETROW
  const ItemsAliasListSearch = async (xLoc, xItmCd) => {
    let ItemsAliasListSearchObj = {
      ItmCd: xItmCd,
      Loc: xLoc,
    };
    const vItemsAliasListSearchSearch = await fExecuteAPI(
      "ItemsAliasList_GETROW",
      ItemsAliasListSearchObj
    );
    if (vItemsAliasListSearchSearch?.Type == "SUCCESS") {
      // PostDate: moment(obj.PostDate).format("DD/MM/YYYY")
      let GridID = vItemsAliasListSearchSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setNarrationSearchGridData(GridID);
      setNarrationSearchGridFullData(GridID);
      return GridID;
    } else if (vItemsAliasListSearchSearch.Type == "FAILED") {
      fAlertToast("FAILED", vItemsAliasListSearchSearch.Message);
      return [];
    } else if (
      vItemsAliasListSearchSearch.response.status == 500 ||
      vItemsAliasListSearchSearch.response.status == 400
    ) {
      fAlertToast("FAILED", vItemsAliasListSearchSearch.response.data.message);
      return [];
    } else {
      fAlertToast("FAILED", "Error in loading ItemsAliasListSearchSearch");
      return [];
    }
  };

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 150,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = WmsSalesInvoiceRo();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = WmsSalesInvoiceRo();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };

  //accountDetail end

  const fkeyup = useCallback((e) => {
    if (e.which == 27 || e.key === "Escape") {
      setToggleGrid(false);
    }
    if (e.key === "Enter") {
      let lastChild = document.getElementById("WmssalesinvoiceContentID");
      let TagArr = !!lastChild ? lastChild.querySelectorAll(".col-4") : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";
      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1].getElementsByTagName("input")[0].name ==
            e.target.name &&
          document.getElementById("WMSDocStatID").innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                id: "EnterSave",
                label: "Yes",
                onClick: () => {
                  document.getElementById("BtnSave").click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
            onOpen: () => {
              setTimeout(() => {
                document?.getElementById("EnterSave")?.focus();
              }, 500);
            },
          });
        }
      }
    }
    if (e.key === "Escape") {
      setToggleGrid(false);
      setNarrationToggleDropdown(false);
      setCustomerToggleDropdown(false);
      setToggleDropdown(false);
    }
  }, []);

  useEffect(() => {
    if (vRdxDBKernObj.SONAS_INVOICE.Val === "Y") {
      setInstTypegArr(["Walk-In", "Distribution", "Instant Picking"]);
    } else {
      setInstTypegArr(["Distribution"]);
    }
  }, []);

  const fOnload = async () => {
    let iAttributeResp = await GetAttributes(
      setObjectRights,
      setUser_Doc_Arr,
      setDocLoading,
      setSupervisorSlabs,
      setOtherSlabs,
      setCurrency,
      setSalesman
    );

    const vTransParty = iAttributeResp?.Transaction;
    if (vTransParty?.length > 0) {
      let partyInitValue = vTransParty.find((obj) => {
        return obj.AcCd.toUpperCase() === "ALL";
      });
      setSearchModalObj({
        ...sSearchModalObj,
        Party: partyInitValue?.AcCd,
      });
    }

    let vResponceObj = {
      B_SLANSuprv: "",
      B_SLANOther: "",
    };
    const vSupervisorSlabs = iAttributeResp?.SupervisorSlabs;
    if (vSupervisorSlabs.length > 0) {
      vResponceObj.B_SLANSuprv = vSupervisorSlabs[0];
    }
    const vOtherSlabs = iAttributeResp?.OtherSlabs;
    if (vOtherSlabs.length > 0) {
      vResponceObj.B_SLANOther = vOtherSlabs[0];
    }
    setBufferObj((obj) => ({
      ...obj,
      B_SLANSuprv: vResponceObj.B_SLANSuprv,
      B_SLANOther: vResponceObj.B_SLANOther,
    }));

    var CurrencyArr = {
      Uid: "",
      Name1: "",
      Rate: 0,
    };

    const vCurrency = iAttributeResp?.Currency;
    if (vCurrency.length > 0) {
      CurrencyArr = vCurrency[0];
    }
    //Grn Salesman select api
    var SalesManId = "";
    const vSalesman = iAttributeResp?.Salesman;
    if (vSalesman?.length > 0) {
      SalesManId = vSalesman[0].UId;
    }

    var InvType = "";
    const vReadParameter = iAttributeResp.ReadParameter;
    if (vReadParameter?.length > 0 && vReadParameter[0]?.Val === "N") {
      let NewTypeDataArr = sInstTypeArr?.filter((obj) => {
        return obj === "Distribution";
      });
      setInstTypegArr(NewTypeDataArr);
      InvType = NewTypeDataArr[0];
    } else {
      setInstTypegArr(sInstTypeArr);
      InvType = vRdxWmsInvoiceHead.A_INV_TYPE;
    }

    let vDefaultTaxType = "OTTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsInvoiceHead.A_Loc == "" ||
        vRdxWmsInvoiceHead.A_Loc === null ||
        vRdxWmsInvoiceHead.A_Loc === undefined
        ? vRdxuserLoc[0].UID
        : vRdxWmsInvoiceHead.A_Loc,
      vRdxWmsInvoiceHead.A_Party
    );
    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
    }
    //if inter.comp then tax group should be 0
    if (vDefaultTaxType == "OTTRN002" || vDefaultTaxType == "OTTRN003") {
      InterCompanyDependency(
        vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
        vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
      );
    }
    let vDefaultPartyObj = await fDefParty(
      vRdxWmsInvoiceHead.A_Curr == "" ? InvType : vRdxWmsInvoiceHead.A_INV_TYPE
    );

    const vSalesGroup = await GetSalesGroups(
      vRdxWmsInvoiceHead.A_Loc == "" ||
        vRdxWmsInvoiceHead.A_Loc === null ||
        vRdxWmsInvoiceHead.A_Loc === undefined
        ? vRdxuserLoc[0].UID
        : vRdxWmsInvoiceHead.A_Loc
    );
    if (vSalesGroup?.Type?.toUpperCase() === "SUCCESS") {
      setSalesGroup(vSalesGroup.ResultSet);
    } else {
      fAlertToast("FAILED", vSalesGroup.Message);
    }
    let vDocLoadingObj = {
      VocTyp: "",
      VocName: "",
      Paymode: "",
    };
    const vDocLoading = iAttributeResp?.DocLoading;
    if (vDocLoading.length > 0) {
      vDocLoadingObj = vDocLoading[0];
      fDefaultPayload(
        vRdxWmsInvoiceHead.A_Curr == "" ||
          vRdxWmsInvoiceHead.A_Curr === null ||
          vRdxWmsInvoiceHead.A_Curr === undefined
          ? vDocLoading[0]?.Paymode
          : vRdxWmsInvoiceHead.A_PayMode,
        dispatch,
        setPaymodeEnable
      );

      let vSalesGroupObj = await fSalesGroup(
        vRdxWmsInvoiceHead.A_Loc == "" ||
          vRdxWmsInvoiceHead.A_Loc === null ||
          vRdxWmsInvoiceHead.A_Loc === undefined
          ? vRdxuserLoc[0].UID
          : vRdxWmsInvoiceHead.A_Loc
      );

      dispatch(
        Wms_Invoice_HeadObject_Set({
          ...vRdxWmsInvoiceHead,
          A_VocTyp:
            vRdxWmsInvoiceHead?.A_VocTyp == "" ||
            vRdxWmsInvoiceHead?.A_VocTyp === null ||
            vRdxWmsInvoiceHead?.A_VocTyp === undefined
              ? vDocLoadingObj.VocTyp
              : vRdxWmsInvoiceHead.A_VocTyp,
          A_VocTypName:
            vRdxWmsInvoiceHead?.A_VocTyp == "" ||
            vRdxWmsInvoiceHead?.A_VocTyp === null ||
            vRdxWmsInvoiceHead?.A_VocTyp === undefined
              ? vDocLoadingObj?.VocName
              : vRdxWmsInvoiceHead?.A_VocTypName,
          A_Loc:
            vRdxWmsInvoiceHead?.A_Loc == "" ||
            vRdxWmsInvoiceHead?.A_Loc === null ||
            vRdxWmsInvoiceHead?.A_Loc === undefined
              ? vRdxuserLoc[0]?.UID
              : vRdxWmsInvoiceHead?.A_Loc,
          A_Curr:
            vRdxWmsInvoiceHead?.A_Curr == "" ||
            vRdxWmsInvoiceHead?.A_Curr === null ||
            vRdxWmsInvoiceHead?.A_Curr === undefined
              ? CurrencyArr?.Uid
              : vRdxWmsInvoiceHead?.A_Curr,
          A_Currname:
            vRdxWmsInvoiceHead?.A_Curr == "" ||
            vRdxWmsInvoiceHead?.A_Curr === null ||
            vRdxWmsInvoiceHead?.A_Curr === undefined
              ? CurrencyArr?.Name1
              : vRdxWmsInvoiceHead?.A_Currname,
          A_ExRate:
            vRdxWmsInvoiceHead?.A_Curr == "" ||
            vRdxWmsInvoiceHead?.A_Curr === null ||
            vRdxWmsInvoiceHead?.A_Curr === undefined
              ? CurrencyArr?.Rate
              : vRdxWmsInvoiceHead?.A_ExRate,
          A_Type:
            vRdxWmsInvoiceHead?.A_Curr == "" ||
            vRdxWmsInvoiceHead?.A_Curr === null ||
            vRdxWmsInvoiceHead?.A_Curr === undefined
              ? vRdxPricelevel[0]
              : vRdxWmsInvoiceHead?.A_Type, //In this A_curr condition is checked bcoz on 1st  load A_type has def value
          A_Buyer:
            vRdxWmsInvoiceHead?.A_Buyer == "" ||
            vRdxWmsInvoiceHead?.A_Buyer === null ||
            vRdxWmsInvoiceHead?.A_Buyer === undefined
              ? SalesManId
              : vRdxWmsInvoiceHead?.A_Buyer,
          // A_CUSTFIELD2: SalesGroupId
          A_CUSTFIELD2:
            vRdxWmsInvoiceHead?.A_CUSTFIELD2 == "" ||
            vRdxWmsInvoiceHead?.A_CUSTFIELD2 === null ||
            vRdxWmsInvoiceHead?.A_CUSTFIELD2 === undefined
              ? vSalesGroupObj?.A_CUSTFIELD2
              : vRdxWmsInvoiceHead?.A_CUSTFIELD2,
          A_INV_TYPE:
            vRdxWmsInvoiceHead?.A_Curr == "" ||
            vRdxWmsInvoiceHead?.A_Curr === null ||
            vRdxWmsInvoiceHead?.A_Curr === undefined
              ? InvType
              : vRdxWmsInvoiceHead?.A_INV_TYPE, //In this A_curr condition is checked bcoz on 1st  load A_INV_TYPE has def value
          A_CUSTFIELD3:
            vRdxWmsInvoiceHead?.A_Curr == "" ||
            vRdxWmsInvoiceHead?.A_Curr === null ||
            vRdxWmsInvoiceHead?.A_Curr === undefined
              ? vDefaultTaxType
              : vRdxWmsInvoiceHead?.A_CUSTFIELD3,
          A_Party:
            vRdxWmsInvoiceHead?.A_Party == "" ||
            vRdxWmsInvoiceHead?.A_Party === null ||
            vRdxWmsInvoiceHead?.A_Party === undefined
              ? vDefaultPartyObj?.A_Party
              : vRdxWmsInvoiceHead?.A_Party,
          A_PartyName:
            vRdxWmsInvoiceHead?.A_Party == "" ||
            vRdxWmsInvoiceHead?.A_Party === null ||
            vRdxWmsInvoiceHead?.A_Party === undefined
              ? vDefaultPartyObj?.A_PartyName
              : vRdxWmsInvoiceHead?.A_PartyName,
        })
      );
      fLoad_Grid(
        vRdxWmsInvoiceHead?.A_VocNo,
        0,
        0,
        vRdxWmsInvoiceHead?.A_VocTyp == "" ||
          vRdxWmsInvoiceHead?.A_VocTyp === null ||
          vRdxWmsInvoiceHead?.A_VocTyp === undefined
          ? vDocLoadingObj?.VocTyp
          : vRdxWmsInvoiceHead?.A_VocTyp
      );
      GetDefcustomersetting(
        vRdxWmsInvoiceHead?.A_Party == "" ||
          vRdxWmsInvoiceHead?.A_Party === null ||
          vRdxWmsInvoiceHead?.A_Party === undefined
          ? vDefaultPartyObj?.A_Party
          : vRdxWmsInvoiceHead?.A_Party,
        vRdxWmsInvoiceHead?.A_Loc == "" ||
          vRdxWmsInvoiceHead?.A_Loc === null ||
          vRdxWmsInvoiceHead?.A_Loc === undefined
          ? vRdxuserLoc[0]?.UID
          : vRdxWmsInvoiceHead?.A_Loc
      );
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      } = fCalculate_Detail(
        0, //sBufferObj.B_Qty,
        0, //sBufferObj.B_PackQty,
        vRdxWmsInvoiceHead?.A_Curr == "" ||
          vRdxWmsInvoiceHead?.A_Curr === null ||
          vRdxWmsInvoiceHead?.A_Curr === undefined
          ? CurrencyArr?.Rate
          : vRdxWmsInvoiceHead?.A_ExRate, //exchangeRate
        0, //sBufferObj.B_URateFc,
        0, //sBufferObj.B_LDiscPerc,
        vRdxWmsInvoiceHead?.A_DiscPerc, //sBufferObj.B_TDiscPerc,
        "N", //sBufferObj.B_FocFlag,
        0, //sBufferObj.B_ExciseTaxAmt,
        vRdxGRNtax1[0]?.Perc, //tax1%
        vRdxGRNtax2[0]?.Perc, //tax%2
        0, //sBufferObj.B_Ad_PCRate,
        0 //Rounding
      );

      setBufferObj((obj) => ({
        ...obj,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
        B_TDiscPerc: vRdxWmsInvoiceHead?.A_DiscPerc,
      }));
      ItemsAliasListSearch(
        vRdxWmsInvoiceHead?.A_Loc == "" ||
          vRdxWmsInvoiceHead?.A_Loc === null ||
          vRdxWmsInvoiceHead?.A_Loc === undefined
          ? vRdxuserLoc[0]?.UID
          : vRdxWmsInvoiceHead?.A_Loc,
        sBufferObj?.B_Itmcd
      );
      setLoading(false);
    }
    GetItemNarration(
      sBufferObj?.B_Itmcd,
      vRdxWmsInvoiceHead?.A_Loc == "" ||
        vRdxWmsInvoiceHead?.A_Loc === null ||
        vRdxWmsInvoiceHead?.A_Loc === undefined
        ? vRdxuserLoc[0]?.UID
        : vRdxWmsInvoiceHead?.A_Loc
    );
    GetItemStock(
      sBufferObj.B_Itmcd,
      sBufferObj.B_Srno,
      vRdxWmsInvoiceHead?.A_Loc == "" ||
        vRdxWmsInvoiceHead?.A_Loc === null ||
        vRdxWmsInvoiceHead?.A_Loc === undefined
        ? vRdxuserLoc[0]?.UID
        : vRdxWmsInvoiceHead?.A_Loc,
      vRdxWmsInvoiceHead?.A_Curr == ""
        ? InvType
        : vRdxWmsInvoiceHead?.A_INV_TYPE,
      sBufferObj?.B_Unit
    );
    GetDefaultDrCrAccount(
      vRdxWmsInvoiceHead?.A_VocTyp == "" ||
        vRdxWmsInvoiceHead?.A_VocTyp === null ||
        vRdxWmsInvoiceHead?.A_VocTyp === undefined
        ? vDocLoadingObj?.VocTyp
        : vRdxWmsInvoiceHead?.A_VocTyp,
      vRdxWmsInvoiceHead?.A_Curr == "" ||
        vRdxWmsInvoiceHead?.A_Curr === null ||
        vRdxWmsInvoiceHead?.A_Curr === undefined
        ? sPayModeArr[0]
        : vRdxWmsInvoiceHead?.A_PayMode,
      vRdxWmsInvoiceHead?.A_Party == "" ||
        vRdxWmsInvoiceHead?.A_Party === null ||
        vRdxWmsInvoiceHead?.A_Party === undefined
        ? vDefaultPartyObj?.A_Party
        : vRdxWmsInvoiceHead?.A_Party
    );
  };

  useEffect(() => {
    fOnload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsInvoiceHead.A_DocStat,
      vRdxWmsInvoiceHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [
    vRdxWmsInvoiceHead.A_DocStat,
    vRdxWmsInvoiceHead.A_VocTyp,
    sObjectRights,
  ]);
  useEffect(() => {
    if (
      vRdxWmsInvoiceHead.A_DocStat !== "ENTER" ||
      vRdxWmsInvoiceHead.A_Loc === null ||
      vRdxWmsInvoiceHead.A_Loc === undefined ||
      vRdxWmsInvoiceHead.A_Loc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxWmsInvoiceHead.A_Loc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxWmsInvoiceHead.A_Loc,
    vRdxWmsInvoiceHead.A_DocStat,
  ]);
  useEffect(() => {
    RefNoFocusOnLoad?.current?.focus();
  }, []);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);
  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = vRdxWmsInvoiceHead.A_INV_TYPE == "Walk-In" ? "P" : "PF";
      FShortCutKey(
        e,
        "BtnNew",
        "BtnSave",
        "BtnApprove",
        "BtnSearch",
        "BtnDelete",
        "BtnAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint, vRdxWmsInvoiceHead.A_INV_TYPE]
  );
  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);
  // if ONE TOGGLE FUNCTION OPEN THEN OTHER TOGGLE WILL CLOSE

  useEffect(() => {
    if (ToggleDropdown === true) {
      setNarrationToggleDropdown(false);
      setCustomerToggleDropdown(false);
    }
  }, [ToggleDropdown]);

  useEffect(() => {
    if (sCustomerToggleDropdown === true) {
      setToggleDropdown(false);
      setNarrationToggleDropdown(false);
    }
  }, [sCustomerToggleDropdown]);

  useEffect(() => {
    if (sNarrationToggleDropdown === true) {
      setCustomerToggleDropdown(false);
      setToggleDropdown(false);
    }
  }, [sNarrationToggleDropdown]);

  useEffect(() => {
    GetOSAmount(
      vRdxWmsInvoiceHead.A_Loc,
      vRdxWmsInvoiceHead.A_Party,
      setOsAmount
    );
  }, [vRdxWmsInvoiceHead.A_Loc, vRdxWmsInvoiceHead.A_Party]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (ToggleDropdown) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          setToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ToggleDropdown]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sGCSearchBtn_Toggle_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGCSearchBtn_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sCustomerToggleDropdown) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          setCustomerToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sCustomerToggleDropdown]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sGCSearchBtn_Toggle_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGCSearchBtn_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sNarrationToggleDropdown) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          setNarrationToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sNarrationToggleDropdown]);

  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    {
      field: "B_Srno",
      headerName: "Sr.No",
      width: 50,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_Itmcd",
      headerName: "Item Code",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 300,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_Qty",
      headerName: "Qty",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "UnitName",
      headerName: "Unit",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_URateFc",
      headerName: "Unit Rate",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_GrossAmt",
      headerName: "Gross.Amt",
      width: 90,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_LDiscPerc",
      headerName: "L Disc %",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_LDiscAmt",
      headerName: "L Disc.Amt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_FocAmt",
      headerName: "Foc.Amt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_NetAmt",
      headerName: "Net.Amt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_ExciseTaxNetAmt",
      headerName: "B_ExciseTaxNetAmt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_TaxAmt",
      headerName: "B_TaxAmt1",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_ExciseTaxPerc",
      headerName: "B_ExciseTaxPerc",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_ExciseTaxAmt",
      headerName: "B_ExciseTaxAmt",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "SplDiscAmt1",
      headerName: "SplDiscAmt1",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_TaxDept",
      headerName: "B_TaxDept",
      width: 150,
      headerClassName: "grid-header-row",
    },

    {
      field: "B_Unit",
      headerName: "B_Unit",
      width: 100,
      hide: true,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_BaseQty",
      headerName: "B_BaseQty",
      width: 90,
      hide: true,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_URateLc",
      headerName: "B_URateLc",
      width: 90,
      hide: true,
      headerClassName: "grid-header-row",
    },

    { field: "B_TDiscPerc", headerName: "B_TDiscPerc", width: 90, hide: true },
    { field: "B_TDiscAmt", headerName: "B_TDiscAmt", width: 90, hide: true },
    { field: "B_FocFlag", headerName: "B_FocFlag", width: 90, hide: true },
    { field: "B_TaxPerc", headerName: "B_TaxPerc", width: 90, hide: true },
    { field: "B_Rounding", headerName: "B_Rounding", width: 90, hide: true },
    { field: "B_LandVal", headerName: "B_LandVal", width: 90, hide: true },
    { field: "B_RSP", headerName: "B_RSP", width: 90, hide: true },
    { field: "B_RefDocTyp", headerName: "B_RefDocTyp", width: 90, hide: true },
    { field: "RefVocName", headerName: "RefVocName", width: 90, hide: true },
    { field: "B_RefDocNo", headerName: "B_RefDocNo", width: 90, hide: true },
    { field: "B_BatchNo", headerName: "B_BatchNo", width: 90, hide: true },
    { field: "BatchCrl", headerName: "BatchCrl", width: 90, hide: true },
    { field: "DOFlag", headerName: "DOFlag", width: 90, hide: true },
    {
      field: "B_URate_Fixed",
      headerName: "B_URate_Fixed",
      width: 90,
      hide: true,
    },
    { field: "B_TaxDept2", headerName: "B_TaxDept2", width: 90, hide: true },
    { field: "B_TaxPerc2", headerName: "B_TaxPerc2", width: 90, hide: true },
    { field: "B_TaxAmt2", headerName: "B_TaxAmt2", width: 90, hide: true },
    { field: "B_IncGroup", headerName: "B_IncGroup", width: 100, hide: true },
    {
      field: "IncGroupName",
      headerName: "IncGroupName",
      width: 100,
      hide: true,
    },
    { field: "B_SuprvPerc", headerName: "B_SuprvPerc", width: 90, hide: true },
    {
      field: "B_OthersPerc",
      headerName: "B_OthersPerc",
      width: 90,
      hide: true,
    },
    { field: "B_SLANSuprv", headerName: "B_SLANSuprv", width: 90, hide: true },
    {
      field: "B_SlabAmtSuprv",
      headerName: "B_SlabAmtSuprv",
      width: 90,
      hide: true,
    },
    { field: "B_SLANOther", headerName: "B_SLANOther", width: 90, hide: true },
    {
      field: "B_SlabAmtOther",
      headerName: "B_SlabAmtOther",
      width: 90,
      hide: true,
    },
    { field: "Field8", headerName: "Field8", width: 90, hide: true },
  ]);
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "VocName", headerName: "Doc.Name", width: 250 },
    { field: "A_VocNo", headerName: "Doc.No", width: 150 },
    {
      field: "A_PostDt",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref.No", width: 90 },
    { field: "PartyName", headerName: "Vendor", width: 250 },
    { field: "LocName", headerName: "Location", width: 130 },
    { field: "A_NetAmt", headerName: "NetAmt", width: 90 },
    { field: "SalesGroup", headerName: "Sales Group", width: 130 },
    { field: "A_DocStat", headerName: "A_DocStat", width: 90, hide: true },
    { field: "A_VocTyp", headerName: "A_VocTyp", width: 90, hide: true },
  ]);

  const [GridDataColumnsVendorSearch, setGridDataColumnsVendorSearch] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "AcCd", headerName: "Code" },
      { field: "Name1", headerName: "Name", width: 350 },
    ]);
  const [GridDataColumnsSalesGroupModal, setGridDataColumnsSalesGroupModal] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "UId", headerName: "Code" },
      { field: "Srno", headerName: "SrNo", width: 90 },
      { field: "EMPID", headerName: "Employee ID", width: 120 },
      { field: "EMPNAME", headerName: "Employee Name", width: 350 },
      { field: "Typ", headerName: "Type", width: 100 },
      { field: "Active", headerName: "Active", width: 100 },
    ]);
  const [GridDataColumnsEmployeeModal, setGridDataColumnsEmployeeModal] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "SrNo", headerName: "SrNo", width: 50 },
      { field: "EMPID", headerName: "Employee ID", width: 120 },
      { field: "SName", headerName: "Name", width: 300 },
      { field: "FName", headerName: "First Name", width: 150, hide: true },
      { field: "LName", headerName: "Last Name", width: 180, hide: true },
      { field: "MName", headerName: "Middle Name", width: 100, hide: true },
      { field: "InActive", headerName: "InActive", width: 60 },
      { field: "JOBTITLE", headerName: "Job Title", width: 80 },
      { field: "Gender", headerName: "Gender", width: 60 },
      {
        field: "DOB",
        headerName: "DOB",
        width: 100,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      { field: "Country", headerName: "Country", width: 120 },
      { field: "Maritial", headerName: "Maritial", width: 60 },
      { field: "Mobile", headerName: "Mobile", width: 120 },
      { field: "Dept", headerName: "Dept", width: 50 },
      { field: "Br", headerName: "Br", width: 50 },
      { field: "Loc", headerName: "Loc", width: 50 },
      {
        field: "EmployementDt",
        headerName: "EmployementDt",
        width: 180,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      {
        field: "DOJ",
        headerName: "DOJ",
        width: 190,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      { field: "Phone", headerName: "Phone", width: 90 },
      { field: "EMail", headerName: "EMail", width: 150 },
      { field: "CompEMail", headerName: "CompEMail", width: 90 },
      { field: "CompPhone", headerName: "CompPhone", width: 90 },
      { field: "CompExt", headerName: "CompExt", width: 90 },
      { field: "CompMobile", headerName: "CompMobile", width: 120 },
      {
        field: "TerminationDt",
        headerName: "TerminationDt",
        width: 90,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
    ]);
  //Item Search
  const [xcolumnsDropdownSearch, setxcolumnsDropdownSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "Item Code", width: 100 },
    { field: "Name2", headerName: "Name", width: 450 },
    { field: "Barcode", headerName: "Barcode", width: 220 },
  ]);
  //Customer Search
  const [columnsCustomerDropdownSearch, setcolumnsCustomerDropdownSearch] =
    useState([
      { field: "id", headerName: "ID", width: 70, hide: true },
      { field: "AcCd", headerName: "Code", width: 90 },
      { field: "Name2", headerName: "Name2", width: 450 },
      { field: "Name1", headerName: "Name1", width: 450 },
    ]);
  //Narration Search
  const [columnsNarrationDropdownSearch, setcolumnsNarrationDropdownSearch] =
    useState([
      { field: "id", headerName: "ID", width: 70, hide: true },
      { field: "Code", headerName: "Code", width: 80, hide: true },
      { field: "Name", headerName: "Name1", width: 220 },
    ]);
  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);

  const [GridDataSalesHistoryColumns, setGridDataSalesHistoryColumns] =
    useState([
      { field: "id", headerName: "ID", width: 70, hide: true },
      { field: "A_VocNo", headerName: "Inv.N0", width: 130 },
      {
        field: "A_PostDt",
        headerName: "Date",
        width: 130,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      { field: "Unit", headerName: "Unit", width: 130 },
      { field: "GrossAmt", headerName: "GrossAmt", width: 130 },
      { field: "NetAmt", headerName: "NetAmt", width: 130 },
      { field: "Qty", headerName: "Qty", width: 130 },
    ]);

  const [
    xGCSearchBtn_Columns_DropdownSearch,
    setxGCSearchBtn_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name2", headerName: "Name2", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsWmsSiDetail,
      "WMS_SALES_INVOICE_DETAL",
      GridDataColumnsWmsSiDetail
    );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "WMS_SALES_INVOICE_SEARCH",
      GridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDataColumnsVendorSearch,
      "WMS_SALES_INVOICE_VENDOR",
      GridDataColumnsVendorSearch
    );
    GetGitterColumns(
      setGridDataColumnsSalesGroupModal,
      "WMS_SALES_INVOICE_SALES_GRP",
      GridDataColumnsSalesGroupModal
    );
    GetGitterColumns(
      setGridDataColumnsEmployeeModal,
      "WMS_SALES_INVOICE_SALES_GRP_EMP",
      GridDataColumnsEmployeeModal
    );
    GetGitterColumns(
      setxcolumnsDropdownSearch,
      "WMS_SALES_INVOICE_ITEM_SEARCH",
      xcolumnsDropdownSearch
    );
    GetGitterColumns(
      setcolumnsCustomerDropdownSearch,
      "WMS_SALES_INVOICE_CUST",
      columnsCustomerDropdownSearch
    );
    GetGitterColumns(
      setcolumnsNarrationDropdownSearch,
      "WMS_SALES_INVOICE_NARR",
      columnsNarrationDropdownSearch
    );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataSalesHistoryColumns,
      "WMS_SALES_INVOICE_HISTORY",
      GridDataSalesHistoryColumns
    );
    GetGitterColumns(
      setxGCSearchBtn_Columns_DropdownSearch,
      "WMS_SALES_INVOICE_GCSearchBtn",
      xGCSearchBtn_Columns_DropdownSearch
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    GetGitterColumns(
      setERPStockGridColumn,
      "ERPStockGridColumn",
      sERPStockGridColumn
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid">
      {/* mobile Screen nav  */}
      <GCNAV
        fNew={fNew}
        xDisableNew={sObjRights.RNew == "N"}
        fSave={fSave}
        xDisableSave={sObjRights.RSave == "N"}
        sRightClick={sRigntClick}
        xRightClick={(e) => {
          fLeftClick(e);
          setShowMore(false);
          setRigntClick(false);
          setTimeout(() => {
            document.getElementsByName("A_PostDt")[0]?.focus();
          }, 100);
        }}
        xLeftClick={(e) => {
          fRightClick(e);
          setShowMore(false);
          setRigntClick(true);
          setTimeout(() => {
            document.getElementsByName("B_ItmName")[0]?.focus();
          }, 100);
        }}
        setShowMore={setShowMore}
        sShowMore={sShowMore}
        fDelete={fDelete}
        xDisableDelete={
          vRdxWmsInvoiceHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
            ? false
            : sObjRights.RDelete == "N"
            ? true
            : false
        }
        isBtnDraft={sObjRights.RApprove == "N" && false}
        fDraft={() => {
          fApprove("DRAFT");
        }}
        xDisableDraft={vRdxWmsInvoiceHead.A_DocStat != "ENTER" ? true : false}
        fApprove={() => {
          fApprove("POST");
        }}
        xDisableApprove={
          vRdxWmsInvoiceHead.A_DocStat == "ENTER" ||
          vRdxWmsInvoiceHead.A_DocStat == "DRAFT"
            ? false
            : true
        }
        fView={() => {
          fOpenInvoiceSalesModal("detailView");
        }}
        fSummary={() => {
          fOpenInvoiceSalesModal("summary");
        }}
        fSearch={() => {
          fSearch();
        }}
      />
      <div style={{ paddingTop: vMediaQuery ? "50px" : "" }}>
        <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
            <div className="Wms-sales-invoice ">
              <Grid
                container
                spacing={0}
                className="my-2 Wms-nav-sm-hide"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center", justifyContent: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={(e) => fNew(0)}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N"}
                    xSize="small"
                    xId={"BtnNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N"}
                    xSize="small"
                    xId={"BtnSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  {sObjRights.RApprove == "N" && false ? (
                    <CmpButton
                      xbtnName="Draft"
                      xOnClick={() => {
                        fApprove("DRAFT");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsInvoiceHead.A_DocStat != "ENTER" ? true : false
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  ) : (
                    <CmpButton
                      xbtnName="Approve"
                      xOnClick={() => {
                        fApprove("POST");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsInvoiceHead.A_DocStat == "ENTER" ||
                        vRdxWmsInvoiceHead.A_DocStat == "DRAFT"
                          ? false
                          : true
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Search"
                    xOnClick={fSearch}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"BtnSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={
                      vRdxWmsInvoiceHead.A_DocStat == "ENTER" &&
                      sBufferObj.B_Srno > 0
                        ? false
                        : sObjRights.RDelete == "N"
                        ? true
                        : false
                    }
                    xSize="small"
                    xId="BtnDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="outlined"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      id="wmsSalesInvoicePrint"
                      onClick={(e) => {
                        fPrint("P");
                      }}
                    >
                      Sales
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("PF");
                      }}
                    >
                      Preformated
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("AR");
                      }}
                    >
                      Preformated Arabic
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("A5");
                      }}
                    >
                      A5
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Audit"
                    xOnClick={fAudit}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId="BtnAudit"
                    xSendIcon={<SendIcon />}
                  />
                </Grid>

                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      { label: "Link Document", onClick: fLinkDocument },
                    ]}
                  />
                </Grid>
              </Grid>

              <>
                <div id="wms-salese-invoice-id">
                  <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                    <GCHead
                      fOpenERPStockModal={fOpenERPStockModal}
                      xItemStock={sItemStock}
                      xposMode={vRdxWmsInvoicePosMode?.PosMode}
                      xPaymodeEnable={sPaymodeEnable}
                      xOsAmount={sOsAmount}
                      vRdxWmsInvoiceHead={vRdxWmsInvoiceHead}
                      vRdxuserLoc={vRdxuserLoc}
                      DocLoading={sDocLoading}
                      currency={sCurrency}
                      selecType={vRdxPricelevel}
                      sPayModeArr={sPayModeArr}
                      fOpenHeadCustomerSearchModalKey={
                        fOpenHeadCustomerSearchModalKey
                      }
                      fOnChangeSelectDocType={fOnChangeSelectDocType}
                      fOnChangeSelectCurr={fOnChangeSelectCurr}
                      fOnChangeInputDate={fOnChangeInputDate}
                      fOnChangeInputDateRefDate={fOnChangeInputDateRefDate}
                      fonChangeInput={fonChangeInput}
                      fonChangeInputTaxType={fonChangeInputTaxType}
                      fonChangeInputInvType={fonChangeInputInvType}
                      fonChangeInputPayMode={fonChangeInputPayMode}
                      fonChangeInputTaxable={fonChangeInputTaxable}
                      fonChangeInputPosMode={fonChangeInputPosMode}
                      fonChangeInputLocation={fonChangeInputLocation}
                      fonChangeInputCustomer={fonChangeInputCustomer}
                      sInstTypeArr={sInstTypeArr}
                      sErrorMsg={sErrorMsg}
                      sDetailGridData={sDetailGridData}
                      sToggleGrid={sToggleGrid}
                      GridDataSalesHistoryColumns={GridDataSalesHistoryColumns}
                      sGridSalesHistoryRowData={sGridSalesHistoryRowData}
                      vMediaQuery={vMediaQuery}
                      xcolumnsDropdownSearch={columnsCustomerDropdownSearch}
                      xrowDropdownSearch={sCustSearchGridData}
                      xOnCellKeyDown={fRowCellClick}
                      xOnRowClick={fRowClick}
                      xToggleDropdown={sCustomerToggleDropdown}
                      xData={sCustomerSearchData}
                      xOnChange={fOnChangeCustomer}
                      xDropdownObj={sCustomerSearchDropdownObj}
                      xOnKeyUp={fOnKeyUpCustomer}
                      xhandleClick={fOpenHeadCustomerSearchModalKey}
                      inputReference={RefNoFocusOnLoad}
                    />

                    <Button onClick={fOpenCustomerSearchModal}>hiiii</Button>
                  </div>
                  <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <div className="wms-incoice-sales-m">
                      <GCContent
                        sTransItemStockObj={sTransItemStockObj}
                        xTransItemStockShow={
                          vRdxuserInfo?.UserRights?.USRCUSTFIELD84?.toUpperCase() ==
                          "Y" //by muthu ji
                        }
                        fGrossAmt={fGrossAmt}
                        bufferObj={sBufferObj}
                        fonClickInputFocus={fContent_Focus}
                        fonClickInputBlur={fContent_Blur}
                        fonChangeInputQty={fonChangeInputQty}
                        fonChangeInputItemName={fonChangeInputItemName}
                        fonChangeInputUnit={fonChangeInputUnit}
                        fonChangeInputUnitRateFC={fonChangeInputUnitRateFC}
                        fUnitRateFCSave_onKeyUp={fUnitRateFCSave_onKeyUp}
                        fonChangeInputLDisc={fonChangeInputLDisc}
                        fonChangeInputLDiscAmt={fonChangeInputLDiscAmt}
                        fOpenContentItemSearchModalKey={
                          fOpenContentItemSearchModalKey
                        }
                        fOnChangeSelectTaxDept={fOnChangeSelectTaxDept}
                        fOnChangeSelectTaxDept2={fOnChangeSelectTaxDept2}
                        fOnChangeSelectIncGroup={fOnChangeSelectIncGroup}
                        fOnChangeSelectSupervisorSlab={
                          fOnChangeSelectSupervisorSlab
                        }
                        fOnChangeSelectOtherSlab={fOnChangeSelectOtherSlab}
                        fonChangeCheckBoxFoc={fonChangeCheckBoxFoc}
                        fonChangeInputExcise={fonChangeInputExcise}
                        fonChangeInputNarration={fonChangeInputNarration}
                        fonChangeInputSupervisorAmtSc={
                          fonChangeInputSupervisorAmtSc
                        }
                        fonChangeInputOtherAmtSc={fonChangeInputOtherAmtSc}
                        taxDept1={vRdxGRNtax1}
                        taxDept2={vRdxGRNtax2}
                        IncentiveGroups={sIncentiveGroups}
                        SupervisorSlabs={sSupervisorSlabs}
                        OtherSlabs={sOtherSlabs}
                        ItemUnit={sItemUnit}
                        sErrorMsgDetail={sErrorMsgDetail}
                        xNarrArr={sNarrArr}
                        vRdxWmsInvoiceHead={vRdxWmsInvoiceHead}
                        xItemStock={sItemStock}
                        //toggle item
                        xcolumnsDropdownSearch={xcolumnsDropdownSearch}
                        xrowDropdownSearch={sSearchGridData}
                        xOnCellKeyDown={fOnCellKeyDown}
                        xOnRowClick={fOnRowClick}
                        xToggleDropdown={ToggleDropdown}
                        xData={sItemSearchData}
                        xOnChange={fOnChangeItem}
                        xDropdownObj={sItemSearchDropdownObj}
                        xOnKeyUp={fOnKeyUpItem}
                        xhandleClick={fOpenContentItemSearchModalKey}
                        xMediaQuery={vMediaQuery}
                        //togggle narration
                        xNarrationToggleDropdown={sNarrationToggleDropdown}
                        xrowDropdownNarrationSearch={sNarrationSearchGridData}
                        xcolumnsDropdownNarrationSearch={
                          columnsNarrationDropdownSearch
                        }
                        xOnCellKeyNarrationDown={OnCellKeyNarrationDown}
                        xOnRowNarrationClick={OnRowNarrationClick}
                        fNarrationKeyEnter={fNarrationKeyEnter}
                        fFocusShowSalesHistoryGrid={fFocusShowSalesHistoryGrid}
                        xinputRef={ClickNewFocsItem}
                      />
                      {vMediaQuery && (
                        <DetailTblCard
                          data={sDetailGridData}
                          onClick={(item) => {
                            fonRowClickGridObj(item);
                          }}
                          fDelete={fDelete}
                          xDisableDelete={
                            vRdxWmsInvoiceHead.A_DocStat == "ENTER"
                              ? false
                              : sObjRights.RDelete == "N"
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                    <div className="wms-sales-content-grid xs-screen-hide">
                      <div
                        style={{
                          height: vMediaQuery ? "70vh" : "30vh",
                          width: "100%",
                        }}
                      >
                        <DataGrid
                          rowHeight={30}
                          headerHeight={40}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "mui-even-row"
                              : "mui-odd-row"
                          }
                          sx={{
                            border: 1,
                            borderColor: "primary.light",
                          }}
                          rows={sDetailGridData}
                          columns={GridDataColumnsWmsSiDetail}
                          onRowClick={fonRowClickGridObj}
                          hideFooter={sDetailGridData.length < 100}
                          // components={{
                          //   Toolbar: GridToolbar,
                          // }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <WmsSalesFooter
                      Salesman={sSalesman}
                      SalesGroup={sSalesGroup}
                      sFooterObj={sFooterObj}
                      fonChangeInputDiscount={fonChangeInputDiscount}
                      fonChangeRounding={fFooter_Rounding_OnChange}
                      fOpenDiscountPercentageModal={
                        fOpenDiscountPercentageModal
                      }
                      fOpenSalesGroupModal={fOpenSalesGroupModal}
                      fonClickInputFocusRounding={fFooter_Rounding_Focus}
                      fonClickInputBlurRounding={fFooter_Rounding_Blur}
                      sErrorMsg={sErrorMsg}
                      vRdxWmsInvoiceHead={vRdxWmsInvoiceHead}
                      fonChangeSelectSalesMan={fonChangeSelectSalesMan}
                      fonChangeSelectSalesGroup={fonChangeSelectSalesGroup}
                      fonClickInputBlurDiscount={fonClickInputBlurDiscount}
                      fonClickInputFocusDiscount={fonClickInputFocusDiscount}
                      fonChangeInputFooter={fonChangeInputFooter}
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>

      <>
        <Modal
          open={sInvoiceSalesModal}
          onClose={fCloseInvoiceSalesModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="model-Variance">
            <GCTitleSticky
              title={sOpenModalName === "detailView" ? "View" : "Summary"}
              onClose={fCloseInvoiceSalesModal}
            />

            <div>
              {sLoading ? (
                <div
                  style={{
                    height: "22rem",
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "1rem",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <>
                  {sOpenModalName === "detailView" ? (
                    <>
                      <div className="py-3">
                        <Box
                          style={{
                            height: vMediaQuery ? "70vh" : "30vh",
                            width: "100%",
                          }}
                        >
                          <DataGrid
                            rowHeight={30}
                            headerHeight={40}
                            getRowClassName={(params) =>
                              params.indexRelativeToCurrentPage % 2 === 0
                                ? "mui-even-row"
                                : "mui-odd-row"
                            }
                            sx={{
                              border: 1,
                              borderColor: "primary.light",
                            }}
                            getRowId={(row) => row.id}
                            rows={sDetailGridData}
                            columns={GridDataColumnsWmsSiDetail}
                            onRowClick={fonRowClickGridObj}
                            experimentalFeatures={{ newEditingApi: false }}
                            hideFooter={sDetailGridData.length < 100}
                          />
                        </Box>
                      </div>
                    </>
                  ) : sOpenModalName === "summary" ? (
                    <>
                      <div className="py-3">
                        <WmsSalesFooter
                          Salesman={sSalesman}
                          SalesGroup={sSalesGroup}
                          sFooterObj={sFooterObj}
                          fonChangeInputDiscount={fonChangeInputDiscount}
                          fonChangeRounding={fFooter_Rounding_OnChange}
                          fOpenDiscountPercentageModal={
                            fOpenDiscountPercentageModal
                          }
                          fOpenSalesGroupModal={fOpenSalesGroupModal}
                          fonClickInputFocusRounding={fFooter_Rounding_Focus}
                          fonClickInputBlurRounding={fFooter_Rounding_Blur}
                          sErrorMsg={sErrorMsg}
                          vRdxWmsInvoiceHead={vRdxWmsInvoiceHead}
                          fonChangeSelectSalesMan={fonChangeSelectSalesMan}
                          fonChangeSelectSalesGroup={fonChangeSelectSalesGroup}
                          fonClickInputBlurDiscount={fonClickInputBlurDiscount}
                          fonClickInputFocusDiscount={
                            fonClickInputFocusDiscount
                          }
                          fonChangeInputFooter={fonChangeInputFooter}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </Box>
        </Modal>
      </>
      <GCSearchBtn
        open={sSearchModal}
        xStatusArr={sStatusArr}
        // xLocationArr={vRdxuserLoc}
        xLocationArr={sSearchLoactionArr}
        xSalesGroup={sGCSeachSalesGroupSearch}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangePartyModal={fonChangePartyModal}
        fonChangeLocModal={fonChangeLocModal}
        fonChangeRefNoModal={fonChangeRefNoModal}
        fonChangeSalesGroupModal={fonChangeSalesGroupModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={fTrans_Search_Grid_KeyDown}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Sales Invoice - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
        xSalesGroupVal={sSearchModalObj.SalesGroup}
        xPartyVal={sSearchModalObj.Party}
        xPartyNameVal={sSearchModalObj.PartyName}
        //new Search lookUp
        xfGCSearchBtn_Name={xfGCSearchBtn_Name}
        xGCSearchBtn_Toggle={sGCSearchBtn_Toggle_ToggleDropDowm}
        xGCSearchBtn_onKeyUp={fGCSearchBtn_onKeyUp_onKeyUp}
        xGCSearchBtn_SearchDropdownObj={
          sGCSearchBtn_SearchDropdownObj_SearchDropdownObj
        }
        xGCSearchBtn_Dropdown_onChange={xGCSearchBtn_Dropdown_onChange}
        xGCSearchBtn_Dropdown_OnKeyUp_Load={fGCSearchBtn__Dropdown_OnKeyUp_Load}
        xGCSearchBtn_Columns_DropdownSearch={
          xGCSearchBtn_Columns_DropdownSearch
        }
        xGCSearchBtn_GridData={sGCSearchBtn_GridData}
        xfGCSearchBtn_OnRowClick={fGCSearchBtn_OnRowClick}
        xfGCSearchBtn_OnCellKeyDown={fGCSearchBtn_OnCellKeyDown}
      />
      <GCDiscountPercentage
        sDiscountPercentageModal={sDiscountPercentageModal}
        fCloseDiscountPercentageModal={fCloseDiscountPercentageModal}
        xGrossAmount={sFooterObj.A_GrossAmt}
        xLDiscAmount={sFooterObj.A_LDiscAmt}
        xTDiscAmount={sDiscPerModelObj.A_TDiscAmt}
        xTDiscPer={sDiscPerModelObj.A_DiscPerc}
        fonChangeInputDiscountModal={fonChangeInputDiscountModal}
        fOnChangeTDiscAmtModal={fOnChangeTDiscAmtModal}
        GetApplyTDiscount={GetApplyTDiscount}
        xErrorMsg_DiscPerc={sErrorMsgDiscountModal.A_DiscPerc}
        xErrorMsg_TDiscAmt={sErrorMsgDiscountModal.A_TDiscAmt}
        xRdx_DocStatus={vRdxWmsInvoiceHead.A_DocStat !== "ENTER"}
      />
      <GCVanMaster
        open={sSalesGroupModal}
        xDocStatus={vRdxWmsInvoiceHead.A_DocStat == "POST"}
        xVocNo={vRdxWmsInvoiceHead.A_VocNo}
        xVocType={vRdxWmsInvoiceHead.A_VocTyp}
        xVocTypeName={vRdxWmsInvoiceHead.A_VocTypName}
        fCloseSalesGroupModal={fCloseSalesGroupModal}
        xSalesGroup={sSalesGroup}
        xSaleGroupTypeArr={sSaleGroupTypeArr}
        xVanMasterModalObj={sSalesGroupModalObj}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xGetVanMasterSearchEnter={fGetVanMasterSearchEnter}
        xfOnVanMasterSrNoModal={fOnVanMasterSrNoModal}
        xfOnVanMasterEmployeeModal={fOnVanMasterEmployeeModal}
        xfOnVanMasterActiveModal={fOnVanMasterActiveModal}
        xfNewSaleGroup={fNewSaleGroupModal}
        xfSaveSaleGroup={fSaveSaleGroupModal}
        xfDeleteSaleGroup={fDeleteSaleGroupModal}
        xfOnVanMasterTypModal={fOnVanMasterTypModal}
        xrows={sSalesGroupModalArr}
        xcolumns={GridDataColumnsSalesGroupModal}
        xRowClick={fVanMasterRowClick}
        xRowCellClick={fVanMasterRowCellClick}
        xErrorMsg={sErrorMsgVanMaster}
      />
      <GCSimpleSearch
        open={sCustomerSearchModal}
        xCloseSearchModal={fCloseCustomerSearchModal}
        xTitle={"Customer"}
        xAnyData={vRdxWmsInvoiceHead.A_PartyName}
        xModelObj={sCustomerModelObj}
        xSearchEnter={fHeaderSearchEnter}
        xonChangeInputModal={fonChangeInputCustomerModal}
        xGridArr={sHeaderSearchResultArr}
        xGridDataColumnsSearch={GridDataColumnsVendorSearch}
        xRowClick={fRowClick}
        xClearSimpleSearch={fClearSimpleSearch}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
      />
      {/* Reverse Narration  */}
      <GCReverse
        open={sReverseTransactionModal}
        fCloseReverseTransactionModal={fCloseReverseTransactionModal}
        sRevNarr={sRevNarr}
        setRevNarr={setRevNarr}
        fReverse={fReverse}
      />

      <GCAuditTblCard
        xOpen={!!sSalesGroupEmployeeModal ? true : sAuditModal}
        xLabel={
          vRdxWmsInvoiceHead.A_VocTypName + "-" + vRdxWmsInvoiceHead.A_VocNo
        }
        fCloseAuditModal={setAuditModal}
        trnTyp={sTrnTyp}
        vocTyp={vRdxWmsInvoiceHead.A_VocTyp}
        vocNo={vRdxWmsInvoiceHead.A_VocNo}
      />
      {/* //Employee modal  */}
      <GCEmployee
        open={sSalesGroupEmployeeModal}
        xCloseSearchModal={fCloseSalesGroupEmployeeModal}
        xTitle={"Employee"}
        xAnyData={""}
        xModelObj={sSalesGroupEmployeeModelObj}
        xSearchEnter={fEmployeeSearchEnter}
        xonChangeInputModal={fonChangeInputEmployeeModal}
        xGridArr={sEmployeeSearchResultArr}
        xGridDataColumnsSearch={GridDataColumnsEmployeeModal}
        xRowClick={fEmployeeRowClick}
        xRowCellClick={fEmployeeRowCellClick}
        xClearSimpleSearch={fClearEmployeeSearch}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
      />
      <Modal
        open={sERPStockModal}
        onClose={fCloseERPStockModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-ERP-Stock">
          <div>
            <GCTitleSticky
              title={"Stock Detail"}
              onClose={fCloseERPStockModal}
            />

            <div className="py-3">
              <Box
                style={{ height: vMediaQuery ? "40vh" : "40vh", width: "99%" }}
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sERPStockGridRow}
                  columns={sERPStockGridColumn}
                  hideFooter={sERPStockGridRow.length < 100}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                />
              </Box>
            </div>
          </div>
        </Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsInvoiceHead.A_VocTyp}
        xLabelVocName={vRdxWmsInvoiceHead.A_VocTypName}
        xLabelVocNo={vRdxWmsInvoiceHead.A_VocNo}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsInvoiceHead.A_VocTyp}
        xLabelVocName={vRdxWmsInvoiceHead.A_VocTypName}
        xLabelVocNo={vRdxWmsInvoiceHead.A_VocNo}
      />
    </div>
  );
}
